var province = [
    {
        "label": "不限",
        "value": "不限"
    },
    {
        "value": "北京市",
        "label": "北京",
        "children": [
            {
                "label": "不限",
                "value": "不限"
            },
            {
                "value": "北京市",
                "label": "北京",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "朝阳",
                        "value": "朝阳区"
                    },
                    {
                        "label": "海淀",
                        "value": "海淀区"
                    },
                    {
                        "label": "丰台",
                        "value": "丰台区"
                    },
                    {
                        "label": "通州",
                        "value": "通州区"
                    },
                    {
                        "label": "房山",
                        "value": "房山区"
                    },
                    {
                        "label": "大兴",
                        "value": "大兴区"
                    },
                    {
                        "label": "昌平",
                        "value": "昌平区"
                    },
                    {
                        "label": "怀柔",
                        "value": "怀柔区"
                    },
                    {
                        "label": "顺义",
                        "value": "顺义区"
                    },
                    {
                        "label": "东城",
                        "value": "东城区"
                    },
                    {
                        "label": "西城",
                        "value": "西城区"
                    },
                    {
                        "label": "密云",
                        "value": "密云区"
                    },
                    {
                        "label": "平谷",
                        "value": "平谷区"
                    },
                    {
                        "label": "石景山",
                        "value": "石景山区"
                    },
                    {
                        "label": "门头沟",
                        "value": "门头沟区"
                    },
                    {
                        "label": "延庆",
                        "value": "延庆区"
                    }
                ]
            }
        ]
    },
    {
        "value": "上海市",
        "label": "上海",
        "children": [
            {
                "label": "不限",
                "value": "不限"
            },
            {
                "value": "上海市",
                "label": "上海",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "浦东",
                        "value": "浦东新区"
                    },
                    {
                        "label": "徐汇",
                        "value": "徐汇区"
                    },
                    {
                        "label": "黄浦",
                        "value": "黄浦区"
                    },
                    {
                        "label": "闵行",
                        "value": "闵行区"
                    },
                    {
                        "label": "杨浦",
                        "value": "杨浦区"
                    },
                    {
                        "label": "静安",
                        "value": "静安区"
                    },
                    {
                        "label": "奉贤",
                        "value": "奉贤区"
                    },
                    {
                        "label": "金山",
                        "value": "金山区"
                    },
                    {
                        "label": "嘉定",
                        "value": "嘉定区"
                    },
                    {
                        "label": "宝山",
                        "value": "宝山区"
                    },
                    {
                        "label": "青浦",
                        "value": "青浦区"
                    },
                    {
                        "label": "松江",
                        "value": "松江区"
                    },
                    {
                        "label": "普陀",
                        "value": "普陀区"
                    },
                    {
                        "label": "虹口",
                        "value": "虹口区"
                    },
                    {
                        "label": "长宁",
                        "value": "长宁区"
                    },
                    {
                        "label": "崇明",
                        "value": "崇明区"
                    },
                    {
                        "label": "上海",
                        "value": "上海市"
                    }
                ]
            }
        ]
    },
    {
        "value": "广东省",
        "label": "广东",
        "children": [
            {
                "label": "不限",
                "value": "不限"
            },
            {
                "value": "广州市",
                "label": "广州",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "天河",
                        "value": "天河区"
                    },
                    {
                        "label": "白云",
                        "value": "白云区"
                    },
                    {
                        "label": "番禺",
                        "value": "番禺区"
                    },
                    {
                        "label": "越秀",
                        "value": "越秀区"
                    },
                    {
                        "label": "南沙",
                        "value": "南沙区"
                    },
                    {
                        "label": "海珠",
                        "value": "海珠区"
                    },
                    {
                        "label": "黄埔",
                        "value": "黄埔区"
                    },
                    {
                        "label": "花都",
                        "value": "花都区"
                    },
                    {
                        "label": "增城",
                        "value": "增城区"
                    },
                    {
                        "label": "荔湾",
                        "value": "荔湾区"
                    },
                    {
                        "label": "从化",
                        "value": "从化区"
                    },
                    {
                        "label": "广州",
                        "value": "广州市"
                    }
                ]
            },
            {
                "value": "深圳市",
                "label": "深圳",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "宝安",
                        "value": "宝安区"
                    },
                    {
                        "label": "南山",
                        "value": "南山区"
                    },
                    {
                        "label": "龙岗",
                        "value": "龙岗区"
                    },
                    {
                        "label": "福田",
                        "value": "福田区"
                    },
                    {
                        "label": "龙华",
                        "value": "龙华区"
                    },
                    {
                        "label": "罗湖",
                        "value": "罗湖区"
                    },
                    {
                        "label": "坪山",
                        "value": "坪山区"
                    },
                    {
                        "label": "盐田",
                        "value": "盐田区"
                    },
                    {
                        "label": "深圳",
                        "value": "深圳市"
                    }
                ]
            },
            {
                "value": "东莞市",
                "label": "东莞",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "东莞",
                        "value": "东莞市"
                    }
                ]
            },
            {
                "value": "佛山市",
                "label": "佛山",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "顺德",
                        "value": "顺德区"
                    },
                    {
                        "label": "南海",
                        "value": "南海区"
                    },
                    {
                        "label": "禅城",
                        "value": "禅城区"
                    },
                    {
                        "label": "三水",
                        "value": "三水区"
                    },
                    {
                        "label": "高明",
                        "value": "高明区"
                    },
                    {
                        "label": "佛山",
                        "value": "佛山市"
                    }
                ]
            },
            {
                "value": "惠州市",
                "label": "惠州",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "惠城",
                        "value": "惠城区"
                    },
                    {
                        "label": "惠阳",
                        "value": "惠阳区"
                    },
                    {
                        "label": "博罗",
                        "value": "博罗县"
                    },
                    {
                        "label": "惠东",
                        "value": "惠东县"
                    },
                    {
                        "label": "龙门",
                        "value": "龙门县"
                    },
                    {
                        "label": "惠州",
                        "value": "惠州市"
                    }
                ]
            },
            {
                "value": "珠海市",
                "label": "珠海",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "香洲",
                        "value": "香洲区"
                    },
                    {
                        "label": "斗门",
                        "value": "斗门区"
                    },
                    {
                        "label": "金湾",
                        "value": "金湾区"
                    },
                    {
                        "label": "珠海",
                        "value": "珠海市"
                    }
                ]
            },
            {
                "value": "中山市",
                "label": "中山",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "中山",
                        "value": "中山市"
                    }
                ]
            },
            {
                "value": "江门市",
                "label": "江门",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "蓬江",
                        "value": "蓬江区"
                    },
                    {
                        "label": "新会",
                        "value": "新会区"
                    },
                    {
                        "label": "江海",
                        "value": "江海区"
                    },
                    {
                        "label": "鹤山",
                        "value": "鹤山市"
                    },
                    {
                        "label": "开平",
                        "value": "开平市"
                    },
                    {
                        "label": "台山",
                        "value": "台山市"
                    },
                    {
                        "label": "恩平",
                        "value": "恩平市"
                    },
                    {
                        "label": "江门",
                        "value": "江门市"
                    }
                ]
            },
            {
                "value": "汕头市",
                "label": "汕头",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "龙湖",
                        "value": "龙湖区"
                    },
                    {
                        "label": "金平",
                        "value": "金平区"
                    },
                    {
                        "label": "澄海",
                        "value": "澄海区"
                    },
                    {
                        "label": "潮阳",
                        "value": "潮阳区"
                    },
                    {
                        "label": "潮南",
                        "value": "潮南区"
                    },
                    {
                        "label": "濠江",
                        "value": "濠江区"
                    },
                    {
                        "label": "南澳",
                        "value": "南澳县"
                    },
                    {
                        "label": "汕头",
                        "value": "汕头市"
                    }
                ]
            },
            {
                "value": "湛江市",
                "label": "湛江",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "霞山",
                        "value": "霞山区"
                    },
                    {
                        "label": "赤坎",
                        "value": "赤坎区"
                    },
                    {
                        "label": "廉江",
                        "value": "廉江市"
                    },
                    {
                        "label": "雷州",
                        "value": "雷州市"
                    },
                    {
                        "label": "吴川",
                        "value": "吴川市"
                    },
                    {
                        "label": "徐闻",
                        "value": "徐闻县"
                    },
                    {
                        "label": "遂溪",
                        "value": "遂溪县"
                    },
                    {
                        "label": "麻章",
                        "value": "麻章区"
                    },
                    {
                        "label": "坡头",
                        "value": "坡头区"
                    },
                    {
                        "label": "湛江",
                        "value": "湛江市"
                    }
                ]
            },
            {
                "value": "茂名市",
                "label": "茂名",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "茂南",
                        "value": "茂南区"
                    },
                    {
                        "label": "电白",
                        "value": "电白区"
                    },
                    {
                        "label": "高州",
                        "value": "高州市"
                    },
                    {
                        "label": "化州",
                        "value": "化州市"
                    },
                    {
                        "label": "信宜",
                        "value": "信宜市"
                    },
                    {
                        "label": "茂名",
                        "value": "茂名市"
                    }
                ]
            },
            {
                "value": "清远市",
                "label": "清远",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "清城",
                        "value": "清城区"
                    },
                    {
                        "label": "英德",
                        "value": "英德市"
                    },
                    {
                        "label": "清新",
                        "value": "清新区"
                    },
                    {
                        "label": "连州",
                        "value": "连州市"
                    },
                    {
                        "label": "佛冈",
                        "value": "佛冈县"
                    },
                    {
                        "label": "阳山",
                        "value": "阳山县"
                    },
                    {
                        "label": "连南",
                        "value": "连南瑶族自治县"
                    },
                    {
                        "label": "连山",
                        "value": "连山壮族瑶族自治县"
                    },
                    {
                        "label": "清远",
                        "value": "清远市"
                    }
                ]
            },
            {
                "value": "梅州市",
                "label": "梅州",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "梅江",
                        "value": "梅江区"
                    },
                    {
                        "label": "梅县",
                        "value": "梅县区"
                    },
                    {
                        "label": "兴宁",
                        "value": "兴宁市"
                    },
                    {
                        "label": "五华",
                        "value": "五华县"
                    },
                    {
                        "label": "大埔",
                        "value": "大埔县"
                    },
                    {
                        "label": "平远",
                        "value": "平远县"
                    },
                    {
                        "label": "丰顺",
                        "value": "丰顺县"
                    },
                    {
                        "label": "蕉岭",
                        "value": "蕉岭县"
                    },
                    {
                        "label": "梅州",
                        "value": "梅州市"
                    }
                ]
            },
            {
                "value": "肇庆市",
                "label": "肇庆",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "端州",
                        "value": "端州区"
                    },
                    {
                        "label": "四会",
                        "value": "四会市"
                    },
                    {
                        "label": "高要",
                        "value": "高要区"
                    },
                    {
                        "label": "怀集",
                        "value": "怀集县"
                    },
                    {
                        "label": "广宁",
                        "value": "广宁县"
                    },
                    {
                        "label": "鼎湖",
                        "value": "鼎湖区"
                    },
                    {
                        "label": "德庆",
                        "value": "德庆县"
                    },
                    {
                        "label": "封开",
                        "value": "封开县"
                    },
                    {
                        "label": "肇庆",
                        "value": "肇庆市"
                    }
                ]
            },
            {
                "value": "河源市",
                "label": "河源",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "源城",
                        "value": "源城区"
                    },
                    {
                        "label": "紫金",
                        "value": "紫金县"
                    },
                    {
                        "label": "东源",
                        "value": "东源县"
                    },
                    {
                        "label": "龙川",
                        "value": "龙川县"
                    },
                    {
                        "label": "和平",
                        "value": "和平县"
                    },
                    {
                        "label": "连平",
                        "value": "连平县"
                    },
                    {
                        "label": "河源",
                        "value": "河源市"
                    }
                ]
            },
            {
                "value": "汕尾市",
                "label": "汕尾",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "陆丰",
                        "value": "陆丰市"
                    },
                    {
                        "label": "海丰",
                        "value": "海丰县"
                    },
                    {
                        "label": "城区",
                        "value": "城区"
                    },
                    {
                        "label": "陆河",
                        "value": "陆河县"
                    },
                    {
                        "label": "汕尾",
                        "value": "汕尾市"
                    }
                ]
            },
            {
                "value": "揭阳市",
                "label": "揭阳",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "榕城",
                        "value": "榕城区"
                    },
                    {
                        "label": "普宁",
                        "value": "普宁市"
                    },
                    {
                        "label": "揭东",
                        "value": "揭东区"
                    },
                    {
                        "label": "惠来",
                        "value": "惠来县"
                    },
                    {
                        "label": "揭西",
                        "value": "揭西县"
                    },
                    {
                        "label": "揭阳",
                        "value": "揭阳市"
                    }
                ]
            },
            {
                "value": "韶关市",
                "label": "韶关",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "浈江",
                        "value": "浈江区"
                    },
                    {
                        "label": "武江",
                        "value": "武江区"
                    },
                    {
                        "label": "乐昌",
                        "value": "乐昌市"
                    },
                    {
                        "label": "曲江",
                        "value": "曲江区"
                    },
                    {
                        "label": "南雄",
                        "value": "南雄市"
                    },
                    {
                        "label": "翁源",
                        "value": "翁源县"
                    },
                    {
                        "label": "乳源",
                        "value": "乳源瑶族自治县"
                    },
                    {
                        "label": "始兴",
                        "value": "始兴县"
                    },
                    {
                        "label": "新丰",
                        "value": "新丰县"
                    },
                    {
                        "label": "仁化",
                        "value": "仁化县"
                    },
                    {
                        "label": "韶关",
                        "value": "韶关市"
                    }
                ]
            },
            {
                "value": "阳江市",
                "label": "阳江",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "江城",
                        "value": "江城区"
                    },
                    {
                        "label": "阳东",
                        "value": "阳东区"
                    },
                    {
                        "label": "阳春",
                        "value": "阳春市"
                    },
                    {
                        "label": "阳西",
                        "value": "阳西县"
                    },
                    {
                        "label": "阳江",
                        "value": "阳江市"
                    }
                ]
            },
            {
                "value": "潮州市",
                "label": "潮州",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "潮安",
                        "value": "潮安区"
                    },
                    {
                        "label": "湘桥",
                        "value": "湘桥区"
                    },
                    {
                        "label": "饶平",
                        "value": "饶平县"
                    },
                    {
                        "label": "潮州",
                        "value": "潮州市"
                    }
                ]
            },
            {
                "value": "云浮市",
                "label": "云浮",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "云城",
                        "value": "云城区"
                    },
                    {
                        "label": "罗定",
                        "value": "罗定市"
                    },
                    {
                        "label": "新兴",
                        "value": "新兴县"
                    },
                    {
                        "label": "郁南",
                        "value": "郁南县"
                    },
                    {
                        "label": "云安",
                        "value": "云安区"
                    }
                ]
            },
            {
                "value": "广东省",
                "label": "广东",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "广东",
                        "value": "广东省"
                    }
                ]
            }
        ]
    },
    {
        "value": "江苏省",
        "label": "江苏",
        "children": [
            {
                "label": "不限",
                "value": "不限"
            },
            {
                "value": "南京市",
                "label": "南京",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "秦淮",
                        "value": "秦淮区"
                    },
                    {
                        "label": "建邺",
                        "value": "建邺区"
                    },
                    {
                        "label": "江宁",
                        "value": "江宁区"
                    },
                    {
                        "label": "鼓楼",
                        "value": "鼓楼区"
                    },
                    {
                        "label": "浦口",
                        "value": "浦口区"
                    },
                    {
                        "label": "栖霞",
                        "value": "栖霞区"
                    },
                    {
                        "label": "六合",
                        "value": "六合区"
                    },
                    {
                        "label": "玄武",
                        "value": "玄武区"
                    },
                    {
                        "label": "雨花台",
                        "value": "雨花台区"
                    },
                    {
                        "label": "高淳",
                        "value": "高淳区"
                    },
                    {
                        "label": "溧水",
                        "value": "溧水区"
                    },
                    {
                        "label": "南京",
                        "value": "南京市"
                    }
                ]
            },
            {
                "value": "苏州市",
                "label": "苏州",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "姑苏",
                        "value": "姑苏区"
                    },
                    {
                        "label": "相城",
                        "value": "相城区"
                    },
                    {
                        "label": "吴中",
                        "value": "吴中区"
                    },
                    {
                        "label": "虎丘",
                        "value": "虎丘区"
                    },
                    {
                        "label": "吴江",
                        "value": "吴江区"
                    },
                    {
                        "label": "昆山",
                        "value": "昆山市"
                    },
                    {
                        "label": "常熟",
                        "value": "常熟市"
                    },
                    {
                        "label": "张家港",
                        "value": "张家港市"
                    },
                    {
                        "label": "太仓",
                        "value": "太仓市"
                    },
                    {
                        "label": "苏州",
                        "value": "苏州市"
                    }
                ]
            },
            {
                "value": "无锡市",
                "label": "无锡",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "江阴",
                        "value": "江阴市"
                    },
                    {
                        "label": "梁溪",
                        "value": "梁溪区"
                    },
                    {
                        "label": "宜兴",
                        "value": "宜兴市"
                    },
                    {
                        "label": "滨湖",
                        "value": "滨湖区"
                    },
                    {
                        "label": "惠山",
                        "value": "惠山区"
                    },
                    {
                        "label": "新吴",
                        "value": "新吴区"
                    },
                    {
                        "label": "锡山",
                        "value": "锡山区"
                    },
                    {
                        "label": "无锡",
                        "value": "无锡市"
                    }
                ]
            },
            {
                "value": "南通市",
                "label": "南通",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "崇川",
                        "value": "崇川区"
                    },
                    {
                        "label": "如皋",
                        "value": "如皋市"
                    },
                    {
                        "label": "通州",
                        "value": "通州区"
                    },
                    {
                        "label": "海安",
                        "value": "海安县"
                    },
                    {
                        "label": "港闸",
                        "value": "港闸区"
                    },
                    {
                        "label": "如东",
                        "value": "如东县"
                    },
                    {
                        "label": "启东",
                        "value": "启东市"
                    },
                    {
                        "label": "海门",
                        "value": "海门市"
                    },
                    {
                        "label": "南通",
                        "value": "南通市"
                    }
                ]
            },
            {
                "value": "徐州市",
                "label": "徐州",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "泉山",
                        "value": "泉山区"
                    },
                    {
                        "label": "铜山",
                        "value": "铜山区"
                    },
                    {
                        "label": "鼓楼",
                        "value": "鼓楼区"
                    },
                    {
                        "label": "贾汪",
                        "value": "贾汪区"
                    },
                    {
                        "label": "云龙",
                        "value": "云龙区"
                    },
                    {
                        "label": "新沂",
                        "value": "新沂市"
                    },
                    {
                        "label": "睢宁",
                        "value": "睢宁县"
                    },
                    {
                        "label": "邳州",
                        "value": "邳州市"
                    },
                    {
                        "label": "沛县",
                        "value": "沛县"
                    },
                    {
                        "label": "丰县",
                        "value": "丰县"
                    },
                    {
                        "label": "徐州",
                        "value": "徐州市"
                    }
                ]
            },
            {
                "value": "盐城市",
                "label": "盐城",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "亭湖",
                        "value": "亭湖区"
                    },
                    {
                        "label": "盐都",
                        "value": "盐都区"
                    },
                    {
                        "label": "大丰",
                        "value": "大丰区"
                    },
                    {
                        "label": "东台",
                        "value": "东台市"
                    },
                    {
                        "label": "大丰",
                        "value": "大丰市"
                    },
                    {
                        "label": "阜宁",
                        "value": "阜宁县"
                    },
                    {
                        "label": "建湖",
                        "value": "建湖县"
                    },
                    {
                        "label": "滨海",
                        "value": "滨海县"
                    },
                    {
                        "label": "响水",
                        "value": "响水县"
                    },
                    {
                        "label": "射阳",
                        "value": "射阳县"
                    },
                    {
                        "label": "盐城",
                        "value": "盐城市"
                    }
                ]
            },
            {
                "value": "常州市",
                "label": "常州",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "武进",
                        "value": "武进区"
                    },
                    {
                        "label": "新北",
                        "value": "新北区"
                    },
                    {
                        "label": "天宁",
                        "value": "天宁区"
                    },
                    {
                        "label": "钟楼",
                        "value": "钟楼区"
                    },
                    {
                        "label": "溧阳",
                        "value": "溧阳市"
                    },
                    {
                        "label": "金坛",
                        "value": "金坛区"
                    },
                    {
                        "label": "金坛",
                        "value": "金坛市"
                    }, 
                    {
                        "label": "常州",
                        "value": "常州市"
                    }
                ]
            },
            {
                "value": "扬州市",
                "label": "扬州",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "邗江",
                        "value": "邗江区"
                    },
                    {
                        "label": "广陵",
                        "value": "广陵区"
                    },
                    {
                        "label": "江都",
                        "value": "江都区"
                    },
                    {
                        "label": "高邮",
                        "value": "高邮市"
                    },
                    {
                        "label": "仪征",
                        "value": "仪征市"
                    },
                    {
                        "label": "宝应",
                        "value": "宝应县"
                    },
                    {
                        "label": "扬州",
                        "value": "扬州市"
                    }
                ]
            },
            {
                "value": "泰州市",
                "label": "泰州",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "泰兴",
                        "value": "泰兴市"
                    },
                    {
                        "label": "海陵",
                        "value": "海陵区"
                    },
                    {
                        "label": "兴化",
                        "value": "兴化市"
                    },
                    {
                        "label": "靖江",
                        "value": "靖江市"
                    },
                    {
                        "label": "姜堰",
                        "value": "姜堰区"
                    },
                    {
                        "label": "高港",
                        "value": "高港区"
                    },
                    {
                        "label": "泰州",
                        "value": "泰州市"
                    }
                ]
            },
            {
                "value": "宿迁市",
                "label": "宿迁",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "宿城",
                        "value": "宿城区"
                    },
                    {
                        "label": "宿豫",
                        "value": "宿豫区"
                    },
                    {
                        "label": "沭阳",
                        "value": "沭阳县"
                    },
                    {
                        "label": "泗洪",
                        "value": "泗洪县"
                    },
                    {
                        "label": "泗阳",
                        "value": "泗阳县"
                    },
                    {
                        "label": "宿迁",
                        "value": "宿迁市"
                    }
                ]
            },
            {
                "value": "淮安市",
                "label": "淮安",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "淮阴",
                        "value": "淮阴区"
                    },
                    {
                        "label": "淮安",
                        "value": "淮安区"
                    },
                    {
                        "label": "清河",
                        "value": "清河区"
                    },
                    {
                        "label": "清江浦",
                        "value": "清江浦区"
                    },
                    {
                        "label": "洪泽",
                        "value": "洪泽区"
                    },
                    {
                        "label": "清浦",
                        "value": "清浦区"
                    },
                    {
                        "label": "涟水",
                        "value": "涟水县"
                    },
                    {
                        "label": "盱眙",
                        "value": "盱眙县"
                    },
                    {
                        "label": "金湖",
                        "value": "金湖县"
                    },
                    {
                        "label": "洪泽",
                        "value": "洪泽县"
                    },
                    {
                        "label": "淮安",
                        "value": "淮安市"
                    }
                ]
            },
            {
                "value": "连云港市",
                "label": "连云港",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "海州",
                        "value": "海州区"
                    },
                    {
                        "label": "赣榆",
                        "value": "赣榆区"
                    },
                    {
                        "label": "连云",
                        "value": "连云区"
                    },
                    {
                        "label": "东海",
                        "value": "东海县"
                    },
                    {
                        "label": "灌云",
                        "value": "灌云县"
                    },
                    {
                        "label": "灌南",
                        "value": "灌南县"
                    },
                    {
                        "label": "赣榆",
                        "value": "赣榆县"
                    }, 
                    {
                        "label": "连云港",
                        "value": "连云港市"
                    }
                ]
            },
            {
                "value": "镇江市",
                "label": "镇江",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "京口",
                        "value": "京口区"
                    },
                    {
                        "label": "丹徒",
                        "value": "丹徒区"
                    },
                    {
                        "label": "润州",
                        "value": "润州区"
                    },
                    {
                        "label": "句容",
                        "value": "句容市"
                    },
                    {
                        "label": "丹阳",
                        "value": "丹阳市"
                    },
                    {
                        "label": "扬中",
                        "value": "扬中市"
                    },
                    {
                        "label": "镇江",
                        "value": "镇江市"
                    }
                ]
            },
            {
                "value": "江苏省",
                "label": "江苏",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "江苏",
                        "value": "江苏省"
                    }
                ]
            }
        ]
    },
    {
        "value": "山东省",
        "label": "山东",
        "children": [
            {
                "label": "不限",
                "value": "不限"
            },
            {
                "value": "济南市",
                "label": "济南",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "历下",
                        "value": "历下区"
                    },
                    {
                        "label": "天桥",
                        "value": "天桥区"
                    },
                    {
                        "label": "历城",
                        "value": "历城区"
                    },
                    {
                        "label": "市中",
                        "value": "市中区"
                    },
                    {
                        "label": "槐荫",
                        "value": "槐荫区"
                    },
                    {
                        "label": "章丘",
                        "value": "章丘区"
                    },
                    {
                        "label": "长清",
                        "value": "长清区"
                    },
                    {
                        "label": "济阳",
                        "value": "济阳县"
                    },
                    {
                        "label": "商河",
                        "value": "商河县"
                    },
                    {
                        "label": "平阴",
                        "value": "平阴县"
                    },
                    {
                        "label": "章丘",
                        "value": "章丘市"
                    },
                    {
                        "label": "济南",
                        "value": "济南市"
                    }
                ]
            },
            {
                "value": "青岛市",
                "label": "青岛",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "市北",
                         "value": "市北区"
                    },
                    {
                        "label": "市南",
                        "value": "市南区"
                    },
                    {
                        "label": "城阳",
                        "value": "城阳区"
                    },
                    {
                        "label": "李沧",
                        "value": "李沧区"
                    },
                    {
                        "label": "黄岛",
                        "value": "黄岛区"
                    },
                    {
                        "label": "胶州",
                        "value": "胶州市"
                    },
                    {
                        "label": "崂山",
                        "value": "崂山区"
                    },
                    {
                        "label": "即墨",
                        "value": "即墨市"
                    },
                    {
                        "label": "平度",
                        "value": "平度市"
                    },
                    {
                        "label": "莱西",
                        "value": "莱西市"
                    },
                    {
                        "label": "青岛",
                        "value": "青岛市"
                    }
                ]
            },
            {
                "value": "潍坊市",
                "label": "潍坊",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "奎文",
                        "value": "奎文区"
                    },
                    {
                        "label": "潍城",
                        "value": "潍城区"
                    },
                    {
                        "label": "寒亭",
                        "value": "寒亭区"
                    },
                    {
                        "label": "坊子",
                        "value": "坊子区"
                    },
                    {
                        "label": "寿光",
                        "value": "寿光市"
                    },
                    {
                        "label": "诸城",
                        "value": "诸城市"
                    },
                    {
                        "label": "青州",
                        "value": "青州市"
                    },
                    {
                        "label": "高密",
                        "value": "高密市"
                    },
                    {
                        "label": "安丘",
                        "value": "安丘市"
                    },
                    {
                        "label": "临朐",
                        "value": "临朐县"
                    },
                    {
                        "label": "昌乐",
                        "value": "昌乐县"
                    },
                    {
                        "label": "昌邑",
                        "value": "昌邑市"
                    },
                    {
                        "label": "潍坊",
                        "value": "潍坊市"
                    }
                ]
            },
            {
                "value": "临沂市",
                "label": "临沂",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "兰山",
                        "value": "兰山区"
                    },
                    {
                        "label": "河东",
                        "value": "河东区"
                    },
                    {
                        "label": "罗庄",
                        "value": "罗庄区"
                    },
                    {
                        "label": "费县",
                        "value": "费县"
                    },
                    {
                        "label": "平邑",
                        "value": "平邑县"
                    },
                    {
                        "label": "沂水",
                        "value": "沂水县"
                    },
                    {
                        "label": "临沭",
                        "value": "临沭县"
                    },
                    {
                        "label": "莒南",
                        "value": "莒南县"
                    },
                    {
                        "label": "兰陵",
                        "value": "兰陵县"
                    },
                    {
                        "label": "沂南",
                        "value": "沂南县"
                    },
                    {
                        "label": "郯城",
                        "value": "郯城县"
                    },
                    {
                        "label": "蒙阴",
                        "value": "蒙阴县"
                    },
                    {
                        "label": "临沂",
                        "value": "临沂市"
                    }
                ]
            },
            {
                "value": "烟台市",
                "label": "烟台",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "芝罘",
                        "value": "芝罘区"
                    },
                    {
                        "label": "福山",
                        "value": "福山区"
                    },
                    {
                        "label": "莱山",
                        "value": "莱山区"
                    },
                    {
                        "label": "牟平",
                        "value": "牟平区"
                    },
                    {
                        "label": "莱州",
                        "value": "莱州市"
                    },
                    {
                        "label": "海阳",
                        "value": "海阳市"
                    },
                    {
                        "label": "龙口",
                        "value": "龙口市"
                    },
                    {
                        "label": "招远",
                        "value": "招远市"
                    },
                    {
                        "label": "莱阳",
                        "value": "莱阳市"
                    },
                    {
                        "label": "蓬莱",
                        "value": "蓬莱市"
                    },
                    {
                        "label": "栖霞",
                        "value": "栖霞市"
                    },
                    {
                        "label": "长岛",
                        "value": "长岛县"
                    },
                    {
                        "label": "烟台",
                        "value": "烟台市"
                    }
                ]
            },
            {
                "value": "济宁市",
                "label": "济宁",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "任城",
                        "value": "任城区"
                    },
                    {
                        "label": "兖州",
                        "value": "兖州区"
                    },
                    {
                        "label": "邹城",
                        "value": "邹城市"
                    },
                    {
                        "label": "曲阜",
                        "value": "曲阜市"
                    },
                    {
                        "label": "兖州",
                        "value": "兖州市"
                    }, 
                    {
                        "label": "梁山",
                        "value": "梁山县"
                    },
                    {
                        "label": "嘉祥",
                        "value": "嘉祥县"
                    },
                    {
                        "label": "金乡",
                        "value": "金乡县"
                    },
                    {
                        "label": "汶上",
                        "value": "汶上县"
                    },
                    {
                        "label": "微山",
                        "value": "微山县"
                    },
                    {
                        "label": "泗水",
                        "value": "泗水县"
                    },
                    {
                        "label": "鱼台",
                        "value": "鱼台县"
                    },
                    {
                        "label": "济宁",
                        "value": "济宁市"
                    },
                ]
            },
            {
                "value": "菏泽市",
                "label": "菏泽",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "牡丹",
                        "value": "牡丹区"
                    },
                    {
                        "label": "定陶",
                        "value": "定陶区"
                    },
                    {
                        "label": "曹县",
                        "value": "曹县"
                    },
                    {
                        "label": "郓城",
                        "value": "郓城县"
                    },
                    {
                        "label": "单县",
                        "value": "单县"
                    },
                    {
                        "label": "巨野",
                        "value": "巨野县"
                    },
                    {
                        "label": "鄄城",
                        "value": "鄄城县"
                    },
                    {
                        "label": "成武",
                        "value": "成武县"
                    },
                    {
                        "label": "东明",
                        "value": "东明县"
                    },
                    {
                        "label": "定陶",
                        "value": "定陶县"
                    },
                    {
                        "label": "菏泽",
                        "value": "菏泽市"
                    }
                ]
            },
            {
                "value": "淄博市",
                "label": "淄博",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "张店",
                        "value": "张店区"
                    },
                    {
                        "label": "临淄",
                        "value": "临淄区"
                    },
                    {
                        "label": "淄川",
                        "value": "淄川区"
                    },
                    {
                        "label": "博山",
                        "value": "博山区"
                    },
                    {
                        "label": "周村",
                        "value": "周村区"
                    },
                    {
                        "label": "桓台",
                        "value": "桓台县"
                    },
                    {
                        "label": "沂源",
                        "value": "沂源县"
                    },
                    {
                        "label": "高青",
                        "value": "高青县"
                    },
                    {
                        "label": "淄博",
                        "value": "淄博市"
                    }
                ]
            },
            {
                "value": "聊城市",
                "label": "聊城",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "东昌府",
                        "value": "东昌府区"
                    },
                    {
                        "label": "临清",
                        "value": "临清市"
                    },
                    {
                        "label": "莘县",
                        "value": "莘县"
                    },
                    {
                        "label": "冠县",
                        "value": "冠县"
                    },
                    {
                        "label": "阳谷",
                        "value": "阳谷县"
                    },
                    {
                        "label": "茌平",
                        "value": "茌平县"
                    },
                    {
                        "label": "高唐",
                        "value": "高唐县"
                    },
                    {
                        "label": "东阿",
                        "value": "东阿县"
                    },
                    {
                        "label": "聊城",
                        "value": "聊城市"
                    }
                ]
            },
            {
                "value": "德州市",
                "label": "德州",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "德城",
                        "value": "德城区"
                    },
                    {
                        "label": "陵城",
                        "value": "陵城区"
                    },
                    {
                        "label": "乐陵",
                        "value": "乐陵市"
                    },
                    {
                        "label": "齐河",
                        "value": "齐河县"
                    },
                    {
                        "label": "禹城",
                        "value": "禹城市"
                    },
                    {
                        "label": "武城",
                        "value": "武城县"
                    },
                    {
                        "label": "平原",
                        "value": "平原县"
                    },
                    {
                        "label": "夏津",
                        "value": "夏津县"
                    },
                    {
                        "label": "宁津",
                        "value": "宁津县"
                    },
                    {
                        "label": "庆云",
                        "value": "庆云县"
                    },
                    {
                        "label": "临邑",
                        "value": "临邑县"
                    },
                    {
                        "label": "德州",
                        "value": "德州市"
                    }
                ]
            },
            {
                "value": "泰安市",
                "label": "泰安",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "泰山",
                        "value": "泰山区"
                    },
                    {
                        "label": "岱岳",
                        "value": "岱岳区"
                    },
                    {
                        "label": "新泰",
                        "value": "新泰市"
                    },
                    {
                        "label": "肥城",
                        "value": "肥城市"
                    },
                    {
                        "label": "宁阳",
                        "value": "宁阳县"
                    },
                    {
                        "label": "东平",
                        "value": "东平县"
                    },
                    {
                        "label": "泰安",
                        "value": "泰安市"
                    }
                ]
            },
            {
                "value": "威海市",
                "label": "威海",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "环翠",
                        "value": "环翠区"
                    },
                    {
                        "label": "荣成",
                        "value": "荣成市"
                    },
                    {
                        "label": "文登",
                        "value": "文登区"
                    },
                    {
                        "label": "乳山",
                        "value": "乳山市"
                    },
                    {
                        "label": "威海",
                        "value": "威海市"
                    }
                ]
            },
            {
                "value": "滨州市",
                "label": "滨州",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "滨城",
                        "value": "滨城区"
                    },
                    {
                        "label": "沾化",
                        "value": "沾化区"
                    },
                    {
                        "label": "博兴",
                        "value": "博兴县"
                    },
                    {
                        "label": "惠民",
                        "value": "惠民县"
                    },
                    {
                        "label": "邹平",
                        "value": "邹平县"
                    },
                    {
                        "label": "无棣",
                        "value": "无棣县"
                    },
                    {
                        "label": "阳信",
                        "value": "阳信县"
                    },
                    {
                        "label": "沾化",
                        "value": "沾化县"
                    }, 
                    {
                        "label": "滨州",
                        "value": "滨州市"
                    }
                ]
            },
            {
                "value": "日照市",
                "label": "日照",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "东港",
                        "value": "东港区"
                    },
                    {
                        "label": "岚山",
                        "value": "岚山区"
                    },
                    {
                        "label": "莒县",
                        "value": "莒县"
                    },
                    {
                        "label": "五莲",
                        "value": "五莲县"
                    },
                    {
                        "label": "日照",
                        "value": "日照市"
                    }
                ]
            },
            {
                "value": "枣庄市",
                "label": "枣庄",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "市中",
                        "value": "市中区"
                    },
                    {
                        "label": "薛城",
                        "value": "薛城区"
                    },
                    {
                        "label": "峄城",
                        "value": "峄城区"
                    },
                    {
                        "label": "山亭",
                        "value": "山亭区"
                    },
                    {
                        "label": "台儿庄",
                        "value": "台儿庄区"
                    },
                    {
                        "label": "滕州",
                        "value": "滕州市"
                    },
                    {
                        "label": "枣庄",
                        "value": "枣庄市"
                    }
                ]
            },
            {
                "value": "东营市",
                "label": "东营",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "东营",
                        "value": "东营区"
                    },
                    {
                        "label": "垦利",
                        "value": "垦利区"
                    },
                    {
                        "label": "河口",
                        "value": "河口区"
                    },
                    {
                        "label": "广饶",
                        "value": "广饶县"
                    },
                    {
                        "label": "利津",
                        "value": "利津县"
                    },
                    {
                        "label": "垦利",
                        "value": "垦利县"
                    },
                    {
                        "label": "东营",
                        "value": "东营市"
                    }
                ]
            },
            {
                "value": "莱芜市",
                "label": "莱芜",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "莱城",
                        "value": "莱城区"
                    },
                    {
                        "label": "钢城",
                        "value": "钢城区"
                    },
                    {
                        "label": "莱芜",
                        "value": "莱芜市"
                    }
                ]
            },
            {
                "value": "山东省",
                "label": "山东",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "山东",
                        "value": "山东省"
                    }
                ]
            }
        ]
    },
    {
        "value": "浙江省",
        "label": "浙江",
        "children": [
    {
        "label": "不限",
        "value": "不限"
    },
            {
                "value": "杭州市",
                "label": "杭州",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "西湖",
                        "value": "西湖区"
                    },
                    {
                        "label": "拱墅",
                        "value": "拱墅区"
                    },
                    {
                        "label": "滨江",
                        "value": "滨江区"
                    },
                    {
                        "label": "下城",
                        "value": "下城区"
                    },
                    {
                        "label": "上城",
                        "value": "上城区"
                    },
                    {
                        "label": "江干",
                        "value": "江干区"
                    },
                    {
                        "label": "萧山",
                        "value": "萧山区"
                    },
                    {
                        "label": "余杭",
                        "value": "余杭区"
                    },
                    {
                        "label": "富阳",
                        "value": "富阳区"
                    },
                    {
                        "label": "建德",
                        "value": "建德市"
                    },
                    {
                        "label": "临安",
                        "value": "临安市"
                    },
                    {
                        "label": "临安",
                        "value": "临安区"
                    },
                    {
                        "label": "桐庐",
                        "value": "桐庐县"
                    },
                    {
                        "label": "淳安",
                        "value": "淳安县"
                    },
                    {
                        "label": "杭州",
                        "value": "杭州市"
                    }
                ]
            },
            {
                "value": "宁波市",
                "label": "宁波",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "鄞州",
                        "value": "鄞州区"
                    },
                    {
                        "label": "北仑",
                        "value": "北仑区"
                    },
                    {
                        "label": "海曙",
                        "value": "海曙区"
                    },
                    {
                        "label": "镇海",
                        "value": "镇海区"
                    },
                    {
                        "label": "江北",
                        "value": "江北区"
                    },
                    {
                        "label": "江东",
                        "value": "江东区"
                    },
                    {
                        "label": "奉化",
                        "value": "奉化区"
                    },
                    {
                        "label": "慈溪",
                        "value": "慈溪市"
                    },
                    {
                        "label": "余姚",
                        "value": "余姚市"
                    },
                    {
                        "label": "宁海",
                        "value": "宁海县"
                    },
                    {
                        "label": "象山",
                        "value": "象山县"
                    },
                    {
                        "label": "奉化",
                        "value": "奉化市"
                    },
                    {
                        "label": "宁波",
                        "value": "宁波市"
                    }
                ]
            },
            {
                "value": "金华市",
                "label": "金华",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "金东",
                        "value": "金东区"
                    },
                    {
                        "label": "婺城",
                        "value": "婺城区"
                    },
                    {
                        "label": "义乌",
                        "value": "义乌市"
                    },
                    {
                        "label": "兰溪",
                        "value": "兰溪市"
                    },
                    {
                        "label": "永康",
                        "value": "永康市"
                    },
                    {
                        "label": "东阳",
                        "value": "东阳市"
                    },
                    {
                        "label": "浦江",
                        "value": "浦江县"
                    },
                    {
                        "label": "武义",
                        "value": "武义县"
                    },
                    {
                        "label": "磐安",
                        "value": "磐安县"
                    },
                    {
                        "label": "金华",
                        "value": "金华市"
                    }
                ]
            },
            {
                "value": "温州市",
                "label": "温州",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "瓯海",
                        "value": "瓯海区"
                    },
                    {
                        "label": "龙湾",
                        "value": "龙湾区"
                    },
                    {
                        "label": "鹿城",
                        "value": "鹿城区"
                    },
                    {
                        "label": "洞头",
                        "value": "洞头区"
                    },
                    {
                        "label": "乐清",
                        "value": "乐清市"
                    },
                    {
                        "label": "瑞安",
                        "value": "瑞安市"
                    },
                    {
                        "label": "永嘉",
                        "value": "永嘉县"
                    },
                    {
                        "label": "苍南",
                        "value": "苍南县"
                    },
                    {
                        "label": "平阳",
                        "value": "平阳县"
                    },
                    {
                        "label": "泰顺",
                        "value": "泰顺县"
                    },
                    {
                        "label": "文成",
                        "value": "文成县"
                    },
                    {
                        "label": "温州",
                        "value": "温州市"
                    }
                ]
            },
            {
                "value": "台州市",
                "label": "台州",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "椒江",
                        "value": "椒江区"
                    },
                    {
                        "label": "路桥",
                        "value": "路桥区"
                    },
                    {
                        "label": "黄岩",
                        "value": "黄岩区"
                    },
                    {
                        "label": "温岭",
                        "value": "温岭市"
                    },
                    {
                        "label": "临海",
                        "value": "临海市"
                    },
                    {
                        "label": "玉环",
                        "value": "玉环市"
                    },
                    {
                        "label": "天台",
                        "value": "天台县"
                    },
                    {
                        "label": "三门",
                        "value": "三门县"
                    },
                    {
                        "label": "仙居",
                        "value": "仙居县"
                    },
                    {
                        "label": "玉环",
                        "value": "玉环县"
                    }, 
                    {
                        "label": "台州",
                        "value": "台州市"
                    }
                ]
            },
            {
                "value": "绍兴市",
                "label": "绍兴",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "柯桥",
                        "value": "柯桥区"
                    },
                    {
                        "label": "越城",
                        "value": "越城区"
                    },
                    {
                        "label": "上虞",
                        "value": "上虞区"
                    },
                    {
                        "label": "诸暨",
                        "value": "诸暨市"
                    },
                    {
                        "label": "嵊州",
                        "value": "嵊州市"
                    },
                    {
                        "label": "绍兴",
                        "value": "绍兴市"
                    },
                    {
                        "label": "新昌",
                        "value": "新昌县"
                    },
                    {
                        "label": "上虞",
                        "value": "上虞市"
                    }
                ]
            },
            {
                "value": "嘉兴市",
                "label": "嘉兴",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "南湖",
                        "value": "南湖区"
                    },
                    {
                        "label": "秀洲",
                        "value": "秀洲区"
                    },
                    {
                        "label": "桐乡",
                        "value": "桐乡市"
                    },
                    {
                        "label": "平湖",
                        "value": "平湖市"
                    },
                    {
                        "label": "海宁",
                        "value": "海宁市"
                    },
                    {
                        "label": "嘉善",
                        "value": "嘉善县"
                    },
                    {
                        "label": "海盐",
                        "value": "海盐县"
                    },
                    {
                        "label": "嘉兴",
                        "value": "嘉兴市"
                    }
                ]
            },
            {
                "value": "湖州市",
                "label": "湖州",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "吴兴",
                        "value": "吴兴区"
                    },
                    {
                        "label": "南浔",
                        "value": "南浔区"
                    },
                    {
                        "label": "长兴",
                        "value": "长兴县"
                    },
                    {
                        "label": "德清",
                        "value": "德清县"
                    },
                    {
                        "label": "安吉",
                        "value": "安吉县"
                    },
                    {
                        "label": "湖州",
                        "value": "湖州市"
                    }
                ]
            },
            {
                "value": "丽水市",
                "label": "丽水",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "莲都",
                        "value": "莲都区"
                    },
                    {
                        "label": "龙泉",
                        "value": "龙泉市"
                    },
                    {
                        "label": "缙云",
                        "value": "缙云县"
                    },
                    {
                        "label": "青田",
                        "value": "青田县"
                    },
                    {
                        "label": "遂昌",
                        "value": "遂昌县"
                    },
                    {
                        "label": "松阳",
                        "value": "松阳县"
                    },
                    {
                        "label": "云和",
                        "value": "云和县"
                    },
                    {
                        "label": "景宁",
                        "value": "景宁畲族自治县"
                    },
                    {
                        "label": "庆元",
                        "value": "庆元县"
                    },
                    {
                        "label": "丽水",
                        "value": "丽水市"
                    }
                ]
            },
            {
                "value": "衢州市",
                "label": "衢州",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "柯城",
                        "value": "柯城区"
                    },
                    {
                        "label": "衢江",
                        "value": "衢江区"
                    },
                    {
                        "label": "江山",
                        "value": "江山市"
                    },
                    {
                        "label": "龙游",
                        "value": "龙游县"
                    },
                    {
                        "label": "常山",
                        "value": "常山县"
                    },
                    {
                        "label": "开化",
                        "value": "开化县"
                    },
                    {
                        "label": "衢州",
                        "value": "衢州市"
                    }
                ]
            },
            {
                "value": "舟山市",
                "label": "舟山",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "定海",
                        "value": "定海区"
                    },
                    {
                        "label": "普陀",
                        "value": "普陀区"
                    },
                    {
                        "label": "岱山",
                        "value": "岱山县"
                    },
                    {
                        "label": "嵊泗",
                        "value": "嵊泗县"
                    },
                    {
                        "label": "舟山",
                        "value": "舟山市"
                    }
                ]
            },
            {
                "value": "浙江省",
                "label": "浙江",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "浙江",
                        "value": "浙江省"
                    }
                ]
            }
        ]
    },
    {
        "value": "天津市",
        "label": "天津",
        "children": [
            {
                "label": "不限",
                "value": "不限"
            },
            {
                "value": "天津市",
                "label": "天津",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "滨海",
                        "value": "滨海新区"
                    },
                    {
                        "label": "静海",
                        "value": "静海区"
                    },
                    {
                        "label": "武清",
                        "value": "武清区"
                    },
                    {
                        "label": "南开",
                        "value": "南开区"
                    },
                    {
                        "label": "东丽",
                        "value": "东丽区"
                    },
                    {
                        "label": "津南",
                        "value": "津南区"
                    },
                    {
                        "label": "西青",
                        "value": "西青区"
                    },
                    {
                        "label": "北辰",
                        "value": "北辰区"
                    },
                    {
                        "label": "河西",
                        "value": "河西区"
                    },
                    {
                        "label": "河北",
                        "value": "河北区"
                    },
                    {
                        "label": "河东",
                        "value": "河东区"
                    },
                    {
                        "label": "宝坻",
                        "value": "宝坻区"
                    },
                    {
                        "label": "蓟州",
                        "value": "蓟州区"
                    },
                    {
                        "label": "和平",
                        "value": "和平区"
                    },
                    {
                        "label": "红桥",
                        "value": "红桥区"
                    },
                    {
                        "label": "宁河",
                        "value": "宁河区"
                    },
                    {
                        "label": "蓟县",
                        "value": "蓟县"
                    }, 
                    {
                        "label": "天津",
                        "value": "天津市"
                    },
                ]
            }
        ]
    },
    {
        "value": "重庆市",
        "label": "重庆",
        "children": [
            {
                "label": "不限",
                "value": "不限"
            },
            {
                "value": "重庆市",
                "label": "重庆",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "渝北",
                        "value": "渝北区"
                    },
                    {
                        "label": "渝中",
                        "value": "渝中区"
                    },
                    {
                        "label": "九龙坡",
                        "value": "九龙坡区"
                    },
                    {
                        "label": "南岸",
                        "value": "南岸区"
                    },
                    {
                        "label": "江北",
                        "value": "江北区"
                    },
                    {
                        "label": "江津",
                        "value": "江津区"
                    },
                    {
                        "label": "沙坪坝",
                        "value": "沙坪坝区"
                    },
                    {
                        "label": "万州",
                        "value": "万州区"
                    },
                    {
                        "label": "巴南",
                        "value": "巴南区"
                    },
                    {
                        "label": "綦江",
                        "value": "綦江区"
                    },
                    {
                        "label": "涪陵",
                        "value": "涪陵区"
                    },
                    {
                        "label": "永川",
                        "value": "永川区"
                    },
                    {
                        "label": "北碚",
                        "value": "北碚区"
                    },
                    {
                        "label": "黔江",
                        "value": "黔江区"
                    },
                    {
                        "label": "开州",
                        "value": "开州区"
                    },
                    {
                        "label": "大足",
                        "value": "大足区"
                    },
                    {
                        "label": "荣昌",
                        "value": "荣昌区"
                    },
                    {
                        "label": "长寿",
                        "value": "长寿区"
                    },
                    {
                        "label": "合川",
                        "value": "合川区"
                    },
                    {
                        "label": "潼南",
                        "value": "潼南区"
                    },
                    {
                        "label": "南川",
                        "value": "南川区"
                    },
                    {
                        "label": "璧山",
                        "value": "璧山区"
                    },
                    {
                        "label": "大渡口",
                        "value": "大渡口区"
                    },
                    {
                        "label": "铜梁",
                        "value": "铜梁区"
                    },
                    {
                        "label": "梁平",
                        "value": "梁平区"
                    },
                    {
                        "label": "武隆",
                        "value": "武隆区"
                    },
                    {
                        "label": "云阳",
                        "value": "云阳县"
                    },
                    {
                        "label": "秀山",
                        "value": "秀山土家族苗族自治县"
                    },
                    {
                        "label": "奉节",
                        "value": "奉节县"
                    },
                    {
                        "label": "忠县",
                        "value": "忠县"
                    },
                    {
                        "label": "酉阳",
                        "value": "酉阳土家族苗族自治县"
                    },
                    {
                        "label": "丰都",
                        "value": "丰都县"
                    },
                    {
                        "label": "石柱",
                        "value": "石柱土家族自治县"
                    },
                    {
                        "label": "垫江",
                        "value": "垫江县"
                    },
                    {
                        "label": "彭水",
                        "value": "彭水苗族土家族自治县"
                    },
                    {
                        "label": "巫山",
                        "value": "巫山县"
                    },
                    {
                        "label": "巫溪",
                        "value": "巫溪县"
                    },
                    {
                        "label": "城口",
                        "value": "城口县"
                    },
                    {
                        "label": "梁平",
                        "value": "梁平县"
                    },
                    {
                        "label": "开县",
                        "value": "开县"
                    },
                    {
                        "label": "武隆",
                        "value": "武隆县"
                    }, 
                    {
                        "label": "重庆",
                        "value": "重庆市"
                    }
                ]
            },
            {
                "value": "县",
                "label": "县",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "彭水",
                        "value": "彭水苗族土家族自治县"
                    },
                    {
                        "label": "酉阳",
                        "value": "酉阳土家族苗族自治县"
                    },
                    {
                        "label": "武隆",
                        "value": "武隆县"
                    },
                    {
                        "label": "奉节",
                        "value": "奉节县"
                    },
                    {
                        "label": "云阳",
                        "value": "云阳县"
                    },
                    {
                        "label": "丰都",
                        "value": "丰都县"
                    },
                    {
                        "label": "开县",
                        "value": "开县"
                    },
                    {
                        "label": "忠县",
                        "value": "忠县"
                    },
                    {
                        "label": "秀山",
                        "value": "秀山土家族苗族自治县"
                    },
                    {
                        "label": "石柱",
                        "value": "石柱土家族自治县"
                    },
                    {
                        "label": "城口",
                        "value": "城口县"
                    },
                    {
                        "label": "垫江",
                        "value": "垫江县"
                    },
                    {
                        "label": "巫溪",
                        "value": "巫溪县"
                    },
                    {
                        "label": "梁平",
                        "value": "梁平县"
                    },
                    {
                        "label": "巫山",
                        "value": "巫山县"
                    }
                ]
            }
        ]
    },
    {
        "value": "河南省",
        "label": "河南",
        "children": [
            {
                "label": "不限",
                "value": "不限"
            },
            {
                "value": "郑州市",
                "label": "郑州",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "金水",
                        "value": "金水区"
                    },
                    {
                        "label": "管城",
                        "value": "管城回族区"
                    },
                    {
                        "label": "中原",
                        "value": "中原区"
                    },
                    {
                        "label": "二七",
                        "value": "二七区"
                    },
                    {
                        "label": "新郑",
                        "value": "新郑市"
                    },
                    {
                        "label": "惠济",
                        "value": "惠济区"
                    },
                    {
                        "label": "中牟",
                        "value": "中牟县"
                    },
                    {
                        "label": "荥阳",
                        "value": "荥阳市"
                    },
                    {
                        "label": "新密",
                        "value": "新密市"
                    },
                    {
                        "label": "巩义",
                        "value": "巩义市"
                    },
                    {
                        "label": "登封",
                        "value": "登封市"
                    },
                    {
                        "label": "上街",
                        "value": "上街区"
                    },
                    {
                        "label": "郑州",
                        "value": "郑州市"
                    }
                ]
            },
            {
                "value": "南阳市",
                "label": "南阳",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "卧龙",
                        "value": "卧龙区"
                    },
                    {
                        "label": "宛城",
                        "value": "宛城区"
                    },
                    {
                        "label": "邓州",
                        "value": "邓州市"
                    },
                    {
                        "label": "方城",
                        "value": "方城县"
                    },
                    {
                        "label": "镇平",
                        "value": "镇平县"
                    },
                    {
                        "label": "唐河",
                        "value": "唐河县"
                    },
                    {
                        "label": "淅川",
                        "value": "淅川县"
                    },
                    {
                        "label": "内乡",
                        "value": "内乡县"
                    },
                    {
                        "label": "西峡",
                        "value": "西峡县"
                    },
                    {
                        "label": "南召",
                        "value": "南召县"
                    },
                    {
                        "label": "社旗",
                        "value": "社旗县"
                    },
                    {
                        "label": "新野",
                        "value": "新野县"
                    },
                    {
                        "label": "桐柏",
                        "value": "桐柏县"
                    },
                    {
                        "label": "南阳",
                        "value": "南阳市"
                    }
                ]
            },
            {
                "value": "洛阳市",
                "label": "洛阳",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "洛龙",
                        "value": "洛龙区"
                    },
                    {
                        "label": "涧西",
                        "value": "涧西区"
                    },
                    {
                        "label": "西工",
                        "value": "西工区"
                    },
                    {
                        "label": "伊川",
                        "value": "伊川县"
                    },
                    {
                        "label": "偃师",
                        "value": "偃师市"
                    },
                    {
                        "label": "宜阳",
                        "value": "宜阳县"
                    },
                    {
                        "label": "孟津",
                        "value": "孟津县"
                    },
                    {
                        "label": "新安",
                        "value": "新安县"
                    },
                    {
                        "label": "老城",
                        "value": "老城区"
                    },
                    {
                        "label": "栾川",
                        "value": "栾川县"
                    },
                    {
                        "label": "嵩县",
                        "value": "嵩县"
                    },
                    {
                        "label": "汝阳",
                        "value": "汝阳县"
                    },
                    {
                        "label": "洛宁",
                        "value": "洛宁县"
                    },
                    {
                        "label": "瀍河回族区",
                        "value": "瀍河回族区"
                    },
                    {
                        "label": "吉利",
                        "value": "吉利区"
                    },
                    {
                        "label": "洛阳",
                        "value": "洛阳市"
                    }
                ]
            },
            {
                "value": "周口市",
                "label": "周口",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "川汇",
                        "value": "川汇区"
                    },
                    {
                        "label": "太康",
                        "value": "太康县"
                    },
                    {
                        "label": "项城",
                        "value": "项城市"
                    },
                    {
                        "label": "郸城",
                        "value": "郸城县"
                    },
                    {
                        "label": "沈丘",
                        "value": "沈丘县"
                    },
                    {
                        "label": "商水",
                        "value": "商水县"
                    },
                    {
                        "label": "鹿邑",
                        "value": "鹿邑县"
                    },
                    {
                        "label": "淮阳",
                        "value": "淮阳县"
                    },
                    {
                        "label": "西华",
                        "value": "西华县"
                    },
                    {
                        "label": "扶沟",
                        "value": "扶沟县"
                    },
                    {
                        "label": "周口",
                        "value": "周口市"
                    }
                ]
            },
            {
                "value": "商丘市",
                "label": "商丘",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "梁园",
                        "value": "梁园区"
                    },
                    {
                        "label": "睢阳",
                        "value": "睢阳区"
                    },
                    {
                        "label": "永城",
                        "value": "永城市"
                    },
                    {
                        "label": "虞城",
                        "value": "虞城县"
                    },
                    {
                        "label": "夏邑",
                        "value": "夏邑县"
                    },
                    {
                        "label": "民权",
                        "value": "民权县"
                    },
                    {
                        "label": "柘城",
                        "value": "柘城县"
                    },
                    {
                        "label": "睢县",
                        "value": "睢县"
                    },
                    {
                        "label": "宁陵",
                        "value": "宁陵县"
                    },
                    {
                        "label": "商丘",
                        "value": "商丘市"
                    }
                ]
            },
            {
                "value": "驻马店市",
                "label": "驻马店",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "驿城",
                        "value": "驿城区"
                    },
                    {
                        "label": "上蔡",
                        "value": "上蔡县"
                    },
                    {
                        "label": "新蔡",
                        "value": "新蔡县"
                    },
                    {
                        "label": "西平",
                        "value": "西平县"
                    },
                    {
                        "label": "正阳",
                        "value": "正阳县"
                    },
                    {
                        "label": "平舆",
                        "value": "平舆县"
                    },
                    {
                        "label": "确山",
                        "value": "确山县"
                    },
                    {
                        "label": "泌阳",
                        "value": "泌阳县"
                    },
                    {
                        "label": "汝南",
                        "value": "汝南县"
                    },
                    {
                        "label": "遂平",
                        "value": "遂平县"
                    },
                    {
                        "label": "驻马店",
                        "value": "驻马店市"
                    }
                ]
            },
            {
                "value": "新乡市",
                "label": "新乡",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "红旗",
                        "value": "红旗区"
                    },
                    {
                        "label": "长垣",
                        "value": "长垣县"
                    },
                    {
                        "label": "辉县",
                        "value": "辉县市"
                    },
                    {
                        "label": "原阳",
                        "value": "原阳县"
                    },
                    {
                        "label": "封丘",
                        "value": "封丘县"
                    },
                    {
                        "label": "延津",
                        "value": "延津县"
                    },
                    {
                        "label": "牧野",
                        "value": "牧野区"
                    },
                    {
                        "label": "卫滨",
                        "value": "卫滨区"
                    },
                    {
                        "label": "新乡",
                        "value": "新乡县"
                    },
                    {
                        "label": "获嘉",
                        "value": "获嘉县"
                    },
                    {
                        "label": "卫辉",
                        "value": "卫辉市"
                    },
                    {
                        "label": "凤泉",
                        "value": "凤泉区"
                    },
                    {
                        "label": "新乡",
                        "value": "新乡市"
                    }
                ]
            },
            {
                "value": "开封市",
                "label": "开封",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "龙亭",
                        "value": "龙亭区"
                    },
                    {
                        "label": "兰考",
                        "value": "兰考县"
                    },
                    {
                        "label": "尉氏",
                        "value": "尉氏县"
                    },
                    {
                        "label": "杞县",
                        "value": "杞县"
                    },
                    {
                        "label": "祥符",
                        "value": "祥符区"
                    },
                    {
                        "label": "鼓楼",
                        "value": "鼓楼区"
                    },
                    {
                        "label": "通许",
                        "value": "通许县"
                    },
                    {
                        "label": "顺河回族区",
                        "value": "顺河回族区"
                    },
                    {
                        "label": "禹王台",
                        "value": "禹王台区"
                    },
                    {
                        "label": "开封",
                        "value": "开封市"
                    }
                ]
            },
            {
                "value": "信阳市",
                "label": "信阳",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "固始",
                        "value": "固始县"
                    },
                    {
                        "label": "平桥",
                        "value": "平桥区"
                    },
                    {
                        "label": "浉河",
                        "value": "浉河区"
                    },
                    {
                        "label": "光山",
                        "value": "光山县"
                    },
                    {
                        "label": "潢川",
                        "value": "潢川县"
                    },
                    {
                        "label": "商城",
                        "value": "商城县"
                    },
                    {
                        "label": "淮滨",
                        "value": "淮滨县"
                    },
                    {
                        "label": "息县",
                        "value": "息县"
                    },
                    {
                        "label": "罗山",
                        "value": "罗山县"
                    },
                    {
                        "label": "新县",
                        "value": "新县"
                    },
                    {
                        "label": "信阳",
                        "value": "信阳市"
                    }
                ]
            },
            {
                "value": "许昌市",
                "label": "许昌",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "魏都",
                        "value": "魏都区"
                    },
                    {
                        "label": "禹州",
                        "value": "禹州市"
                    },
                    {
                        "label": "长葛",
                        "value": "长葛市"
                    },
                    {
                        "label": "襄城",
                        "value": "襄城县"
                    },
                    {
                        "label": "鄢陵",
                        "value": "鄢陵县"
                    },
                    {
                        "label": "建安",
                        "value": "建安区"
                    },
                    {
                        "label": "许昌",
                        "value": "许昌县"
                    },
                    {
                        "label": "许昌",
                        "value": "许昌市"
                    }
                ]
            },
            {
                "value": "安阳市",
                "label": "安阳",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "滑县",
                        "value": "滑县"
                    },
                    {
                        "label": "林州",
                        "value": "林州市"
                    },
                    {
                        "label": "文峰",
                        "value": "文峰区"
                    },
                    {
                        "label": "安阳",
                        "value": "安阳县"
                    },
                    {
                        "label": "汤阴",
                        "value": "汤阴县"
                    },
                    {
                        "label": "殷都",
                        "value": "殷都区"
                    },
                    {
                        "label": "内黄",
                        "value": "内黄县"
                    },
                    {
                        "label": "北关",
                        "value": "北关区"
                    },
                    {
                        "label": "龙安",
                        "value": "龙安区"
                    },
                    {
                        "label": "安阳",
                        "value": "安阳市"
                    }
                ]
            },
            {
                "value": "平顶山市",
                "label": "平顶山",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "汝州",
                        "value": "汝州市"
                    },
                    {
                        "label": "新华",
                        "value": "新华区"
                    },
                    {
                        "label": "卫东",
                        "value": "卫东区"
                    },
                    {
                        "label": "鲁山",
                        "value": "鲁山县"
                    },
                    {
                        "label": "湛河",
                        "value": "湛河区"
                    },
                    {
                        "label": "叶县",
                        "value": "叶县"
                    },
                    {
                        "label": "郏县",
                        "value": "郏县"
                    },
                    {
                        "label": "宝丰",
                        "value": "宝丰县"
                    },
                    {
                        "label": "舞钢",
                        "value": "舞钢市"
                    },
                    {
                        "label": "石龙",
                        "value": "石龙区"
                    },
                    {
                        "label": "平顶山",
                        "value": "平顶山市"
                    }
                ]
            },
            {
                "value": "焦作市",
                "label": "焦作",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "武陟",
                        "value": "武陟县"
                    },
                    {
                        "label": "山阳",
                        "value": "山阳区"
                    },
                    {
                        "label": "解放",
                        "value": "解放区"
                    },
                    {
                        "label": "温县",
                        "value": "温县"
                    },
                    {
                        "label": "沁阳",
                        "value": "沁阳市"
                    },
                    {
                        "label": "孟州",
                        "value": "孟州市"
                    },
                    {
                        "label": "博爱",
                        "value": "博爱县"
                    },
                    {
                        "label": "修武",
                        "value": "修武县"
                    },
                    {
                        "label": "中站",
                        "value": "中站区"
                    },
                    {
                        "label": "马村",
                        "value": "马村区"
                    },
                    {
                        "label": "焦作",
                        "value": "焦作市"
                    }
                ]
            },
            {
                "value": "濮阳市",
                "label": "濮阳",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "华龙",
                        "value": "华龙区"
                    },
                    {
                        "label": "濮阳",
                        "value": "濮阳县"
                    },
                    {
                        "label": "范县",
                        "value": "范县"
                    },
                    {
                        "label": "南乐",
                        "value": "南乐县"
                    },
                    {
                        "label": "清丰",
                        "value": "清丰县"
                    },
                    {
                        "label": "台前",
                        "value": "台前县"
                    },
                    {
                        "label": "濮阳",
                        "value": "濮阳市"
                    }
                ]
            },
            {
                "value": "漯河市",
                "label": "漯河",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "郾城",
                        "value": "郾城区"
                    },
                    {
                        "label": "源汇",
                        "value": "源汇区"
                    },
                    {
                        "label": "召陵",
                        "value": "召陵区"
                    },
                    {
                        "label": "临颍",
                        "value": "临颍县"
                    },
                    {
                        "label": "舞阳",
                        "value": "舞阳县"
                    },
                    {
                        "label": "漯河",
                        "value": "漯河市"
                    }
                ]
            },
            {
                "value": "三门峡市",
                "label": "三门峡",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "湖滨",
                        "value": "湖滨区"
                    },
                    {
                        "label": "灵宝",
                        "value": "灵宝市"
                    },
                    {
                        "label": "陕州",
                        "value": "陕州区"
                    },
                    {
                        "label": "渑池",
                        "value": "渑池县"
                    },
                    {
                        "label": "卢氏",
                        "value": "卢氏县"
                    },
                    {
                        "label": "义马",
                        "value": "义马市"
                    },
                    {
                        "label": "三门峡",
                        "value": "三门峡市"
                    },
                    {
                        "label": "陕县",
                        "value": "陕县"
                    }
                ]
            },
            {
                "value": "鹤壁市",
                "label": "鹤壁",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "淇滨",
                        "value": "淇滨区"
                    },
                    {
                        "label": "浚县",
                        "value": "浚县"
                    },
                    {
                        "label": "淇县",
                        "value": "淇县"
                    },
                    {
                        "label": "山城",
                        "value": "山城区"
                    },
                    {
                        "label": "鹤山",
                        "value": "鹤山区"
                    },
                    {
                        "label": "鹤壁",
                        "value": "鹤壁市"
                    }
                ]
            },
            {
                "value": "河南省",
                "label": "河南",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "河南",
                        "value": "河南省"
                    }
                ]
            }
        ]
    },
    {
        "value": "河北省",
        "label": "河北",
        "children": [
            {
                "label": "不限",
                "value": "不限"
            },
            {
                "value": "石家庄市",
                "label": "石家庄",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "裕华",
                        "value": "裕华区"
                    },
                    {
                        "label": "长安",
                        "value": "长安区"
                    },
                    {
                        "label": "桥西",
                        "value": "桥西区"
                    },
                    {
                        "label": "新华",
                        "value": "新华区"
                    },
                    {
                        "label": "藁城",
                        "value": "藁城区"
                    },
                    {
                        "label": "正定",
                        "value": "正定县"
                    },
                    {
                        "label": "栾城",
                        "value": "栾城区"
                    },
                    {
                        "label": "辛集",
                        "value": "辛集市"
                    },
                    {
                        "label": "无极",
                        "value": "无极县"
                    },
                    {
                        "label": "晋州",
                        "value": "晋州市"
                    },
                    {
                        "label": "鹿泉",
                        "value": "鹿泉区"
                    },
                    {
                        "label": "平山",
                        "value": "平山县"
                    },
                    {
                        "label": "新乐",
                        "value": "新乐市"
                    },
                    {
                        "label": "赵县",
                        "value": "赵县"
                    },
                    {
                        "label": "元氏",
                        "value": "元氏县"
                    },
                    {
                        "label": "赞皇",
                        "value": "赞皇县"
                    },
                    {
                        "label": "灵寿",
                        "value": "灵寿县"
                    },
                    {
                        "label": "深泽",
                        "value": "深泽县"
                    },
                    {
                        "label": "行唐",
                        "value": "行唐县"
                    },
                    {
                        "label": "高邑",
                        "value": "高邑县"
                    },
                    {
                        "label": "井陉",
                        "value": "井陉县"
                    },
                    {
                        "label": "井陉矿",
                        "value": "井陉矿区"
                    },
                    {
                        "label": "石家庄",
                        "value": "石家庄市"
                    }
                ]
            },
            {
                "value": "保定市",
                "label": "保定",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "竞秀",
                        "value": "竞秀区"
                    },
                    {
                        "label": "莲池",
                        "value": "莲池区"
                    },
                    {
                        "label": "高碑店",
                        "value": "高碑店市"
                    },
                    {
                        "label": "涿州",
                        "value": "涿州市"
                    },
                    {
                        "label": "定州",
                        "value": "定州市"
                    },
                    {
                        "label": "易县",
                        "value": "易县"
                    },
                    {
                        "label": "曲阳",
                        "value": "曲阳县"
                    },
                    {
                        "label": "唐县",
                        "value": "唐县"
                    },
                    {
                        "label": "徐水",
                        "value": "徐水区"
                    },
                    {
                        "label": "高阳",
                        "value": "高阳县"
                    },
                    {
                        "label": "清苑",
                        "value": "清苑区"
                    },
                    {
                        "label": "雄县",
                        "value": "雄县"
                    },
                    {
                        "label": "定兴",
                        "value": "定兴县"
                    },
                    {
                        "label": "满城",
                        "value": "满城区"
                    },
                    {
                        "label": "蠡县",
                        "value": "蠡县"
                    },
                    {
                        "label": "安国",
                        "value": "安国市"
                    },
                    {
                        "label": "涞水",
                        "value": "涞水县"
                    },
                    {
                        "label": "容城",
                        "value": "容城县"
                    },
                    {
                        "label": "安新",
                        "value": "安新县"
                    },
                    {
                        "label": "阜平",
                        "value": "阜平县"
                    },
                    {
                        "label": "顺平",
                        "value": "顺平县"
                    },
                    {
                        "label": "涞源",
                        "value": "涞源县"
                    },
                    {
                        "label": "望都",
                        "value": "望都县"
                    },
                    {
                        "label": "博野",
                        "value": "博野县"
                    },
                    {
                        "label": "保定",
                        "value": "保定市"
                    }
                ]
            },
            {
                "value": "邯郸市",
                "label": "邯郸",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "丛台",
                        "value": "丛台区"
                    },
                    {
                        "label": "邯山",
                        "value": "邯山区"
                    },
                    {
                        "label": "武安",
                        "value": "武安市"
                    },
                    {
                        "label": "永年",
                        "value": "永年区"
                    },
                    {
                        "label": "魏县",
                        "value": "魏县"
                    },
                    {
                        "label": "复兴",
                        "value": "复兴区"
                    },
                    {
                        "label": "肥乡",
                        "value": "肥乡区"
                    },
                    {
                        "label": "大名",
                        "value": "大名县"
                    },
                    {
                        "label": "邱县",
                        "value": "邱县"
                    },
                    {
                        "label": "临漳",
                        "value": "临漳县"
                    },
                    {
                        "label": "曲周",
                        "value": "曲周县"
                    },
                    {
                        "label": "涉县",
                        "value": "涉县"
                    },
                    {
                        "label": "磁县",
                        "value": "磁县"
                    },
                    {
                        "label": "峰峰矿",
                        "value": "峰峰矿区"
                    },
                    {
                        "label": "成安",
                        "value": "成安县"
                    },
                    {
                        "label": "馆陶",
                        "value": "馆陶县"
                    },
                    {
                        "label": "鸡泽",
                        "value": "鸡泽县"
                    },
                    {
                        "label": "广平",
                        "value": "广平县"
                    },
                    {
                        "label": "邯郸",
                        "value": "邯郸县"
                    },
                    {
                        "label": "肥乡",
                        "value": "肥乡县"
                    },
                    {
                        "label": "永年",
                        "value": "永年县"
                    },
                    {
                        "label": "邯郸",
                        "value": "邯郸市"
                    }
                ]
            },
            {
                "value": "邢台市",
                "label": "邢台",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "清河",
                        "value": "清河县"
                    },
                    {
                        "label": "桥东",
                        "value": "桥东区"
                    },
                    {
                        "label": "南宫",
                        "value": "南宫市"
                    },
                    {
                        "label": "宁晋",
                        "value": "宁晋县"
                    },
                    {
                        "label": "桥西",
                        "value": "桥西区"
                    },
                    {
                        "label": "任县",
                        "value": "任县"
                    },
                    {
                        "label": "邢台",
                        "value": "邢台县"
                    },
                    {
                        "label": "沙河",
                        "value": "沙河市"
                    },
                    {
                        "label": "威县",
                        "value": "威县"
                    },
                    {
                        "label": "平乡",
                        "value": "平乡县"
                    },
                    {
                        "label": "隆尧",
                        "value": "隆尧县"
                    },
                    {
                        "label": "巨鹿",
                        "value": "巨鹿县"
                    },
                    {
                        "label": "广宗",
                        "value": "广宗县"
                    },
                    {
                        "label": "内丘",
                        "value": "内丘县"
                    },
                    {
                        "label": "南和",
                        "value": "南和县"
                    },
                    {
                        "label": "临西",
                        "value": "临西县"
                    },
                    {
                        "label": "临城",
                        "value": "临城县"
                    },
                    {
                        "label": "柏乡",
                        "value": "柏乡县"
                    },
                    {
                        "label": "新河",
                        "value": "新河县"
                    },
                    {
                        "label": "邢台",
                        "value": "邢台市"
                    }
                ]
            },
            {
                "value": "沧州市",
                "label": "沧州",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "任丘",
                        "value": "任丘市"
                    },
                    {
                        "label": "运河",
                        "value": "运河区"
                    },
                    {
                        "label": "黄骅",
                        "value": "黄骅市"
                    },
                    {
                        "label": "泊头",
                        "value": "泊头市"
                    },
                    {
                        "label": "河间",
                        "value": "河间市"
                    },
                    {
                        "label": "沧县",
                        "value": "沧县"
                    },
                    {
                        "label": "新华",
                        "value": "新华区"
                    },
                    {
                        "label": "献县",
                        "value": "献县"
                    },
                    {
                        "label": "盐山",
                        "value": "盐山县"
                    },
                    {
                        "label": "青县",
                        "value": "青县"
                    },
                    {
                        "label": "南皮",
                        "value": "南皮县"
                    },
                    {
                        "label": "东光",
                        "value": "东光县"
                    },
                    {
                        "label": "肃宁",
                        "value": "肃宁县"
                    },
                    {
                        "label": "海兴",
                        "value": "海兴县"
                    },
                    {
                        "label": "孟村",
                        "value": "孟村回族自治县"
                    },
                    {
                        "label": "吴桥",
                        "value": "吴桥县"
                    },
                    {
                        "label": "沧州",
                        "value": "沧州市"
                    }
                ]
            },
            {
                "value": "唐山市",
                "label": "唐山",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "路北",
                        "value": "路北区"
                    },
                    {
                        "label": "路南",
                        "value": "路南区"
                    },
                    {
                        "label": "玉田",
                        "value": "玉田县"
                    },
                    {
                        "label": "丰润",
                        "value": "丰润区"
                    },
                    {
                        "label": "迁安",
                        "value": "迁安市"
                    },
                    {
                        "label": "丰南",
                        "value": "丰南区"
                    },
                    {
                        "label": "曹妃甸",
                        "value": "曹妃甸区"
                    },
                    {
                        "label": "遵化",
                        "value": "遵化市"
                    },
                    {
                        "label": "乐亭",
                        "value": "乐亭县"
                    },
                    {
                        "label": "滦县",
                        "value": "滦县"
                    },
                    {
                        "label": "开平",
                        "value": "开平区"
                    },
                    {
                        "label": "滦南",
                        "value": "滦南县"
                    },
                    {
                        "label": "迁西",
                        "value": "迁西县"
                    },
                    {
                        "label": "古冶",
                        "value": "古冶区"
                    },
                    {
                        "label": "唐山",
                        "value": "唐山市"
                    }
                ]
            },
            {
                "value": "廊坊市",
                "label": "廊坊",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "广阳",
                        "value": "广阳区"
                    },
                    {
                        "label": "三河",
                        "value": "三河市"
                    },
                    {
                        "label": "霸州",
                        "value": "霸州市"
                    },
                    {
                        "label": "固安",
                        "value": "固安县"
                    },
                    {
                        "label": "安次",
                        "value": "安次区"
                    },
                    {
                        "label": "大城",
                        "value": "大城县"
                    },
                    {
                        "label": "文安",
                        "value": "文安县"
                    },
                    {
                        "label": "香河",
                        "value": "香河县"
                    },
                    {
                        "label": "永清",
                        "value": "永清县"
                    },
                    {
                        "label": "大厂",
                        "value": "大厂回族自治县"
                    },
                    {
                        "label": "廊坊",
                        "value": "廊坊市"
                    }
                ]
            },
            {
                "value": "衡水市",
                "label": "衡水",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "桃城",
                        "value": "桃城区"
                    },
                    {
                        "label": "安平",
                        "value": "安平县"
                    },
                    {
                        "label": "故城",
                        "value": "故城县"
                    },
                    {
                        "label": "景县",
                        "value": "景县"
                    },
                    {
                        "label": "冀州",
                        "value": "冀州区"
                    },
                    {
                        "label": "枣强",
                        "value": "枣强县"
                    },
                    {
                        "label": "深州",
                        "value": "深州市"
                    },
                    {
                        "label": "饶阳",
                        "value": "饶阳县"
                    },
                    {
                        "label": "武邑",
                        "value": "武邑县"
                    },
                    {
                        "label": "阜城",
                        "value": "阜城县"
                    },
                    {
                        "label": "武强",
                        "value": "武强县"
                    },
                    {
                        "label": "冀州",
                        "value": "冀州市"
                    },
                    {
                        "label": "衡水",
                        "value": "衡水市"
                    }
                ]
            },
            {
                "value": "张家口市",
                "label": "张家口",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "桥东",
                        "value": "桥东区"
                    },
                    {
                        "label": "宣化",
                        "value": "宣化区"
                    },
                    {
                        "label": "桥西",
                        "value": "桥西区"
                    },
                    {
                        "label": "怀来",
                        "value": "怀来县"
                    },
                    {
                        "label": "蔚县",
                        "value": "蔚县"
                    },
                    {
                        "label": "张北",
                        "value": "张北县"
                    },
                    {
                        "label": "涿鹿",
                        "value": "涿鹿县"
                    },
                    {
                        "label": "沽源",
                        "value": "沽源县"
                    },
                    {
                        "label": "崇礼",
                        "value": "崇礼区"
                    },
                    {
                        "label": "康保",
                        "value": "康保县"
                    },
                    {
                        "label": "万全",
                        "value": "万全区"
                    },
                    {
                        "label": "赤城",
                        "value": "赤城县"
                    },
                    {
                        "label": "怀安",
                        "value": "怀安县"
                    },
                    {
                        "label": "阳原",
                        "value": "阳原县"
                    },
                    {
                        "label": "尚义",
                        "value": "尚义县"
                    },
                    {
                        "label": "下花园",
                        "value": "下花园区"
                    },
                    {
                        "label": "宣化",
                        "value": "宣化县"
                    },
                    {
                        "label": "万全",
                        "value": "万全县"
                    },
                    {
                        "label": "崇礼",
                        "value": "崇礼县"
                    },
                    {
                        "label": "张家口",
                        "value": "张家口市"
                    }
                ]
            },
            {
                "value": "秦皇岛市",
                "label": "秦皇岛",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "海港",
                        "value": "海港区"
                    },
                    {
                        "label": "昌黎",
                        "value": "昌黎县"
                    },
                    {
                        "label": "抚宁",
                        "value": "抚宁区"
                    },
                    {
                        "label": "青龙",
                        "value": "青龙满族自治县"
                    },
                    {
                        "label": "卢龙",
                        "value": "卢龙县"
                    },
                    {
                        "label": "山海关",
                        "value": "山海关区"
                    },
                    {
                        "label": "北戴河",
                        "value": "北戴河区"
                    },
                    {
                        "label": "秦皇岛",
                        "value": "秦皇岛市"
                    }
                ]
            },
            {
                "value": "承德市",
                "label": "承德",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "双桥",
                        "value": "双桥区"
                    },
                    {
                        "label": "围场",
                        "value": "围场满族蒙古族自治县"
                    },
                    {
                        "label": "丰宁",
                        "value": "丰宁满族自治县"
                    },
                    {
                        "label": "滦平",
                        "value": "滦平县"
                    },
                    {
                        "label": "隆化",
                        "value": "隆化县"
                    },
                    {
                        "label": "承德",
                        "value": "承德县"
                    },
                    {
                        "label": "双滦",
                        "value": "双滦区"
                    },
                    {
                        "label": "兴隆",
                        "value": "兴隆县"
                    },
                    {
                        "label": "平泉",
                        "value": "平泉市"
                    },
                    {
                        "label": "宽城",
                        "value": "宽城满族自治县"
                    },
                    {
                        "label": "平泉",
                        "value": "平泉县"
                    },
                    {
                        "label": "鹰手营子",
                        "value": "鹰手营子矿区"
                    },
                    {
                        "label": "承德",
                        "value": "承德市"
                    }
                ]
            },
            {
                "value": "河北省",
                "label": "河北",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "河北",
                        "value": "河北省"
                    }
                ]
            }
        ]
    },
    {
        "value": "四川省",
        "label": "四川",
        "children": [
            {
                "label": "不限",
                "value": "不限"
            },
            {
                "value": "成都市",
                "label": "成都",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "武侯",
                        "value": "武侯区"
                    },
                    {
                        "label": "金牛",
                        "value": "金牛区"
                    },
                    {
                        "label": "成华",
                        "value": "成华区"
                    },
                    {
                        "label": "青羊",
                        "value": "青羊区"
                    },
                    {
                        "label": "锦江",
                        "value": "锦江区"
                    },
                    {
                        "label": "双流",
                        "value": "双流区"
                    },
                    {
                        "label": "新都",
                        "value": "新都区"
                    },
                    {
                        "label": "龙泉驿",
                        "value": "龙泉驿区"
                    },
                    {
                        "label": "郫都",
                        "value": "郫都区"
                    },
                    {
                        "label": "温江",
                        "value": "温江区"
                    },
                    {
                        "label": "青白江",
                        "value": "青白江区"
                    },
                    {
                        "label": "彭州",
                        "value": "彭州市"
                    },
                    {
                        "label": "简阳",
                        "value": "简阳市"
                    },
                    {
                        "label": "都江堰",
                        "value": "都江堰市"
                    },
                    {
                        "label": "崇州",
                        "value": "崇州市"
                    },
                    {
                        "label": "金堂",
                        "value": "金堂县"
                    },
                    {
                        "label": "邛崃",
                        "value": "邛崃市"
                    },
                    {
                        "label": "新津",
                        "value": "新津县"
                    },
                    {
                        "label": "大邑",
                        "value": "大邑县"
                    },
                    {
                        "label": "蒲江",
                        "value": "蒲江县"
                    },
                    {
                        "label": "郫县",
                        "value": "郫县"
                    },
                    {
                        "label": "成都",
                        "value": "成都市"
                    },
                    {
                        "label": "双流",
                        "value": "双流县"
                    }
                ]
            },
            {
                "value": "绵阳市",
                "label": "绵阳",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "涪城",
                        "value": "涪城区"
                    },
                    {
                        "label": "江油",
                        "value": "江油市"
                    },
                    {
                        "label": "游仙",
                        "value": "游仙区"
                    },
                    {
                        "label": "三台",
                        "value": "三台县"
                    },
                    {
                        "label": "安州",
                        "value": "安州区"
                    },
                    {
                        "label": "盐亭",
                        "value": "盐亭县"
                    },
                    {
                        "label": "梓潼",
                        "value": "梓潼县"
                    },
                    {
                        "label": "北川",
                        "value": "北川羌族自治县"
                    },
                    {
                        "label": "平武",
                        "value": "平武县"
                    },
                    {
                        "label": "安县",
                        "value": "安县"
                    }, 
                    {
                        "label": "绵阳",
                        "value": "绵阳市"
                    },
                ]
            },
            {
                "value": "宜宾市",
                "label": "宜宾",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "翠屏",
                        "value": "翠屏区"
                    },
                    {
                        "label": "宜宾",
                        "value": "宜宾县"
                    },
                    {
                        "label": "长宁",
                        "value": "长宁县"
                    },
                    {
                        "label": "南溪",
                        "value": "南溪区"
                    },
                    {
                        "label": "兴文",
                        "value": "兴文县"
                    },
                    {
                        "label": "筠连",
                        "value": "筠连县"
                    },
                    {
                        "label": "高县",
                        "value": "高县"
                    },
                    {
                        "label": "珙县",
                        "value": "珙县"
                    },
                    {
                        "label": "江安",
                        "value": "江安县"
                    },
                    {
                        "label": "屏山",
                        "value": "屏山县"
                    },
                    {
                        "label": "宜宾",
                        "value": "宜宾市"
                    }
                ]
            },
            {
                "value": "南充市",
                "label": "南充",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "顺庆",
                        "value": "顺庆区"
                    },
                    {
                        "label": "南部",
                        "value": "南部县"
                    },
                    {
                        "label": "高坪",
                        "value": "高坪区"
                    },
                    {
                        "label": "阆中",
                        "value": "阆中市"
                    },
                    {
                        "label": "嘉陵",
                        "value": "嘉陵区"
                    },
                    {
                        "label": "仪陇",
                        "value": "仪陇县"
                    },
                    {
                        "label": "营山",
                        "value": "营山县"
                    },
                    {
                        "label": "西充",
                        "value": "西充县"
                    },
                    {
                        "label": "蓬安",
                        "value": "蓬安县"
                    }
                ]
            },
            {
                "value": "泸州市",
                "label": "泸州",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "江阳",
                        "value": "江阳区"
                    },
                    {
                        "label": "龙马潭",
                        "value": "龙马潭区"
                    },
                    {
                        "label": "泸县",
                        "value": "泸县"
                    },
                    {
                        "label": "古蔺",
                        "value": "古蔺县"
                    },
                    {
                        "label": "合江",
                        "value": "合江县"
                    },
                    {
                        "label": "叙永",
                        "value": "叙永县"
                    },
                    {
                        "label": "纳溪",
                        "value": "纳溪区"
                    },
                    {
                        "label": "泸州",
                        "value": "泸州市"
                    }
                ]
            },
            {
                "value": "达州市",
                "label": "达州",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "通川",
                        "value": "通川区"
                    },
                    {
                        "label": "达川",
                        "value": "达川区"
                    },
                    {
                        "label": "宣汉",
                        "value": "宣汉县"
                    },
                    {
                        "label": "渠县",
                        "value": "渠县"
                    },
                    {
                        "label": "大竹",
                        "value": "大竹县"
                    },
                    {
                        "label": "万源",
                        "value": "万源市"
                    },
                    {
                        "label": "开江",
                        "value": "开江县"
                    },
                    {
                        "label": "达州",
                        "value": "达州市"
                    }
                ]
            },
            {
                "value": "德阳市",
                "label": "德阳",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "旌阳",
                        "value": "旌阳区"
                    },
                    {
                        "label": "广汉",
                        "value": "广汉市"
                    },
                    {
                        "label": "绵竹",
                        "value": "绵竹市"
                    },
                    {
                        "label": "中江",
                        "value": "中江县"
                    },
                    {
                        "label": "什邡",
                        "value": "什邡市"
                    },
                    {
                        "label": "罗江",
                        "value": "罗江县"
                    },
                    {
                        "label": "德阳",
                        "value": "德阳市"
                    }
                ]
            },
            {
                "value": "乐山市",
                "label": "乐山",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "市中",
                        "value": "市中区"
                    },
                    {
                        "label": "峨眉山",
                        "value": "峨眉山市"
                    },
                    {
                        "label": "夹江",
                        "value": "夹江县"
                    },
                    {
                        "label": "犍为",
                        "value": "犍为县"
                    },
                    {
                        "label": "井研",
                        "value": "井研县"
                    },
                    {
                        "label": "五通桥",
                        "value": "五通桥区"
                    },
                    {
                        "label": "沙湾",
                        "value": "沙湾区"
                    },
                    {
                        "label": "马边",
                        "value": "马边彝族自治县"
                    },
                    {
                        "label": "峨边",
                        "value": "峨边彝族自治县"
                    },
                    {
                        "label": "沐川",
                        "value": "沐川县"
                    },
                    {
                        "label": "金口河",
                        "value": "金口河区"
                    },
                    {
                        "label": "乐山",
                        "value": "乐山市"
                    }
                ]
            },
            {
                "value": "凉山",
                "label": "凉山彝族自治州",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "西昌",
                        "value": "西昌市"
                    },
                    {
                        "label": "会理",
                        "value": "会理县"
                    },
                    {
                        "label": "冕宁",
                        "value": "冕宁县"
                    },
                    {
                        "label": "盐源",
                        "value": "盐源县"
                    },
                    {
                        "label": "会东",
                        "value": "会东县"
                    },
                    {
                        "label": "德昌",
                        "value": "德昌县"
                    },
                    {
                        "label": "甘洛",
                        "value": "甘洛县"
                    },
                    {
                        "label": "越西",
                        "value": "越西县"
                    },
                    {
                        "label": "雷波",
                        "value": "雷波县"
                    },
                    {
                        "label": "昭觉",
                        "value": "昭觉县"
                    },
                    {
                        "label": "宁南",
                        "value": "宁南县"
                    },
                    {
                        "label": "金阳",
                        "value": "金阳县"
                    },
                    {
                        "label": "喜德",
                        "value": "喜德县"
                    },
                    {
                        "label": "木里",
                        "value": "木里藏族自治县"
                    },
                    {
                        "label": "美姑",
                        "value": "美姑县"
                    },
                    {
                        "label": "普格",
                        "value": "普格县"
                    },
                    {
                        "label": "布拖",
                        "value": "布拖县"
                    }
                ]
            },
            {
                "value": "眉山市",
                "label": "眉山",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "东坡",
                        "value": "东坡区"
                    },
                    {
                        "label": "仁寿",
                        "value": "仁寿县"
                    },
                    {
                        "label": "彭山",
                        "value": "彭山区"
                    },
                    {
                        "label": "洪雅",
                        "value": "洪雅县"
                    },
                    {
                        "label": "丹棱",
                        "value": "丹棱县"
                    },
                    {
                        "label": "青神",
                        "value": "青神县"
                    },
                    {
                        "label": "眉山",
                        "value": "眉山市"
                    }
                ]
            },
            {
                "value": "自贡市",
                "label": "自贡",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "自流井",
                        "value": "自流井区"
                    },
                    {
                        "label": "富顺",
                        "value": "富顺县"
                    },
                    {
                        "label": "荣县",
                        "value": "荣县"
                    },
                    {
                        "label": "大安",
                        "value": "大安区"
                    },
                    {
                        "label": "贡井",
                        "value": "贡井区"
                    },
                    {
                        "label": "沿滩",
                        "value": "沿滩区"
                    },
                    {
                        "label": "自贡",
                        "value": "自贡市"
                    }
                ]
            },
            {
                "value": "广元市",
                "label": "广元",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "利州",
                        "value": "利州区"
                    },
                    {
                        "label": "剑阁",
                        "value": "剑阁县"
                    },
                    {
                        "label": "苍溪",
                        "value": "苍溪县"
                    },
                    {
                        "label": "旺苍",
                        "value": "旺苍县"
                    },
                    {
                        "label": "昭化",
                        "value": "昭化区"
                    },
                    {
                        "label": "青川",
                        "value": "青川县"
                    },
                    {
                        "label": "朝天",
                        "value": "朝天区"
                    },
                    {
                        "label": "广元",
                        "value": "广元市"
                    }
                ]
            },
            {
                "value": "巴中市",
                "label": "巴中",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "巴州",
                        "value": "巴州区"
                    },
                    {
                        "label": "平昌",
                        "value": "平昌县"
                    },
                    {
                        "label": "南江",
                        "value": "南江县"
                    },
                    {
                        "label": "通江",
                        "value": "通江县"
                    },
                    {
                        "label": "恩阳",
                        "value": "恩阳区"
                    },
                    {
                        "label": "巴中",
                        "value": "巴中市"
                    }
                ]
            },
            {
                "value": "内江市",
                "label": "内江",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "东兴",
                        "value": "东兴区"
                    },
                    {
                        "label": "资中",
                        "value": "资中县"
                    },
                    {
                        "label": "市中",
                        "value": "市中区"
                    },
                    {
                        "label": "威远",
                        "value": "威远县"
                    },
                    {
                        "label": "隆昌",
                        "value": "隆昌县"
                    },
                    {
                        "label": "隆昌",
                        "value": "隆昌市"
                    },
                    {
                        "label": "内江",
                        "value": "内江市"
                    }
                ]
            },
            {
                "value": "遂宁市",
                "label": "遂宁",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "船山",
                        "value": "船山区"
                    },
                    {
                        "label": "射洪",
                        "value": "射洪县"
                    },
                    {
                        "label": "蓬溪",
                        "value": "蓬溪县"
                    },
                    {
                        "label": "安居",
                        "value": "安居区"
                    },
                    {
                        "label": "大英",
                        "value": "大英县"
                    },
                    {
                        "label": "遂宁",
                        "value": "遂宁市"
                    }
                ]
            },
            {
                "value": "广安市",
                "label": "广安",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "广安",
                        "value": "广安区"
                    },
                    {
                        "label": "邻水",
                        "value": "邻水县"
                    },
                    {
                        "label": "武胜",
                        "value": "武胜县"
                    },
                    {
                        "label": "岳池",
                        "value": "岳池县"
                    },
                    {
                        "label": "华蓥",
                        "value": "华蓥市"
                    },
                    {
                        "label": "前锋",
                        "value": "前锋区"
                    },
                    {
                        "label": "广安",
                        "value": "广安市"
                    }
                ]
            },
            {
                "value": "攀枝花市",
                "label": "攀枝花",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "东区",
                        "value": "东区"
                    },
                    {
                        "label": "仁和",
                        "value": "仁和区"
                    },
                    {
                        "label": "西区",
                        "value": "西区"
                    },
                    {
                        "label": "盐边",
                        "value": "盐边县"
                    },
                    {
                        "label": "米易",
                        "value": "米易县"
                    },
                    {
                        "label": "攀枝花",
                        "value": "攀枝花市"
                    }
                ]
            },
            {
                "value": "雅安市",
                "label": "雅安",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "雨城",
                        "value": "雨城区"
                    },
                    {
                        "label": "汉源",
                        "value": "汉源县"
                    },
                    {
                        "label": "名山",
                        "value": "名山区"
                    },
                    {
                        "label": "荥经",
                        "value": "荥经县"
                    },
                    {
                        "label": "石棉",
                        "value": "石棉县"
                    },
                    {
                        "label": "天全",
                        "value": "天全县"
                    },
                    {
                        "label": "芦山",
                        "value": "芦山县"
                    },
                    {
                        "label": "宝兴",
                        "value": "宝兴县"
                    },
                    {
                        "label": "雅安",
                        "value": "雅安市"
                    }
                ]
            },
            {
                "value": "资阳市",
                "label": "资阳",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "雁江",
                        "value": "雁江区"
                    },
                    {
                        "label": "安岳",
                        "value": "安岳县"
                    },
                    {
                        "label": "乐至",
                        "value": "乐至县"
                    },
                    {
                        "label": "简阳",
                        "value": "简阳市"
                    },
                    {
                        "label": "资阳",
                        "value": "资阳市"
                    }
                ]
            },
            {
                "value": "阿坝藏族羌族自治州",
                "label": "阿坝",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "汶川",
                        "value": "汶川县"
                    },
                    {
                        "label": "茂县",
                        "value": "茂县"
                    },
                    {
                        "label": "九寨沟",
                        "value": "九寨沟县"
                    },
                    {
                        "label": "小金",
                        "value": "小金县"
                    },
                    {
                        "label": "金川",
                        "value": "金川县"
                    },
                    {
                        "label": "马尔康",
                        "value": "马尔康市"
                    },
                    {
                        "label": "松潘",
                        "value": "松潘县"
                    },
                    {
                        "label": "理县",
                        "value": "理县"
                    },
                    {
                        "label": "若尔盖",
                        "value": "若尔盖县"
                    },
                    {
                        "label": "黑水",
                        "value": "黑水县"
                    },
                    {
                        "label": "阿坝",
                        "value": "阿坝县"
                    },
                    {
                        "label": "红原",
                        "value": "红原县"
                    },
                    {
                        "label": "壤塘",
                        "value": "壤塘县"
                    },
                    {
                        "label": "阿坝",
                        "value": "阿坝藏族羌族自治州"
                    }
                ]
            },
            {
                "value": "甘孜藏族自治州",
                "label": "甘孜",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "康定",
                        "value": "康定市"
                    },
                    {
                        "label": "泸定",
                        "value": "泸定县"
                    },
                    {
                        "label": "九龙",
                        "value": "九龙县"
                    },
                    {
                        "label": "丹巴",
                        "value": "丹巴县"
                    },
                    {
                        "label": "甘孜",
                        "value": "甘孜县"
                    },
                    {
                        "label": "理塘",
                        "value": "理塘县"
                    },
                    {
                        "label": "稻城",
                        "value": "稻城县"
                    },
                    {
                        "label": "雅江",
                        "value": "雅江县"
                    },
                    {
                        "label": "道孚",
                        "value": "道孚县"
                    },
                    {
                        "label": "巴塘",
                        "value": "巴塘县"
                    },
                    {
                        "label": "石渠",
                        "value": "石渠县"
                    },
                    {
                        "label": "乡城",
                        "value": "乡城县"
                    },
                    {
                        "label": "德格",
                        "value": "德格县"
                    },
                    {
                        "label": "白玉",
                        "value": "白玉县"
                    },
                    {
                        "label": "炉霍",
                        "value": "炉霍县"
                    },
                    {
                        "label": "色达",
                        "value": "色达县"
                    },
                    {
                        "label": "得荣",
                        "value": "得荣县"
                    },
                    {
                        "label": "新龙",
                        "value": "新龙县"
                    }
                ]
            },
            {
                "value": "四川省",
                "label": "四川",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "四川",
                        "value": "四川省"
                    }
                ]
            }
        ]
    },
    {
        "value": "安徽省",
        "label": "安徽",
        "children": [
            {
                "label": "不限",
                "value": "不限"
            },
            {
                "value": "合肥市",
                "label": "合肥",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "蜀山",
                        "value": "蜀山区"
                    },
                    {
                        "label": "包河",
                        "value": "包河区"
                    },
                    {
                        "label": "瑶海",
                        "value": "瑶海区"
                    },
                    {
                        "label": "庐阳",
                        "value": "庐阳区"
                    },
                    {
                        "label": "肥西",
                        "value": "肥西县"
                    },
                    {
                        "label": "肥东",
                        "value": "肥东县"
                    },
                    {
                        "label": "长丰",
                        "value": "长丰县"
                    },
                    {
                        "label": "巢湖",
                        "value": "巢湖市"
                    },
                    {
                        "label": "庐江",
                        "value": "庐江县"
                    },
                    {
                        "label": "合肥",
                        "value": "合肥市"
                    }
                ]
            },
            {
                "value": "阜阳市",
                "label": "阜阳",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "颍州",
                        "value": "颍州区"
                    },
                    {
                        "label": "临泉",
                        "value": "临泉县"
                    },
                    {
                        "label": "颍泉",
                        "value": "颍泉区"
                    },
                    {
                        "label": "太和",
                        "value": "太和县"
                    },
                    {
                        "label": "颍上",
                        "value": "颍上县"
                    },
                    {
                        "label": "界首",
                        "value": "界首市"
                    },
                    {
                        "label": "阜南",
                        "value": "阜南县"
                    },
                    {
                        "label": "颍东",
                        "value": "颍东区"
                    },
                    {
                        "label": "阜阳",
                        "value": "阜阳市"
                    }
                ]
            },
            {
                "value": "亳州市",
                "label": "亳州",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "谯城",
                        "value": "谯城区"
                    },
                    {
                        "label": "蒙城",
                        "value": "蒙城县"
                    },
                    {
                        "label": "涡阳",
                        "value": "涡阳县"
                    },
                    {
                        "label": "利辛",
                        "value": "利辛县"
                    },
                    {
                        "label": "亳州",
                        "value": "亳州市"
                    }
                ]
            },
            {
                "value": "安庆市",
                "label": "安庆",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "桐城",
                        "value": "桐城市"
                    },
                    {
                        "label": "宜秀",
                        "value": "宜秀区"
                    },
                    {
                        "label": "潜山",
                        "value": "潜山县"
                    },
                    {
                        "label": "太湖",
                        "value": "太湖县"
                    },
                    {
                        "label": "岳西",
                        "value": "岳西县"
                    },
                    {
                        "label": "迎江",
                        "value": "迎江区"
                    },
                    {
                        "label": "怀宁",
                        "value": "怀宁县"
                    },
                    {
                        "label": "宿松",
                        "value": "宿松县"
                    },
                    {
                        "label": "大观",
                        "value": "大观区"
                    },
                    {
                        "label": "望江",
                        "value": "望江县"
                    },
                    {
                        "label": "安庆",
                        "value": "安庆市"
                    }
                ]
            },
            {
                "value": "芜湖市",
                "label": "芜湖",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "镜湖",
                        "value": "镜湖区"
                    },
                    {
                        "label": "鸠江",
                        "value": "鸠江区"
                    },
                    {
                        "label": "无为",
                        "value": "无为县"
                    },
                    {
                        "label": "弋江",
                        "value": "弋江区"
                    },
                    {
                        "label": "芜湖",
                        "value": "芜湖县"
                    },
                    {
                        "label": "南陵",
                        "value": "南陵县"
                    },
                    {
                        "label": "繁昌",
                        "value": "繁昌县"
                    },
                    {
                        "label": "三山",
                        "value": "三山区"
                    },
                    {
                        "label": "芜湖",
                        "value": "芜湖市"
                    }
                ]
            },
            {
                "value": "六安市",
                "label": "六安",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "裕安",
                        "value": "裕安区"
                    },
                    {
                        "label": "金安",
                        "value": "金安区"
                    },
                    {
                        "label": "霍邱",
                        "value": "霍邱县"
                    },
                    {
                        "label": "金寨",
                        "value": "金寨县"
                    },
                    {
                        "label": "舒城",
                        "value": "舒城县"
                    },
                    {
                        "label": "霍山",
                        "value": "霍山县"
                    },
                    {
                        "label": "叶集",
                        "value": "叶集区"
                    },
                    {
                        "label": "六安",
                        "value": "六安市"
                    }
                ]
            },
            {
                "value": "滁州市",
                "label": "滁州",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "天长",
                        "value": "天长市"
                    },
                    {
                        "label": "琅琊",
                        "value": "琅琊区"
                    },
                    {
                        "label": "凤阳",
                        "value": "凤阳县"
                    },
                    {
                        "label": "定远",
                        "value": "定远县"
                    },
                    {
                        "label": "南谯",
                        "value": "南谯区"
                    },
                    {
                        "label": "全椒",
                        "value": "全椒县"
                    },
                    {
                        "label": "明光",
                        "value": "明光市"
                    },
                    {
                        "label": "来安",
                        "value": "来安县"
                    },
                    {
                        "label": "滁州",
                        "value": "滁州市"
                    }
                ]
            },
            {
                "value": "宿州市",
                "label": "宿州",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "埇桥",
                        "value": "埇桥区"
                    },
                    {
                        "label": "砀山",
                        "value": "砀山县"
                    },
                    {
                        "label": "灵璧",
                        "value": "灵璧县"
                    },
                    {
                        "label": "萧县",
                        "value": "萧县"
                    },
                    {
                        "label": "泗县",
                        "value": "泗县"
                    },
                    {
                        "label": "宿州",
                        "value": "宿州市"
                    }
                ]
            },
            {
                "value": "蚌埠市",
                "label": "蚌埠",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "蚌山",
                        "value": "蚌山区"
                    },
                    {
                        "label": "怀远",
                        "value": "怀远县"
                    },
                    {
                        "label": "五河",
                        "value": "五河县"
                    },
                    {
                        "label": "禹会",
                        "value": "禹会区"
                    },
                    {
                        "label": "龙子湖",
                        "value": "龙子湖区"
                    },
                    {
                        "label": "固镇",
                        "value": "固镇县"
                    },
                    {
                        "label": "淮上",
                        "value": "淮上区"
                    },
                    {
                        "label": "蚌埠",
                        "value": "蚌埠市"
                    }
                ]
            },
            {
                "value": "马鞍山市",
                "label": "马鞍山",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "花山",
                        "value": "花山区"
                    },
                    {
                        "label": "雨山",
                        "value": "雨山区"
                    },
                    {
                        "label": "当涂",
                        "value": "当涂县"
                    },
                    {
                        "label": "博望",
                        "value": "博望区"
                    },
                    {
                        "label": "和县",
                        "value": "和县"
                    },
                    {
                        "label": "含山",
                        "value": "含山县"
                    },
                    {
                        "label": "马鞍山",
                        "value": "马鞍山市"
                    }
                ]
            },
            {
                "value": "宣城市",
                "label": "宣城",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "宣州",
                        "value": "宣州区"
                    },
                    {
                        "label": "广德",
                        "value": "广德县"
                    },
                    {
                        "label": "宁国",
                        "value": "宁国市"
                    },
                    {
                        "label": "郎溪",
                        "value": "郎溪县"
                    },
                    {
                        "label": "泾县",
                        "value": "泾县"
                    },
                    {
                        "label": "绩溪",
                        "value": "绩溪县"
                    },
                    {
                        "label": "旌德",
                        "value": "旌德县"
                    },
                    {
                        "label": "宣城",
                        "value": "宣城市"
                    }
                ]
            },
            {
                "value": "淮南市",
                "label": "淮南",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "田家庵",
                        "value": "田家庵区"
                    },
                    {
                        "label": "凤台",
                        "value": "凤台县"
                    },
                    {
                        "label": "寿县",
                        "value": "寿县"
                    },
                    {
                        "label": "潘集",
                        "value": "潘集区"
                    },
                    {
                        "label": "大通",
                        "value": "大通区"
                    },
                    {
                        "label": "谢家集",
                        "value": "谢家集区"
                    },
                    {
                        "label": "八公山",
                        "value": "八公山区"
                    },
                    {
                        "label": "淮南",
                        "value": "淮南市"
                    }
                ]
            },
            {
                "value": "淮北市",
                "label": "淮北",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "相山",
                        "value": "相山区"
                    },
                    {
                        "label": "濉溪",
                        "value": "濉溪县"
                    },
                    {
                        "label": "杜集",
                        "value": "杜集区"
                    },
                    {
                        "label": "烈山",
                        "value": "烈山区"
                    },
                    {
                        "label": "淮北",
                        "value": "淮北市"
                    }
                ]
            },
            {
                "value": "黄山市",
                "label": "黄山",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "屯溪",
                        "value": "屯溪区"
                    },
                    {
                        "label": "歙县",
                        "value": "歙县"
                    },
                    {
                        "label": "黄山",
                        "value": "黄山区"
                    },
                    {
                        "label": "休宁",
                        "value": "休宁县"
                    },
                    {
                        "label": "徽州",
                        "value": "徽州区"
                    },
                    {
                        "label": "祁门",
                        "value": "祁门县"
                    },
                    {
                        "label": "黟县",
                        "value": "黟县"
                    },
                    {
                        "label": "黄山",
                        "value": "黄山市"
                    }
                ]
            },
            {
                "value": "铜陵市",
                "label": "铜陵",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "铜官",
                        "value": "铜官区"
                    },
                    {
                        "label": "枞阳",
                        "value": "枞阳县"
                    },
                    {
                        "label": "义安",
                        "value": "义安区"
                    },
                    {
                        "label": "郊区",
                        "value": "郊区"
                    },
                    {
                        "label": "铜陵",
                        "value": "铜陵市"
                    },
                    {
                        "label": "铜陵",
                        "value": "铜陵县"
                    }
                ]
            },
            {
                "value": "池州市",
                "label": "池州",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "贵池",
                        "value": "贵池区"
                    },
                    {
                        "label": "青阳",
                        "value": "青阳县"
                    },
                    {
                        "label": "东至",
                        "value": "东至县"
                    },
                    {
                        "label": "石台",
                        "value": "石台县"
                    },
                    {
                        "label": "池州",
                        "value": "池州市"
                    }
                ]
            },
            {
                "value": "安徽省",
                "label": "安徽",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "安徽",
                        "value": "安徽省"
                    }
                ]
            }
        ]
    },
    {
        "value": "湖北省",
        "label": "湖北",
        "children": [
    {
        "label": "不限",
        "value": "不限"
    },
            {
                "value": "武汉市",
                "label": "武汉",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "洪山",
                        "value": "洪山区"
                    },
                    {
                        "label": "武昌",
                        "value": "武昌区"
                    },
                    {
                        "label": "东西湖",
                        "value": "东西湖区"
                    },
                    {
                        "label": "江岸",
                        "value": "江岸区"
                    },
                    {
                        "label": "江夏",
                        "value": "江夏区"
                    },
                    {
                        "label": "江汉",
                        "value": "江汉区"
                    },
                    {
                        "label": "硚口",
                        "value": "硚口区"
                    },
                    {
                        "label": "汉阳",
                        "value": "汉阳区"
                    },
                    {
                        "label": "蔡甸",
                        "value": "蔡甸区"
                    },
                    {
                        "label": "黄陂",
                        "value": "黄陂区"
                    },
                    {
                        "label": "青山",
                        "value": "青山区"
                    },
                    {
                        "label": "新洲",
                        "value": "新洲区"
                    },
                    {
                        "label": "汉南",
                        "value": "汉南区"
                    },
                    {
                        "label": "武汉",
                        "value": "武汉市"
                    }
                ]
            },
            {
                "value": "襄阳市",
                "label": "襄阳",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "樊城",
                        "value": "樊城区"
                    },
                    {
                        "label": "襄州",
                        "value": "襄州区"
                    },
                    {
                        "label": "枣阳",
                        "value": "枣阳市"
                    },
                    {
                        "label": "襄城",
                        "value": "襄城区"
                    },
                    {
                        "label": "老河口",
                        "value": "老河口市"
                    },
                    {
                        "label": "宜城",
                        "value": "宜城市"
                    },
                    {
                        "label": "谷城",
                        "value": "谷城县"
                    },
                    {
                        "label": "南漳",
                        "value": "南漳县"
                    },
                    {
                        "label": "保康",
                        "value": "保康县"
                    },
                    {
                        "label": "襄阳",
                        "value": "襄阳市"
                    }
                ]
            },
            {
                "value": "黄冈市",
                "label": "黄冈",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "武穴",
                        "value": "武穴市"
                    },
                    {
                        "label": "黄州",
                        "value": "黄州区"
                    },
                    {
                        "label": "黄梅",
                        "value": "黄梅县"
                    },
                    {
                        "label": "浠水",
                        "value": "浠水县"
                    },
                    {
                        "label": "蕲春",
                        "value": "蕲春县"
                    },
                    {
                        "label": "麻城",
                        "value": "麻城市"
                    },
                    {
                        "label": "红安",
                        "value": "红安县"
                    },
                    {
                        "label": "团风",
                        "value": "团风县"
                    },
                    {
                        "label": "罗田",
                        "value": "罗田县"
                    },
                    {
                        "label": "英山",
                        "value": "英山县"
                    },
                    {
                        "label": "黄冈",
                        "value": "黄冈市"
                    }
                ]
            },
            {
                "value": "宜昌市",
                "label": "宜昌",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "西陵",
                        "value": "西陵区"
                    },
                    {
                        "label": "伍家岗",
                        "value": "伍家岗区"
                    },
                    {
                        "label": "夷陵",
                        "value": "夷陵区"
                    },
                    {
                        "label": "枝江",
                        "value": "枝江市"
                    },
                    {
                        "label": "宜都",
                        "value": "宜都市"
                    },
                    {
                        "label": "当阳",
                        "value": "当阳市"
                    },
                    {
                        "label": "长阳",
                        "value": "长阳土家族自治县"
                    },
                    {
                        "label": "秭归",
                        "value": "秭归县"
                    },
                    {
                        "label": "兴山",
                        "value": "兴山县"
                    },
                    {
                        "label": "五峰",
                        "value": "五峰土家族自治县"
                    },
                    {
                        "label": "远安",
                        "value": "远安县"
                    },
                    {
                        "label": "点军",
                        "value": "点军区"
                    },
                    {
                        "label": "猇亭",
                        "value": "猇亭区"
                    },
                    {
                        "label": "宜昌",
                        "value": "宜昌市"
                    }
                ]
            },
            {
                "value": "十堰市",
                "label": "十堰",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "茅箭",
                        "value": "茅箭区"
                    },
                    {
                        "label": "张湾",
                        "value": "张湾区"
                    },
                    {
                        "label": "丹江口",
                        "value": "丹江口市"
                    },
                    {
                        "label": "竹溪",
                        "value": "竹溪县"
                    },
                    {
                        "label": "郧西",
                        "value": "郧西县"
                    },
                    {
                        "label": "房县",
                        "value": "房县"
                    },
                    {
                        "label": "郧阳",
                        "value": "郧阳区"
                    },
                    {
                        "label": "竹山",
                        "value": "竹山县"
                    },
                    {
                        "label": "十堰",
                        "value": "十堰市"
                    },
                    {
                        "label": "郧县",
                        "value": "郧县"
                    }
                ]
            },
            {
                "value": "荆州市",
                "label": "荆州",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "沙市",
                        "value": "沙市区"
                    },
                    {
                        "label": "荆州",
                        "value": "荆州区"
                    },
                    {
                        "label": "公安",
                        "value": "公安县"
                    },
                    {
                        "label": "监利",
                        "value": "监利县"
                    },
                    {
                        "label": "洪湖",
                        "value": "洪湖市"
                    },
                    {
                        "label": "松滋",
                        "value": "松滋市"
                    },
                    {
                        "label": "石首",
                        "value": "石首市"
                    },
                    {
                        "label": "江陵",
                        "value": "江陵县"
                    },
                    {
                        "label": "荆州",
                        "value": "荆州市"
                    }
                ]
            },
            {
                "value": "恩施土家族苗族自治州",
                "label": "恩施",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "恩施",
                        "value": "恩施市"
                    },
                    {
                        "label": "利川",
                        "value": "利川市"
                    },
                    {
                        "label": "巴东",
                        "value": "巴东县"
                    },
                    {
                        "label": "建始",
                        "value": "建始县"
                    },
                    {
                        "label": "咸丰",
                        "value": "咸丰县"
                    },
                    {
                        "label": "宣恩",
                        "value": "宣恩县"
                    },
                    {
                        "label": "来凤",
                        "value": "来凤县"
                    },
                    {
                        "label": "鹤峰",
                        "value": "鹤峰县"
                    },
                    {
                        "label": "恩施",
                        "value": "恩施土家族苗族自治州"
                    }
                ]
            },
            {
                "value": "孝感市",
                "label": "孝感",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "孝南",
                        "value": "孝南区"
                    },
                    {
                        "label": "汉川",
                        "value": "汉川市"
                    },
                    {
                        "label": "应城",
                        "value": "应城市"
                    },
                    {
                        "label": "大悟",
                        "value": "大悟县"
                    },
                    {
                        "label": "孝昌",
                        "value": "孝昌县"
                    },
                    {
                        "label": "安陆",
                        "value": "安陆市"
                    },
                    {
                        "label": "云梦",
                        "value": "云梦县"
                    },
                    {
                        "label": "孝感",
                        "value": "孝感市"
                    }
                ]
            },
            {
                "value": "黄石市",
                "label": "黄石",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "大冶",
                        "value": "大冶市"
                    },
                    {
                        "label": "阳新",
                        "value": "阳新县"
                    },
                    {
                        "label": "黄石港",
                        "value": "黄石港区"
                    },
                    {
                        "label": "下陆",
                        "value": "下陆区"
                    },
                    {
                        "label": "西塞山",
                        "value": "西塞山区"
                    },
                    {
                        "label": "铁山",
                        "value": "铁山区"
                    },
                    {
                        "label": "黄石",
                        "value": "黄石市"
                    }
                ]
            },
            {
                "value": "荆门市",
                "label": "荆门",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "钟祥",
                        "value": "钟祥市"
                    },
                    {
                        "label": "东宝",
                        "value": "东宝区"
                    },
                    {
                        "label": "掇刀",
                        "value": "掇刀区"
                    },
                    {
                        "label": "京山",
                        "value": "京山县"
                    },
                    {
                        "label": "沙洋",
                        "value": "沙洋县"
                    },
                    {
                        "label": "荆门",
                        "value": "荆门市"
                    }
                ]
            },
            {
                "value": "咸宁市",
                "label": "咸宁",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "咸安",
                        "value": "咸安区"
                    },
                    {
                        "label": "通山",
                        "value": "通山县"
                    },
                    {
                        "label": "赤壁",
                        "value": "赤壁市"
                    },
                    {
                        "label": "通城",
                        "value": "通城县"
                    },
                    {
                        "label": "崇阳",
                        "value": "崇阳县"
                    },
                    {
                        "label": "嘉鱼",
                        "value": "嘉鱼县"
                    },
                    {
                        "label": "咸宁",
                        "value": "咸宁市"
                    }
                ]
            },
            {
                "value": "随州市",
                "label": "随州",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "曾都",
                        "value": "曾都区"
                    },
                    {
                        "label": "广水",
                        "value": "广水市"
                    },
                    {
                        "label": "随县",
                        "value": "随县"
                    },
                    {
                        "label": "随州",
                        "value": "随州市"
                    }
                ]
            },
            {
                "value": "鄂州市",
                "label": "鄂州",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "鄂城",
                        "value": "鄂城区"
                    },
                    {
                        "label": "华容",
                        "value": "华容区"
                    },
                    {
                        "label": "梁子湖",
                        "value": "梁子湖区"
                    },
                    {
                        "label": "鄂州",
                        "value": "鄂州市"
                    }
                ]
            },
            {
                "value": "1",
                "label": "仙桃",
                "children": [
                    {
                        "label": "不限",
                        "value": "仙桃市"
                    } 
                ]
            }, 
            {
                "value": "2",
                "label": "天门",
                "children": [
                    {
                        "label": "不限",
                        "value": "天门市"
                    } 
                ]
            }, 
            {
                "value": "3",
                "label": "潜江",
                "children": [
                    {
                        "label": "不限",
                        "value": "潜江市"
                    } 
                ]
            }, 
            {
                "value": "4",
                "label": "神农架林",
                "children": [
                    {
                        "label": "不限",
                        "value": "神农架林区"
                    } 
                ]
            }, 
            {
                "value": "湖北省",
                "label": "湖北",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "湖北",
                        "value": "湖北省"
                    }
                ]
            }
        ]
    },
    {
        "value": "福建省",
        "label": "福建",
        "children": [
    {
        "label": "不限",
        "value": "不限"
    },
            {
                "value": "厦门市",
                "label": "厦门",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "湖里",
                        "value": "湖里区"
                    },
                    {
                        "label": "思明",
                        "value": "思明区"
                    },
                    {
                        "label": "集美",
                        "value": "集美区"
                    },
                    {
                        "label": "海沧",
                        "value": "海沧区"
                    },
                    {
                        "label": "同安",
                        "value": "同安区"
                    },
                    {
                        "label": "翔安",
                        "value": "翔安区"
                    },
                    {
                        "label": "厦门",
                        "value": "厦门市"
                    }
                ]
            },
            {
                "value": "福州市",
                "label": "福州",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "鼓楼",
                        "value": "鼓楼区"
                    },
                    {
                        "label": "仓山",
                        "value": "仓山区"
                    },
                    {
                        "label": "晋安",
                        "value": "晋安区"
                    },
                    {
                        "label": "台江",
                        "value": "台江区"
                    },
                    {
                        "label": "马尾",
                        "value": "马尾区"
                    },
                    {
                        "label": "福清",
                        "value": "福清市"
                    },
                    {
                        "label": "闽侯",
                        "value": "闽侯县"
                    },
                    {
                        "label": "平潭",
                        "value": "平潭县"
                    },
                    {
                        "label": "长乐",
                        "value": "长乐区"
                    },
                    {
                        "label": "连江",
                        "value": "连江县"
                    },
                    {
                        "label": "闽清",
                        "value": "闽清县"
                    },
                    {
                        "label": "永泰",
                        "value": "永泰县"
                    },
                    {
                        "label": "罗源",
                        "value": "罗源县"
                    },
                    {
                        "label": "长乐",
                        "value": "长乐市"
                    },
                    {
                        "label": "福州",
                        "value": "福州市"
                    }
                ]
            },
            {
                "value": "泉州市",
                "label": "泉州",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "晋江",
                        "value": "晋江市"
                    },
                    {
                        "label": "丰泽",
                        "value": "丰泽区"
                    },
                    {
                        "label": "南安",
                        "value": "南安市"
                    },
                    {
                        "label": "石狮",
                        "value": "石狮市"
                    },
                    {
                        "label": "安溪",
                        "value": "安溪县"
                    },
                    {
                        "label": "鲤城",
                        "value": "鲤城区"
                    },
                    {
                        "label": "惠安",
                        "value": "惠安县"
                    },
                    {
                        "label": "德化",
                        "value": "德化县"
                    },
                    {
                        "label": "洛江",
                        "value": "洛江区"
                    },
                    {
                        "label": "永春",
                        "value": "永春县"
                    },
                    {
                        "label": "泉港",
                        "value": "泉港区"
                    },
                    {
                        "label": "泉州",
                        "value": "泉州市"
                    }
                ]
            },
            {
                "value": "漳州市",
                "label": "漳州",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "芗城",
                        "value": "芗城区"
                    },
                    {
                        "label": "龙海",
                        "value": "龙海市"
                    },
                    {
                        "label": "漳浦",
                        "value": "漳浦县"
                    },
                    {
                        "label": "龙文",
                        "value": "龙文区"
                    },
                    {
                        "label": "平和",
                        "value": "平和县"
                    },
                    {
                        "label": "南靖",
                        "value": "南靖县"
                    },
                    {
                        "label": "长泰",
                        "value": "长泰县"
                    },
                    {
                        "label": "云霄",
                        "value": "云霄县"
                    },
                    {
                        "label": "东山",
                        "value": "东山县"
                    },
                    {
                        "label": "诏安",
                        "value": "诏安县"
                    },
                    {
                        "label": "华安",
                        "value": "华安县"
                    },
                    {
                        "label": "漳州",
                        "value": "漳州市"
                    }
                ]
            },
            {
                "value": "莆田市",
                "label": "莆田",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "荔城",
                        "value": "荔城区"
                    },
                    {
                        "label": "城厢",
                        "value": "城厢区"
                    },
                    {
                        "label": "仙游",
                        "value": "仙游县"
                    },
                    {
                        "label": "涵江",
                        "value": "涵江区"
                    },
                    {
                        "label": "秀屿",
                        "value": "秀屿区"
                    },
                    {
                        "label": "莆田",
                        "value": "莆田市"
                    }
                ]
            },
            {
                "value": "宁德市",
                "label": "宁德",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "蕉城",
                        "value": "蕉城区"
                    },
                    {
                        "label": "福安",
                        "value": "福安市"
                    },
                    {
                        "label": "福鼎",
                        "value": "福鼎市"
                    },
                    {
                        "label": "霞浦",
                        "value": "霞浦县"
                    },
                    {
                        "label": "古田",
                        "value": "古田县"
                    },
                    {
                        "label": "柘荣",
                        "value": "柘荣县"
                    },
                    {
                        "label": "屏南",
                        "value": "屏南县"
                    },
                    {
                        "label": "寿宁",
                        "value": "寿宁县"
                    },
                    {
                        "label": "周宁",
                        "value": "周宁县"
                    },
                    {
                        "label": "宁德",
                        "value": "宁德市"
                    }
                ]
            },
            {
                "value": "南平市",
                "label": "南平",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "延平",
                        "value": "延平区"
                    },
                    {
                        "label": "武夷山",
                        "value": "武夷山市"
                    },
                    {
                        "label": "建阳",
                        "value": "建阳区"
                    },
                    {
                        "label": "建瓯",
                        "value": "建瓯市"
                    },
                    {
                        "label": "邵武",
                        "value": "邵武市"
                    },
                    {
                        "label": "浦城",
                        "value": "浦城县"
                    },
                    {
                        "label": "政和",
                        "value": "政和县"
                    },
                    {
                        "label": "松溪",
                        "value": "松溪县"
                    },
                    {
                        "label": "顺昌",
                        "value": "顺昌县"
                    },
                    {
                        "label": "光泽",
                        "value": "光泽县"
                    },
                    {
                        "label": "南平",
                        "value": "南平市"
                    }
                ]
            },
            {
                "value": "三明市",
                "label": "三明",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "梅列",
                        "value": "梅列区"
                    },
                    {
                        "label": "永安",
                        "value": "永安市"
                    },
                    {
                        "label": "三元",
                        "value": "三元区"
                    },
                    {
                        "label": "沙县",
                        "value": "沙县"
                    },
                    {
                        "label": "大田",
                        "value": "大田县"
                    },
                    {
                        "label": "尤溪",
                        "value": "尤溪县"
                    },
                    {
                        "label": "宁化",
                        "value": "宁化县"
                    },
                    {
                        "label": "将乐",
                        "value": "将乐县"
                    },
                    {
                        "label": "清流",
                        "value": "清流县"
                    },
                    {
                        "label": "建宁",
                        "value": "建宁县"
                    },
                    {
                        "label": "泰宁",
                        "value": "泰宁县"
                    },
                    {
                        "label": "明溪",
                        "value": "明溪县"
                    },
                    {
                        "label": "三明",
                        "value": "三明市"
                    }
                ]
            },
            {
                "value": "龙岩市",
                "label": "龙岩",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "新罗",
                        "value": "新罗区"
                    },
                    {
                        "label": "长汀",
                        "value": "长汀县"
                    },
                    {
                        "label": "上杭",
                        "value": "上杭县"
                    },
                    {
                        "label": "永定",
                        "value": "永定区"
                    },
                    {
                        "label": "连城",
                        "value": "连城县"
                    },
                    {
                        "label": "武平",
                        "value": "武平县"
                    },
                    {
                        "label": "漳平",
                        "value": "漳平市"
                    },
                    {
                        "label": "龙岩",
                        "value": "龙岩市"
                    }
                ]
            },
            {
                "value": "福建省",
                "label": "福建",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "福建",
                        "value": "福建省"
                    }
                ]
            }
        ]
    },
    {
        "value": "辽宁省",
        "label": "辽宁",
        "children": [
    {
        "label": "不限",
        "value": "不限"
    },
            {
                "value": "沈阳市",
                "label": "沈阳",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "铁西",
                        "value": "铁西区"
                    },
                    {
                        "label": "浑南",
                        "value": "浑南区"
                    },
                    {
                        "label": "和平",
                        "value": "和平区"
                    },
                    {
                        "label": "沈河",
                        "value": "沈河区"
                    },
                    {
                        "label": "于洪",
                        "value": "于洪区"
                    },
                    {
                        "label": "皇姑",
                        "value": "皇姑区"
                    },
                    {
                        "label": "大东",
                        "value": "大东区"
                    },
                    {
                        "label": "法库",
                        "value": "法库县"
                    },
                    {
                        "label": "沈北新",
                        "value": "沈北新区"
                    },
                    {
                        "label": "苏家屯",
                        "value": "苏家屯区"
                    },
                    {
                        "label": "新民",
                        "value": "新民市"
                    },
                    {
                        "label": "康平",
                        "value": "康平县"
                    },
                    {
                        "label": "辽中",
                        "value": "辽中区"
                    },
                    {
                        "label": "沈阳",
                        "value": "沈阳市"
                    },
                    {
                        "label": "辽中",
                        "value": "辽中县"
                    }
                ]
            },
            {
                "value": "大连市",
                "label": "大连",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "金州",
                        "value": "金州区"
                    },
                    {
                        "label": "甘井子",
                        "value": "甘井子区"
                    },
                    {
                        "label": "沙河口",
                        "value": "沙河口区"
                    },
                    {
                        "label": "中山",
                        "value": "中山区"
                    },
                    {
                        "label": "西岗",
                        "value": "西岗区"
                    },
                    {
                        "label": "庄河",
                        "value": "庄河市"
                    },
                    {
                        "label": "瓦房店",
                        "value": "瓦房店市"
                    },
                    {
                        "label": "普兰店",
                        "value": "普兰店区"
                    },
                    {
                        "label": "旅顺口",
                        "value": "旅顺口区"
                    },
                    {
                        "label": "长海",
                        "value": "长海县"
                    },
                    {
                        "label": "大连",
                        "value": "大连市"
                    }
                ]
            },
            {
                "value": "营口市",
                "label": "营口",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "鲅鱼圈",
                        "value": "鲅鱼圈区"
                    },
                    {
                        "label": "站前",
                        "value": "站前区"
                    },
                    {
                        "label": "盖州",
                        "value": "盖州市"
                    },
                    {
                        "label": "西市",
                        "value": "西市区"
                    },
                    {
                        "label": "大石桥",
                        "value": "大石桥市"
                    },
                    {
                        "label": "老边",
                        "value": "老边区"
                    },
                    {
                        "label": "营口",
                        "value": "营口市"
                    }
                ]
            },
            {
                "value": "鞍山市",
                "label": "鞍山",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "海城",
                        "value": "海城市"
                    },
                    {
                        "label": "铁东",
                        "value": "铁东区"
                    },
                    {
                        "label": "千山",
                        "value": "千山区"
                    },
                    {
                        "label": "铁西",
                        "value": "铁西区"
                    },
                    {
                        "label": "立山",
                        "value": "立山区"
                    },
                    {
                        "label": "岫岩",
                        "value": "岫岩满族自治县"
                    },
                    {
                        "label": "台安",
                        "value": "台安县"
                    },
                    {
                        "label": "鞍山",
                        "value": "鞍山市"
                    }
                ]
            },
            {
                "value": "锦州市",
                "label": "锦州",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "太和",
                        "value": "太和区"
                    },
                    {
                        "label": "黑山",
                        "value": "黑山县"
                    },
                    {
                        "label": "凌海",
                        "value": "凌海市"
                    },
                    {
                        "label": "凌河",
                        "value": "凌河区"
                    },
                    {
                        "label": "北镇",
                        "value": "北镇市"
                    },
                    {
                        "label": "古塔",
                        "value": "古塔区"
                    },
                    {
                        "label": "义县",
                        "value": "义县"
                    },
                    {
                        "label": "锦州",
                        "value": "锦州市"
                    }
                ]
            },
            {
                "value": "朝阳市",
                "label": "朝阳",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "双塔",
                        "value": "双塔区"
                    },
                    {
                        "label": "凌源",
                        "value": "凌源市"
                    },
                    {
                        "label": "建平",
                        "value": "建平县"
                    },
                    {
                        "label": "北票",
                        "value": "北票市"
                    },
                    {
                        "label": "龙城",
                        "value": "龙城区"
                    },
                    {
                        "label": "朝阳",
                        "value": "朝阳县"
                    },
                    {
                        "label": "喀喇沁左翼",
                        "value": "喀喇沁左翼蒙古族自治县"
                    },
                    {
                        "label": "朝阳",
                        "value": "朝阳市"
                    }
                ]
            },
            {
                "value": "丹东市",
                "label": "丹东",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "振兴",
                        "value": "振兴区"
                    },
                    {
                        "label": "东港",
                        "value": "东港市"
                    },
                    {
                        "label": "凤城",
                        "value": "凤城市"
                    },
                    {
                        "label": "元宝",
                        "value": "元宝区"
                    },
                    {
                        "label": "宽甸",
                        "value": "宽甸满族自治县"
                    },
                    {
                        "label": "振安",
                        "value": "振安区"
                    },
                    {
                        "label": "丹东",
                        "value": "丹东市"
                    }
                ]
            },
            {
                "value": "葫芦岛市",
                "label": "葫芦岛",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "兴城",
                        "value": "兴城市"
                    },
                    {
                        "label": "绥中",
                        "value": "绥中县"
                    },
                    {
                        "label": "连山",
                        "value": "连山区"
                    },
                    {
                        "label": "龙港",
                        "value": "龙港区"
                    },
                    {
                        "label": "建昌",
                        "value": "建昌县"
                    },
                    {
                        "label": "南票",
                        "value": "南票区"
                    },
                    {
                        "label": "葫芦岛",
                        "value": "葫芦岛市"
                    }
                ]
            },
            {
                "value": "铁岭市",
                "label": "铁岭",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "昌图",
                        "value": "昌图县"
                    },
                    {
                        "label": "铁岭",
                        "value": "铁岭县"
                    },
                    {
                        "label": "银州",
                        "value": "银州区"
                    },
                    {
                        "label": "开原",
                        "value": "开原市"
                    },
                    {
                        "label": "西丰",
                        "value": "西丰县"
                    },
                    {
                        "label": "调兵山",
                        "value": "调兵山市"
                    },
                    {
                        "label": "清河",
                        "value": "清河区"
                    },
                    {
                        "label": "铁岭",
                        "value": "铁岭市"
                    }
                ]
            },
            {
                "value": "抚顺市",
                "label": "抚顺",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "望花",
                        "value": "望花区"
                    },
                    {
                        "label": "顺城",
                        "value": "顺城区"
                    },
                    {
                        "label": "新宾",
                        "value": "新宾满族自治县"
                    },
                    {
                        "label": "新抚",
                        "value": "新抚区"
                    },
                    {
                        "label": "清原",
                        "value": "清原满族自治县"
                    },
                    {
                        "label": "东洲",
                        "value": "东洲区"
                    },
                    {
                        "label": "抚顺",
                        "value": "抚顺县"
                    },
                    {
                        "label": "抚顺",
                        "value": "抚顺市"
                    }
                ]
            },
            {
                "value": "阜新市",
                "label": "阜新",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "阜新",
                        "value": "阜新蒙古族自治县"
                    },
                    {
                        "label": "彰武",
                        "value": "彰武县"
                    },
                    {
                        "label": "细河",
                        "value": "细河区"
                    },
                    {
                        "label": "海州",
                        "value": "海州区"
                    },
                    {
                        "label": "太平",
                        "value": "太平区"
                    },
                    {
                        "label": "新邱",
                        "value": "新邱区"
                    },
                    {
                        "label": "清河门",
                        "value": "清河门区"
                    },
                    {
                        "label": "阜新",
                        "value": "阜新市"
                    }
                ]
            },
            {
                "value": "辽阳市",
                "label": "辽阳",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "灯塔",
                        "value": "灯塔市"
                    },
                    {
                        "label": "白塔",
                        "value": "白塔区"
                    },
                    {
                        "label": "辽阳",
                        "value": "辽阳县"
                    },
                    {
                        "label": "文圣",
                        "value": "文圣区"
                    },
                    {
                        "label": "太子河",
                        "value": "太子河区"
                    },
                    {
                        "label": "宏伟",
                        "value": "宏伟区"
                    },
                    {
                        "label": "弓长岭",
                        "value": "弓长岭区"
                    },
                    {
                        "label": "辽阳",
                        "value": "辽阳市"
                    }
                ]
            },
            {
                "value": "盘锦市",
                "label": "盘锦",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "兴隆台",
                        "value": "兴隆台区"
                    },
                    {
                        "label": "大洼",
                        "value": "大洼区"
                    },
                    {
                        "label": "盘山",
                        "value": "盘山县"
                    },
                    {
                        "label": "双台子",
                        "value": "双台子区"
                    },
                    {
                        "label": "大洼",
                        "value": "大洼县"
                    },
                    {
                        "label": "盘锦",
                        "value": "盘锦市"
                    }
                ]
            },
            {
                "value": "本溪市",
                "label": "本溪",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "明山",
                        "value": "明山区"
                    },
                    {
                        "label": "平山",
                        "value": "平山区"
                    },
                    {
                        "label": "溪湖",
                        "value": "溪湖区"
                    },
                    {
                        "label": "桓仁",
                        "value": "桓仁满族自治县"
                    },
                    {
                        "label": "本溪",
                        "value": "本溪满族自治县"
                    },
                    {
                        "label": "南芬",
                        "value": "南芬区"
                    },
                    {
                        "label": "本溪",
                        "value": "本溪市"
                    }
                ]
            }
        ]
    },
    {
        "value": "湖南省",
        "label": "湖南",
        "children": [
    {
        "label": "不限",
        "value": "不限"
    },
            {
                "value": "长沙市",
                "label": "长沙",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "岳麓",
                        "value": "岳麓区"
                    },
                    {
                        "label": "雨花",
                        "value": "雨花区"
                    },
                    {
                        "label": "芙蓉",
                        "value": "芙蓉区"
                    },
                    {
                        "label": "开福",
                        "value": "开福区"
                    },
                    {
                        "label": "天心",
                        "value": "天心区"
                    },
                    {
                        "label": "长沙",
                        "value": "长沙县"
                    },
                    {
                        "label": "浏阳",
                        "value": "浏阳市"
                    },
                    {
                        "label": "望城",
                        "value": "望城区"
                    },
                    {
                        "label": "宁乡",
                        "value": "宁乡县"
                    },
                    {
                        "label": "长沙",
                        "value": "长沙市"
                    }
                ]
            },
            {
                "value": "株洲市",
                "label": "株洲",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "天元",
                        "value": "天元区"
                    },
                    {
                        "label": "醴陵",
                        "value": "醴陵市"
                    },
                    {
                        "label": "芦淞",
                        "value": "芦淞区"
                    },
                    {
                        "label": "荷塘",
                        "value": "荷塘区"
                    },
                    {
                        "label": "攸县",
                        "value": "攸县"
                    },
                    {
                        "label": "石峰",
                        "value": "石峰区"
                    },
                    {
                        "label": "茶陵",
                        "value": "茶陵县"
                    },
                    {
                        "label": "株洲",
                        "value": "株洲县"
                    },
                    {
                        "label": "炎陵",
                        "value": "炎陵县"
                    },
                    {
                        "label": "株洲",
                        "value": "株洲市"
                    }
                ]
            },
            {
                "value": "衡阳市",
                "label": "衡阳",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "蒸湘",
                        "value": "蒸湘区"
                    },
                    {
                        "label": "耒阳",
                        "value": "耒阳市"
                    },
                    {
                        "label": "祁东",
                        "value": "祁东县"
                    },
                    {
                        "label": "常宁",
                        "value": "常宁市"
                    },
                    {
                        "label": "衡南",
                        "value": "衡南县"
                    },
                    {
                        "label": "石鼓",
                        "value": "石鼓区"
                    },
                    {
                        "label": "雁峰",
                        "value": "雁峰区"
                    },
                    {
                        "label": "衡东",
                        "value": "衡东县"
                    },
                    {
                        "label": "衡阳",
                        "value": "衡阳县"
                    },
                    {
                        "label": "珠晖",
                        "value": "珠晖区"
                    },
                    {
                        "label": "衡山",
                        "value": "衡山县"
                    },
                    {
                        "label": "南岳",
                        "value": "南岳区"
                    },
                    {
                        "label": "衡阳",
                        "value": "衡阳市"
                    }
                ]
            },
            {
                "value": "邵阳市",
                "label": "邵阳",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "邵东",
                        "value": "邵东县"
                    },
                    {
                        "label": "双清",
                        "value": "双清区"
                    },
                    {
                        "label": "大祥",
                        "value": "大祥区"
                    },
                    {
                        "label": "隆回",
                        "value": "隆回县"
                    },
                    {
                        "label": "洞口",
                        "value": "洞口县"
                    },
                    {
                        "label": "邵阳",
                        "value": "邵阳县"
                    },
                    {
                        "label": "新邵",
                        "value": "新邵县"
                    },
                    {
                        "label": "武冈",
                        "value": "武冈市"
                    },
                    {
                        "label": "新宁",
                        "value": "新宁县"
                    },
                    {
                        "label": "绥宁",
                        "value": "绥宁县"
                    },
                    {
                        "label": "北塔",
                        "value": "北塔区"
                    },
                    {
                        "label": "城步",
                        "value": "城步苗族自治县"
                    },
                    {
                        "label": "邵阳",
                        "value": "邵阳市"
                    }
                ]
            },
            {
                "value": "常德市",
                "label": "常德",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "武陵",
                        "value": "武陵区"
                    },
                    {
                        "label": "鼎城",
                        "value": "鼎城区"
                    },
                    {
                        "label": "澧县",
                        "value": "澧县"
                    },
                    {
                        "label": "桃源",
                        "value": "桃源县"
                    },
                    {
                        "label": "汉寿",
                        "value": "汉寿县"
                    },
                    {
                        "label": "石门",
                        "value": "石门县"
                    },
                    {
                        "label": "临澧",
                        "value": "临澧县"
                    },
                    {
                        "label": "安乡",
                        "value": "安乡县"
                    },
                    {
                        "label": "津市",
                        "value": "津市市"
                    },
                    {
                        "label": "常德",
                        "value": "常德市"
                    }
                ]
            },
            {
                "value": "岳阳市",
                "label": "岳阳",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "岳阳楼",
                        "value": "岳阳楼区"
                    },
                    {
                        "label": "平江",
                        "value": "平江县"
                    },
                    {
                        "label": "汨罗",
                        "value": "汨罗市"
                    },
                    {
                        "label": "湘阴",
                        "value": "湘阴县"
                    },
                    {
                        "label": "岳阳",
                        "value": "岳阳县"
                    },
                    {
                        "label": "华容",
                        "value": "华容县"
                    },
                    {
                        "label": "临湘",
                        "value": "临湘市"
                    },
                    {
                        "label": "云溪",
                        "value": "云溪区"
                    },
                    {
                        "label": "君山",
                        "value": "君山区"
                    },
                    {
                        "label": "岳阳",
                        "value": "岳阳市"
                    }
                ]
            },
            {
                "value": "益阳市",
                "label": "益阳",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "赫山",
                        "value": "赫山区"
                    },
                    {
                        "label": "桃江",
                        "value": "桃江县"
                    },
                    {
                        "label": "安化",
                        "value": "安化县"
                    },
                    {
                        "label": "沅江",
                        "value": "沅江市"
                    },
                    {
                        "label": "南县",
                        "value": "南县"
                    },
                    {
                        "label": "资阳",
                        "value": "资阳区"
                    },
                    {
                        "label": "益阳",
                        "value": "益阳市"
                    }
                ]
            },
            {
                "value": "郴州市",
                "label": "郴州",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "北湖",
                        "value": "北湖区"
                    },
                    {
                        "label": "苏仙",
                        "value": "苏仙区"
                    },
                    {
                        "label": "桂阳",
                        "value": "桂阳县"
                    },
                    {
                        "label": "宜章",
                        "value": "宜章县"
                    },
                    {
                        "label": "永兴",
                        "value": "永兴县"
                    },
                    {
                        "label": "资兴",
                        "value": "资兴市"
                    },
                    {
                        "label": "安仁",
                        "value": "安仁县"
                    },
                    {
                        "label": "汝城",
                        "value": "汝城县"
                    },
                    {
                        "label": "嘉禾",
                        "value": "嘉禾县"
                    },
                    {
                        "label": "临武",
                        "value": "临武县"
                    },
                    {
                        "label": "桂东",
                        "value": "桂东县"
                    },
                    {
                        "label": "郴州",
                        "value": "郴州市"
                    }
                ]
            },
            {
                "value": "永州市",
                "label": "永州",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "冷水滩",
                        "value": "冷水滩区"
                    },
                    {
                        "label": "祁阳",
                        "value": "祁阳县"
                    },
                    {
                        "label": "零陵",
                        "value": "零陵区"
                    },
                    {
                        "label": "宁远",
                        "value": "宁远县"
                    },
                    {
                        "label": "江华",
                        "value": "江华瑶族自治县"
                    },
                    {
                        "label": "道县",
                        "value": "道县"
                    },
                    {
                        "label": "东安",
                        "value": "东安县"
                    },
                    {
                        "label": "新田",
                        "value": "新田县"
                    },
                    {
                        "label": "蓝山",
                        "value": "蓝山县"
                    },
                    {
                        "label": "双牌",
                        "value": "双牌县"
                    },
                    {
                        "label": "江永",
                        "value": "江永县"
                    },
                    {
                        "label": "永州",
                        "value": "永州市"
                    }
                ]
            },
            {
                "value": "怀化市",
                "label": "怀化",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "鹤城",
                        "value": "鹤城区"
                    },
                    {
                        "label": "溆浦",
                        "value": "溆浦县"
                    },
                    {
                        "label": "洪江",
                        "value": "洪江市"
                    },
                    {
                        "label": "沅陵",
                        "value": "沅陵县"
                    },
                    {
                        "label": "中方",
                        "value": "中方县"
                    },
                    {
                        "label": "辰溪",
                        "value": "辰溪县"
                    },
                    {
                        "label": "芷江",
                        "value": "芷江侗族自治县"
                    },
                    {
                        "label": "麻阳",
                        "value": "麻阳苗族自治县"
                    },
                    {
                        "label": "通道",
                        "value": "通道侗族自治县"
                    },
                    {
                        "label": "靖州",
                        "value": "靖州苗族侗族自治县"
                    },
                    {
                        "label": "会同",
                        "value": "会同县"
                    },
                    {
                        "label": "新晃",
                        "value": "新晃侗族自治县"
                    },
                    {
                        "label": "怀化",
                        "value": "怀化市"
                    }
                ]
            },
            {
                "value": "娄底市",
                "label": "娄底",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "娄星",
                        "value": "娄星区"
                    },
                    {
                        "label": "新化",
                        "value": "新化县"
                    },
                    {
                        "label": "双峰",
                        "value": "双峰县"
                    },
                    {
                        "label": "涟源",
                        "value": "涟源市"
                    },
                    {
                        "label": "冷水江",
                        "value": "冷水江市"
                    },
                    {
                        "label": "娄底",
                        "value": "娄底市"
                    }
                ]
            },
            {
                "value": "湘潭市",
                "label": "湘潭",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "岳塘",
                        "value": "岳塘区"
                    },
                    {
                        "label": "湘潭",
                        "value": "湘潭县"
                    },
                    {
                        "label": "雨湖",
                        "value": "雨湖区"
                    },
                    {
                        "label": "湘乡",
                        "value": "湘乡市"
                    },
                    {
                        "label": "韶山",
                        "value": "韶山市"
                    },
                    {
                        "label": "湘潭",
                        "value": "湘潭市"
                    }
                ]
            },
            {
                "value": "湘西土家族苗族自治州",
                "label": "湘西",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "吉首",
                        "value": "吉首市"
                    },
                    {
                        "label": "龙山",
                        "value": "龙山县"
                    },
                    {
                        "label": "花垣",
                        "value": "花垣县"
                    },
                    {
                        "label": "永顺",
                        "value": "永顺县"
                    },
                    {
                        "label": "凤凰",
                        "value": "凤凰县"
                    },
                    {
                        "label": "保靖",
                        "value": "保靖县"
                    },
                    {
                        "label": "泸溪",
                        "value": "泸溪县"
                    },
                    {
                        "label": "古丈",
                        "value": "古丈县"
                    }
                ]
            },
            {
                "value": "张家界市",
                "label": "张家界",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "永定",
                        "value": "永定区"
                    },
                    {
                        "label": "慈利",
                        "value": "慈利县"
                    },
                    {
                        "label": "桑植",
                        "value": "桑植县"
                    },
                    {
                        "label": "武陵源",
                        "value": "武陵源区"
                    },
                    {
                        "label": "张家界",
                        "value": "张家界市"
                    }
                ]
            },
            {
                "value": "湖南省",
                "label": "湖南",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "湖南",
                        "value": "湖南省"
                    }
                ]
            }
        ]
    },
    {
        "value": "陕西省",
        "label": "陕西",
        "children": [
    {
        "label": "不限",
        "value": "不限"
    },
            {
                "value": "西安市",
                "label": "西安",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "雁塔",
                        "value": "雁塔区"
                    },
                    {
                        "label": "未央",
                        "value": "未央区"
                    },
                    {
                        "label": "碑林",
                        "value": "碑林区"
                    },
                    {
                        "label": "莲湖",
                        "value": "莲湖区"
                    },
                    {
                        "label": "新城",
                        "value": "新城区"
                    },
                    {
                        "label": "长安",
                        "value": "长安区"
                    },
                    {
                        "label": "灞桥",
                        "value": "灞桥区"
                    },
                    {
                        "label": "高陵",
                        "value": "高陵区"
                    },
                    {
                        "label": "临潼",
                        "value": "临潼区"
                    },
                    {
                        "label": "鄠邑",
                        "value": "鄠邑区"
                    },
                    {
                        "label": "周至",
                        "value": "周至县"
                    },
                    {
                        "label": "阎良",
                        "value": "阎良区"
                    },
                    {
                        "label": "蓝田",
                        "value": "蓝田县"
                    },
                    {
                        "label": "户县",
                        "value": "户县"
                    },
                    {
                        "label": "西安",
                        "value": "西安市"
                    }
                ]
            },
            {
                "value": "榆林市",
                "label": "榆林",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "榆阳",
                        "value": "榆阳区"
                    },
                    {
                        "label": "神木",
                        "value": "神木市"
                    },
                    {
                        "label": "靖边",
                        "value": "靖边县"
                    },
                    {
                        "label": "府谷",
                        "value": "府谷县"
                    },
                    {
                        "label": "定边",
                        "value": "定边县"
                    },
                    {
                        "label": "横山",
                        "value": "横山区"
                    },
                    {
                        "label": "神木",
                        "value": "神木县"
                    },
                    {
                        "label": "绥德",
                        "value": "绥德县"
                    },
                    {
                        "label": "清涧",
                        "value": "清涧县"
                    },
                    {
                        "label": "佳县",
                        "value": "佳县"
                    },
                    {
                        "label": "米脂",
                        "value": "米脂县"
                    },
                    {
                        "label": "子洲",
                        "value": "子洲县"
                    },
                    {
                        "label": "吴堡",
                        "value": "吴堡县"
                    },
                    {
                        "label": "榆林",
                        "value": "榆林市"
                    }
                ]
            },
            {
                "value": "渭南市",
                "label": "渭南",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "临渭",
                        "value": "临渭区"
                    },
                    {
                        "label": "韩城",
                        "value": "韩城市"
                    },
                    {
                        "label": "蒲城",
                        "value": "蒲城县"
                    },
                    {
                        "label": "大荔",
                        "value": "大荔县"
                    },
                    {
                        "label": "富平",
                        "value": "富平县"
                    },
                    {
                        "label": "澄城",
                        "value": "澄城县"
                    },
                    {
                        "label": "华阴",
                        "value": "华阴市"
                    },
                    {
                        "label": "合阳",
                        "value": "合阳县"
                    },
                    {
                        "label": "华州",
                        "value": "华州区"
                    },
                    {
                        "label": "白水",
                        "value": "白水县"
                    },
                    {
                        "label": "潼关",
                        "value": "潼关县"
                    },
                    {
                        "label": "渭南",
                        "value": "渭南市"
                    }
                ]
            },
            {
                "value": "咸阳市",
                "label": "咸阳",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "秦都",
                        "value": "秦都区"
                    },
                    {
                        "label": "杨陵",
                        "value": "杨陵区"
                    },
                    {
                        "label": "渭城",
                        "value": "渭城区"
                    },
                    {
                        "label": "三原",
                        "value": "三原县"
                    },
                    {
                        "label": "兴平",
                        "value": "兴平市"
                    },
                    {
                        "label": "泾阳",
                        "value": "泾阳县"
                    },
                    {
                        "label": "礼泉",
                        "value": "礼泉县"
                    },
                    {
                        "label": "乾县",
                        "value": "乾县"
                    },
                    {
                        "label": "武功",
                        "value": "武功县"
                    },
                    {
                        "label": "彬县",
                        "value": "彬县"
                    },
                    {
                        "label": "旬邑",
                        "value": "旬邑县"
                    },
                    {
                        "label": "长武",
                        "value": "长武县"
                    },
                    {
                        "label": "淳化",
                        "value": "淳化县"
                    },
                    {
                        "label": "永寿",
                        "value": "永寿县"
                    },
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "咸阳",
                        "value": "咸阳市"
                    }
                ]
            },
            {
                "value": "宝鸡市",
                "label": "宝鸡",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "渭滨",
                        "value": "渭滨区"
                    },
                    {
                        "label": "金台",
                        "value": "金台区"
                    },
                    {
                        "label": "陈仓",
                        "value": "陈仓区"
                    },
                    {
                        "label": "眉县",
                        "value": "眉县"
                    },
                    {
                        "label": "岐山",
                        "value": "岐山县"
                    },
                    {
                        "label": "凤翔",
                        "value": "凤翔县"
                    },
                    {
                        "label": "扶风",
                        "value": "扶风县"
                    },
                    {
                        "label": "陇县",
                        "value": "陇县"
                    },
                    {
                        "label": "麟游",
                        "value": "麟游县"
                    },
                    {
                        "label": "千阳",
                        "value": "千阳县"
                    },
                    {
                        "label": "凤县",
                        "value": "凤县"
                    },
                    {
                        "label": "太白",
                        "value": "太白县"
                    },
                    {
                        "label": "宝鸡",
                        "value": "宝鸡市"
                    }
                ]
            },
            {
                "value": "汉中市",
                "label": "汉中",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "汉台",
                        "value": "汉台区"
                    },
                    {
                        "label": "城固",
                        "value": "城固县"
                    },
                    {
                        "label": "勉县",
                        "value": "勉县"
                    },
                    {
                        "label": "洋县",
                        "value": "洋县"
                    },
                    {
                        "label": "西乡",
                        "value": "西乡县"
                    },
                    {
                        "label": "宁强",
                        "value": "宁强县"
                    },
                    {
                        "label": "略阳",
                        "value": "略阳县"
                    },
                    {
                        "label": "南郑",
                        "value": "南郑区"
                    },
                    {
                        "label": "镇巴",
                        "value": "镇巴县"
                    },
                    {
                        "label": "南郑",
                        "value": "南郑县"
                    },
                    {
                        "label": "留坝",
                        "value": "留坝县"
                    },
                    {
                        "label": "佛坪",
                        "value": "佛坪县"
                    },
                    {
                        "label": "汉中",
                        "value": "汉中市"
                    }
                ]
            },
            {
                "value": "延安市",
                "label": "延安",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "宝塔",
                        "value": "宝塔区"
                    },
                    {
                        "label": "洛川",
                        "value": "洛川县"
                    },
                    {
                        "label": "子长",
                        "value": "子长县"
                    },
                    {
                        "label": "延川",
                        "value": "延川县"
                    },
                    {
                        "label": "富县",
                        "value": "富县"
                    },
                    {
                        "label": "吴起",
                        "value": "吴起县"
                    },
                    {
                        "label": "志丹",
                        "value": "志丹县"
                    },
                    {
                        "label": "黄陵",
                        "value": "黄陵县"
                    },
                    {
                        "label": "延长",
                        "value": "延长县"
                    },
                    {
                        "label": "宜川",
                        "value": "宜川县"
                    },
                    {
                        "label": "安塞",
                        "value": "安塞区"
                    },
                    {
                        "label": "甘泉",
                        "value": "甘泉县"
                    },
                    {
                        "label": "黄龙",
                        "value": "黄龙县"
                    },
                    {
                        "label": "安塞",
                        "value": "安塞县"
                    },
                    {
                        "label": "延安",
                        "value": "延安市"
                    }
                ]
            },
            {
                "value": "安康市",
                "label": "安康",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "汉滨",
                        "value": "汉滨区"
                    },
                    {
                        "label": "旬阳",
                        "value": "旬阳县"
                    },
                    {
                        "label": "汉阴",
                        "value": "汉阴县"
                    },
                    {
                        "label": "石泉",
                        "value": "石泉县"
                    },
                    {
                        "label": "平利",
                        "value": "平利县"
                    },
                    {
                        "label": "岚皋",
                        "value": "岚皋县"
                    },
                    {
                        "label": "紫阳",
                        "value": "紫阳县"
                    },
                    {
                        "label": "白河",
                        "value": "白河县"
                    },
                    {
                        "label": "镇坪",
                        "value": "镇坪县"
                    },
                    {
                        "label": "宁陕",
                        "value": "宁陕县"
                    },
                    {
                        "label": "安康",
                        "value": "安康市"
                    }
                ]
            },
            {
                "value": "商洛市",
                "label": "商洛",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "商州",
                        "value": "商州区"
                    },
                    {
                        "label": "镇安",
                        "value": "镇安县"
                    },
                    {
                        "label": "山阳",
                        "value": "山阳县"
                    },
                    {
                        "label": "洛南",
                        "value": "洛南县"
                    },
                    {
                        "label": "商南",
                        "value": "商南县"
                    },
                    {
                        "label": "丹凤",
                        "value": "丹凤县"
                    },
                    {
                        "label": "柞水",
                        "value": "柞水县"
                    }
                ]
            },
            {
                "value": "铜川市",
                "label": "铜川",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "耀州",
                        "value": "耀州区"
                    },
                    {
                        "label": "王益",
                        "value": "王益区"
                    },
                    {
                        "label": "印台",
                        "value": "印台区"
                    },
                    {
                        "label": "宜君",
                        "value": "宜君县"
                    },
                    {
                        "label": "铜川",
                        "value": "铜川市"
                    }
                ]
            },
            {
                "value": "陕西省",
                "label": "陕西",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "陕西",
                        "value": "陕西省"
                    }
                ]
            }
        ]
    },
    {
        "value": "江西省",
        "label": "江西",
        "children": [
    {
        "label": "不限",
        "value": "不限"
    },
            {
                "value": "南昌市",
                "label": "南昌",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "青山湖",
                        "value": "青山湖区"
                    },
                    {
                        "label": "南昌",
                        "value": "南昌县"
                    },
                    {
                        "label": "东湖",
                        "value": "东湖区"
                    },
                    {
                        "label": "西湖",
                        "value": "西湖区"
                    },
                    {
                        "label": "新建",
                        "value": "新建区"
                    },
                    {
                        "label": "青云谱",
                        "value": "青云谱区"
                    },
                    {
                        "label": "进贤",
                        "value": "进贤县"
                    },
                    {
                        "label": "安义",
                        "value": "安义县"
                    },
                    {
                        "label": "湾里",
                        "value": "湾里区"
                    },
                    {
                        "label": "南昌",
                        "value": "南昌市"
                    }
                ]
            },
            {
                "value": "赣州市",
                "label": "赣州",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "章贡",
                        "value": "章贡区"
                    },
                    {
                        "label": "南康",
                        "value": "南康区"
                    },
                    {
                        "label": "于都",
                        "value": "于都县"
                    },
                    {
                        "label": "信丰",
                        "value": "信丰县"
                    },
                    {
                        "label": "瑞金",
                        "value": "瑞金市"
                    },
                    {
                        "label": "兴国",
                        "value": "兴国县"
                    },
                    {
                        "label": "宁都",
                        "value": "宁都县"
                    },
                    {
                        "label": "寻乌",
                        "value": "寻乌县"
                    },
                    {
                        "label": "赣县",
                        "value": "赣县区"
                    },
                    {
                        "label": "会昌",
                        "value": "会昌县"
                    },
                    {
                        "label": "石城",
                        "value": "石城县"
                    },
                    {
                        "label": "安远",
                        "value": "安远县"
                    },
                    {
                        "label": "上犹",
                        "value": "上犹县"
                    },
                    {
                        "label": "龙南",
                        "value": "龙南县"
                    },
                    {
                        "label": "大余",
                        "value": "大余县"
                    },
                    {
                        "label": "全南",
                        "value": "全南县"
                    },
                    {
                        "label": "定南",
                        "value": "定南县"
                    },
                    {
                        "label": "崇义",
                        "value": "崇义县"
                    },
                    {
                        "label": "赣县",
                        "value": "赣县"
                    },
                    {
                        "label": "赣州",
                        "value": "赣州市"
                    }
                ]
            },
            {
                "value": "上饶市",
                "label": "上饶",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "信州",
                        "value": "信州区"
                    },
                    {
                        "label": "上饶",
                        "value": "上饶县"
                    },
                    {
                        "label": "广丰",
                        "value": "广丰区"
                    },
                    {
                        "label": "余干",
                        "value": "余干县"
                    },
                    {
                        "label": "鄱阳",
                        "value": "鄱阳县"
                    },
                    {
                        "label": "铅山",
                        "value": "铅山县"
                    },
                    {
                        "label": "玉山",
                        "value": "玉山县"
                    },
                    {
                        "label": "万年",
                        "value": "万年县"
                    },
                    {
                        "label": "婺源",
                        "value": "婺源县"
                    },
                    {
                        "label": "德兴",
                        "value": "德兴市"
                    },
                    {
                        "label": "弋阳",
                        "value": "弋阳县"
                    },
                    {
                        "label": "横峰",
                        "value": "横峰县"
                    },
                    {
                        "label": "上饶",
                        "value": "上饶市"
                    }
                ]
            },
            {
                "value": "九江市",
                "label": "九江",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "濂溪",
                        "value": "濂溪区"
                    },
                    {
                        "label": "浔阳",
                        "value": "浔阳区"
                    },
                    {
                        "label": "都昌",
                        "value": "都昌县"
                    },
                    {
                        "label": "瑞昌",
                        "value": "瑞昌市"
                    },
                    {
                        "label": "修水",
                        "value": "修水县"
                    },
                    {
                        "label": "共青城",
                        "value": "共青城市"
                    },
                    {
                        "label": "彭泽",
                        "value": "彭泽县"
                    },
                    {
                        "label": "永修",
                        "value": "永修县"
                    },
                    {
                        "label": "武宁",
                        "value": "武宁县"
                    },
                    {
                        "label": "湖口",
                        "value": "湖口县"
                    },
                    {
                        "label": "德安",
                        "value": "德安县"
                    },
                    {
                        "label": "庐山",
                        "value": "庐山市"
                    },
                    {
                        "label": "九江",
                        "value": "九江县"
                    },
                    {
                        "label": "星子",
                        "value": "星子县"
                    },
                    {
                        "label": "九江",
                        "value": "九江市"
                    }
                ]
            },
            {
                "value": "宜春市",
                "label": "宜春",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "袁州",
                        "value": "袁州区"
                    },
                    {
                        "label": "高安",
                        "value": "高安市"
                    },
                    {
                        "label": "丰城",
                        "value": "丰城市"
                    },
                    {
                        "label": "上高",
                        "value": "上高县"
                    },
                    {
                        "label": "樟树",
                        "value": "樟树市"
                    },
                    {
                        "label": "万载",
                        "value": "万载县"
                    },
                    {
                        "label": "宜丰",
                        "value": "宜丰县"
                    },
                    {
                        "label": "奉新",
                        "value": "奉新县"
                    },
                    {
                        "label": "铜鼓",
                        "value": "铜鼓县"
                    },
                    {
                        "label": "靖安",
                        "value": "靖安县"
                    },
                    {
                        "label": "宜春",
                        "value": "宜春市"
                    }
                ]
            },
            {
                "value": "吉安市",
                "label": "吉安",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "吉州",
                        "value": "吉州区"
                    },
                    {
                        "label": "吉安",
                        "value": "吉安县"
                    },
                    {
                        "label": "泰和",
                        "value": "泰和县"
                    },
                    {
                        "label": "遂川",
                        "value": "遂川县"
                    },
                    {
                        "label": "新干",
                        "value": "新干县"
                    },
                    {
                        "label": "吉水",
                        "value": "吉水县"
                    },
                    {
                        "label": "青原",
                        "value": "青原区"
                    },
                    {
                        "label": "永新",
                        "value": "永新县"
                    },
                    {
                        "label": "永丰",
                        "value": "永丰县"
                    },
                    {
                        "label": "安福",
                        "value": "安福县"
                    },
                    {
                        "label": "井冈山",
                        "value": "井冈山市"
                    },
                    {
                        "label": "万安",
                        "value": "万安县"
                    },
                    {
                        "label": "峡江",
                        "value": "峡江县"
                    },
                    {
                        "label": "吉安",
                        "value": "吉安市"
                    }
                ]
            },
            {
                "value": "抚州市",
                "label": "抚州",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "临川",
                        "value": "临川区"
                    },
                    {
                        "label": "东乡",
                        "value": "东乡区"
                    },
                    {
                        "label": "南城",
                        "value": "南城县"
                    },
                    {
                        "label": "金溪",
                        "value": "金溪县"
                    },
                    {
                        "label": "南丰",
                        "value": "南丰县"
                    },
                    {
                        "label": "乐安",
                        "value": "乐安县"
                    },
                    {
                        "label": "黎川",
                        "value": "黎川县"
                    },
                    {
                        "label": "宜黄",
                        "value": "宜黄县"
                    },
                    {
                        "label": "崇仁",
                        "value": "崇仁县"
                    },
                    {
                        "label": "广昌",
                        "value": "广昌县"
                    },
                    {
                        "label": "资溪",
                        "value": "资溪县"
                    },
                    {
                        "label": "东乡",
                        "value": "东乡县"
                    },
                    {
                        "label": "抚州",
                        "value": "抚州市"
                    }
                ]
            },
            {
                "value": "新余市",
                "label": "新余",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "渝水",
                        "value": "渝水区"
                    },
                    {
                        "label": "分宜",
                        "value": "分宜县"
                    },
                    {
                        "label": "新余",
                        "value": "新余市"
                    }
                ]
            },
            {
                "value": "萍乡市",
                "label": "萍乡",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "安源",
                        "value": "安源区"
                    },
                    {
                        "label": "上栗",
                        "value": "上栗县"
                    },
                    {
                        "label": "芦溪",
                        "value": "芦溪县"
                    },
                    {
                        "label": "湘东",
                        "value": "湘东区"
                    },
                    {
                        "label": "莲花",
                        "value": "莲花县"
                    },
                    {
                        "label": "萍乡",
                        "value": "萍乡市"
                    }
                ]
            },
            {
                "value": "景德镇市",
                "label": "景德镇",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "珠山",
                        "value": "珠山区"
                    },
                    {
                        "label": "乐平",
                        "value": "乐平市"
                    },
                    {
                        "label": "昌江",
                        "value": "昌江区"
                    },
                    {
                        "label": "浮梁",
                        "value": "浮梁县"
                    },
                    {
                        "label": "景德镇",
                        "value": "景德镇市"
                    }
                ]
            },
            {
                "value": "鹰潭市",
                "label": "鹰潭",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "月湖",
                        "value": "月湖区"
                    },
                    {
                        "label": "余江",
                        "value": "余江县"
                    },
                    {
                        "label": "贵溪",
                        "value": "贵溪市"
                    },
                    {
                        "label": "鹰潭",
                        "value": "鹰潭市"
                    }
                ]
            },
            {
                "value": "江西省",
                "label": "江西",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "江西",
                        "value": "江西省"
                    }
                ]
            }
        ]
    },
    {
        "value": "贵州省",
        "label": "贵州",
        "children": [
    {
        "label": "不限",
        "value": "不限"
    },
            {
                "value": "贵阳市",
                "label": "贵阳",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "南明",
                        "value": "南明区"
                    },
                    {
                        "label": "观山湖",
                        "value": "观山湖区"
                    },
                    {
                        "label": "云岩",
                        "value": "云岩区"
                    },
                    {
                        "label": "花溪",
                        "value": "花溪区"
                    },
                    {
                        "label": "白云",
                        "value": "白云区"
                    },
                    {
                        "label": "清镇",
                        "value": "清镇市"
                    },
                    {
                        "label": "乌当",
                        "value": "乌当区"
                    },
                    {
                        "label": "修文",
                        "value": "修文县"
                    },
                    {
                        "label": "开阳",
                        "value": "开阳县"
                    },
                    {
                        "label": "息烽",
                        "value": "息烽县"
                    },
                    {
                        "label": "贵阳",
                        "value": "贵阳市"
                    }
                ]
            },
            {
                "value": "遵义市",
                "label": "遵义",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "红花岗",
                        "value": "红花岗区"
                    },
                    {
                        "label": "汇川",
                        "value": "汇川区"
                    },
                    {
                        "label": "仁怀",
                        "value": "仁怀市"
                    },
                    {
                        "label": "播州",
                        "value": "播州区"
                    },
                    {
                        "label": "桐梓",
                        "value": "桐梓县"
                    },
                    {
                        "label": "习水",
                        "value": "习水县"
                    },
                    {
                        "label": "湄潭",
                        "value": "湄潭县"
                    },
                    {
                        "label": "正安",
                        "value": "正安县"
                    },
                    {
                        "label": "赤水",
                        "value": "赤水市"
                    },
                    {
                        "label": "绥阳",
                        "value": "绥阳县"
                    },
                    {
                        "label": "凤冈",
                        "value": "凤冈县"
                    },
                    {
                        "label": "道真",
                        "value": "道真仡佬族苗族自治县"
                    },
                    {
                        "label": "余庆",
                        "value": "余庆县"
                    },
                    {
                        "label": "务川",
                        "value": "务川仡佬族苗族自治县"
                    },
                    {
                        "label": "遵义",
                        "value": "遵义市"
                    },
                    {
                        "label": "遵义",
                        "value": "遵义县"
                    }
                ]
            },
            {
                "value": "毕节市",
                "label": "毕节",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "七星关",
                        "value": "七星关区"
                    },
                    {
                        "label": "织金",
                        "value": "织金县"
                    },
                    {
                        "label": "威宁",
                        "value": "威宁彝族回族苗族自治县"
                    },
                    {
                        "label": "大方",
                        "value": "大方县"
                    },
                    {
                        "label": "金沙",
                        "value": "金沙县"
                    },
                    {
                        "label": "黔西",
                        "value": "黔西县"
                    },
                    {
                        "label": "纳雍",
                        "value": "纳雍县"
                    },
                    {
                        "label": "赫章",
                        "value": "赫章县"
                    },
                    {
                        "label": "毕节",
                        "value": "毕节市"
                    }
                ]
            },
            {
                "value": "黔南布依族苗族自治州",
                "label": "黔南",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "都匀",
                        "value": "都匀市"
                    },
                    {
                        "label": "独山",
                        "value": "独山县"
                    },
                    {
                        "label": "惠水",
                        "value": "惠水县"
                    },
                    {
                        "label": "瓮安",
                        "value": "瓮安县"
                    },
                    {
                        "label": "福泉",
                        "value": "福泉市"
                    },
                    {
                        "label": "龙里",
                        "value": "龙里县"
                    },
                    {
                        "label": "贵定",
                        "value": "贵定县"
                    },
                    {
                        "label": "长顺",
                        "value": "长顺县"
                    },
                    {
                        "label": "罗甸",
                        "value": "罗甸县"
                    },
                    {
                        "label": "荔波",
                        "value": "荔波县"
                    },
                    {
                        "label": "三都",
                        "value": "三都水族自治县"
                    },
                    {
                        "label": "平塘",
                        "value": "平塘县"
                    },
                    {
                        "label": "黔南",
                        "value": "黔南布依族苗族自治州"
                    }
                ]
            },
            {
                "value": "黔东南苗族侗族自治州",
                "label": "黔东南",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "凯里",
                        "value": "凯里市"
                    },
                    {
                        "label": "天柱",
                        "value": "天柱县"
                    },
                    {
                        "label": "黎平",
                        "value": "黎平县"
                    },
                    {
                        "label": "从江",
                        "value": "从江县"
                    },
                    {
                        "label": "榕江",
                        "value": "榕江县"
                    },
                    {
                        "label": "镇远",
                        "value": "镇远县"
                    },
                    {
                        "label": "黄平",
                        "value": "黄平县"
                    },
                    {
                        "label": "剑河",
                        "value": "剑河县"
                    },
                    {
                        "label": "锦屏",
                        "value": "锦屏县"
                    },
                    {
                        "label": "三穗",
                        "value": "三穗县"
                    },
                    {
                        "label": "丹寨",
                        "value": "丹寨县"
                    },
                    {
                        "label": "台江",
                        "value": "台江县"
                    },
                    {
                        "label": "施秉",
                        "value": "施秉县"
                    },
                    {
                        "label": "雷山",
                        "value": "雷山县"
                    },
                    {
                        "label": "岑巩",
                        "value": "岑巩县"
                    },
                    {
                        "label": "麻江",
                        "value": "麻江县"
                    },
                    {
                        "label": "黔东南",
                        "value": "黔东南苗族侗族自治州"
                    }
                ]
            },
            {
                "value": "铜仁市",
                "label": "铜仁",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "碧江",
                        "value": "碧江区"
                    },
                    {
                        "label": "德江",
                        "value": "德江县"
                    },
                    {
                        "label": "松桃",
                        "value": "松桃苗族自治县"
                    },
                    {
                        "label": "沿河",
                        "value": "沿河土家族自治县"
                    },
                    {
                        "label": "思南",
                        "value": "思南县"
                    },
                    {
                        "label": "石阡",
                        "value": "石阡县"
                    },
                    {
                        "label": "江口",
                        "value": "江口县"
                    },
                    {
                        "label": "印江",
                        "value": "印江土家族苗族自治县"
                    },
                    {
                        "label": "万山",
                        "value": "万山区"
                    },
                    {
                        "label": "玉屏",
                        "value": "玉屏侗族自治县"
                    },
                    {
                        "label": "铜仁",
                        "value": "铜仁市"
                    }
                ]
            },
            {
                "value": "六盘水市",
                "label": "六盘水",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "钟山",
                        "value": "钟山区"
                    },
                    {
                        "label": "盘州",
                        "value": "盘州市"
                    },
                    {
                        "label": "水城",
                        "value": "水城县"
                    },
                    {
                        "label": "六枝",
                        "value": "六枝特区"
                    },
                    {
                        "label": "盘县",
                        "value": "盘县"
                    },
                    {
                        "label": "六盘水",
                        "value": "六盘水市"
                    }
                ]
            },
            {
                "value": "黔西南布依族苗族自治州",
                "label": "黔西南",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "兴义",
                        "value": "兴义市"
                    },
                    {
                        "label": "贞丰",
                        "value": "贞丰县"
                    },
                    {
                        "label": "安龙",
                        "value": "安龙县"
                    },
                    {
                        "label": "兴仁",
                        "value": "兴仁县"
                    },
                    {
                        "label": "普安",
                        "value": "普安县"
                    },
                    {
                        "label": "晴隆",
                        "value": "晴隆县"
                    },
                    {
                        "label": "望谟",
                        "value": "望谟县"
                    },
                    {
                        "label": "册亨",
                        "value": "册亨县"
                    },
                    {
                        "label": "黔西南",
                        "value": "黔西南布依族苗族自治州"
                    }
                ]
            },
            {
                "value": "安顺市",
                "label": "安顺",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "西秀",
                        "value": "西秀区"
                    },
                    {
                        "label": "镇宁",
                        "value": "镇宁布依族苗族自治县"
                    },
                    {
                        "label": "平坝",
                        "value": "平坝区"
                    },
                    {
                        "label": "普定",
                        "value": "普定县"
                    },
                    {
                        "label": "关岭",
                        "value": "关岭布依族苗族自治县"
                    },
                    {
                        "label": "紫云",
                        "value": "紫云苗族布依族自治县"
                    },
                    {
                        "label": "安顺",
                        "value": "安顺市"
                    }
                ]
            },
            {
                "value": "贵州省",
                "label": "贵州",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "贵州",
                        "value": "贵州省"
                    }
                ]
            }
        ]
    },
    {
        "value": "山西省",
        "label": "山西",
        "children": [
    {
        "label": "不限",
        "value": "不限"
    },
            {
                "value": "太原市",
                "label": "太原",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "小店",
                        "value": "小店区"
                    },
                    {
                        "label": "迎泽",
                        "value": "迎泽区"
                    },
                    {
                        "label": "万柏林",
                        "value": "万柏林区"
                    },
                    {
                        "label": "杏花岭",
                        "value": "杏花岭区"
                    },
                    {
                        "label": "尖草坪",
                        "value": "尖草坪区"
                    },
                    {
                        "label": "晋源",
                        "value": "晋源区"
                    },
                    {
                        "label": "清徐",
                        "value": "清徐县"
                    },
                    {
                        "label": "古交",
                        "value": "古交市"
                    },
                    {
                        "label": "阳曲",
                        "value": "阳曲县"
                    },
                    {
                        "label": "娄烦",
                        "value": "娄烦县"
                    },
                    {
                        "label": "太原",
                        "value": "太原市"
                    }
                ]
            },
            {
                "value": "运城市",
                "label": "运城",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "盐湖",
                        "value": "盐湖区"
                    },
                    {
                        "label": "河津",
                        "value": "河津市"
                    },
                    {
                        "label": "临猗",
                        "value": "临猗县"
                    },
                    {
                        "label": "闻喜",
                        "value": "闻喜县"
                    },
                    {
                        "label": "永济",
                        "value": "永济市"
                    },
                    {
                        "label": "万荣",
                        "value": "万荣县"
                    },
                    {
                        "label": "芮城",
                        "value": "芮城县"
                    },
                    {
                        "label": "绛县",
                        "value": "绛县"
                    },
                    {
                        "label": "稷山",
                        "value": "稷山县"
                    },
                    {
                        "label": "新绛",
                        "value": "新绛县"
                    },
                    {
                        "label": "夏县",
                        "value": "夏县"
                    },
                    {
                        "label": "平陆",
                        "value": "平陆县"
                    },
                    {
                        "label": "垣曲",
                        "value": "垣曲县"
                    },
                    {
                        "label": "运城",
                        "value": "运城市"
                    }
                ]
            },
            {
                "value": "临汾市",
                "label": "临汾",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "尧都",
                        "value": "尧都区"
                    },
                    {
                        "label": "洪洞",
                        "value": "洪洞县"
                    },
                    {
                        "label": "侯马",
                        "value": "侯马市"
                    },
                    {
                        "label": "襄汾",
                        "value": "襄汾县"
                    },
                    {
                        "label": "翼城",
                        "value": "翼城县"
                    },
                    {
                        "label": "曲沃",
                        "value": "曲沃县"
                    },
                    {
                        "label": "霍州",
                        "value": "霍州市"
                    },
                    {
                        "label": "乡宁",
                        "value": "乡宁县"
                    },
                    {
                        "label": "浮山",
                        "value": "浮山县"
                    },
                    {
                        "label": "蒲县",
                        "value": "蒲县"
                    },
                    {
                        "label": "隰县",
                        "value": "隰县"
                    },
                    {
                        "label": "古县",
                        "value": "古县"
                    },
                    {
                        "label": "吉县",
                        "value": "吉县"
                    },
                    {
                        "label": "汾西",
                        "value": "汾西县"
                    },
                    {
                        "label": "安泽",
                        "value": "安泽县"
                    },
                    {
                        "label": "永和",
                        "value": "永和县"
                    },
                    {
                        "label": "大宁",
                        "value": "大宁县"
                    },
                    {
                        "label": "临汾",
                        "value": "临汾市"
                    }
                ]
            },
            {
                "value": "晋中市",
                "label": "晋中",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "榆次",
                        "value": "榆次区"
                    },
                    {
                        "label": "介休",
                        "value": "介休市"
                    },
                    {
                        "label": "灵石",
                        "value": "灵石县"
                    },
                    {
                        "label": "平遥",
                        "value": "平遥县"
                    },
                    {
                        "label": "祁县",
                        "value": "祁县"
                    },
                    {
                        "label": "太谷",
                        "value": "太谷县"
                    },
                    {
                        "label": "寿阳",
                        "value": "寿阳县"
                    },
                    {
                        "label": "昔阳",
                        "value": "昔阳县"
                    },
                    {
                        "label": "和顺",
                        "value": "和顺县"
                    },
                    {
                        "label": "左权",
                        "value": "左权县"
                    },
                    {
                        "label": "榆社",
                        "value": "榆社县"
                    },
                    {
                        "label": "晋中",
                        "value": "晋中市"
                    }
                ]
            },
            {
                "value": "吕梁市",
                "label": "吕梁",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "离石",
                        "value": "离石区"
                    },
                    {
                        "label": "孝义",
                        "value": "孝义市"
                    },
                    {
                        "label": "汾阳",
                        "value": "汾阳市"
                    },
                    {
                        "label": "文水",
                        "value": "文水县"
                    },
                    {
                        "label": "兴县",
                        "value": "兴县"
                    },
                    {
                        "label": "临县",
                        "value": "临县"
                    },
                    {
                        "label": "交城",
                        "value": "交城县"
                    },
                    {
                        "label": "柳林",
                        "value": "柳林县"
                    },
                    {
                        "label": "岚县",
                        "value": "岚县"
                    },
                    {
                        "label": "交口",
                        "value": "交口县"
                    },
                    {
                        "label": "方山",
                        "value": "方山县"
                    },
                    {
                        "label": "中阳",
                        "value": "中阳县"
                    },
                    {
                        "label": "石楼",
                        "value": "石楼县"
                    },
                    {
                        "label": "吕梁",
                        "value": "吕梁市"
                    }
                ]
            },
            {
                "value": "长治市",
                "label": "长治",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "城区",
                        "value": "城区"
                    },
                    {
                        "label": "襄垣",
                        "value": "襄垣县"
                    },
                    {
                        "label": "长治",
                        "value": "长治县"
                    },
                    {
                        "label": "屯留",
                        "value": "屯留县"
                    },
                    {
                        "label": "郊区",
                        "value": "郊区"
                    },
                    {
                        "label": "长子",
                        "value": "长子县"
                    },
                    {
                        "label": "壶关",
                        "value": "壶关县"
                    },
                    {
                        "label": "武乡",
                        "value": "武乡县"
                    },
                    {
                        "label": "潞城",
                        "value": "潞城市"
                    },
                    {
                        "label": "沁县",
                        "value": "沁县"
                    },
                    {
                        "label": "沁源",
                        "value": "沁源县"
                    },
                    {
                        "label": "黎城",
                        "value": "黎城县"
                    },
                    {
                        "label": "平顺",
                        "value": "平顺县"
                    },
                    {
                        "label": "长治",
                        "value": "长治市"
                    },
                ]
            },
            {
                "value": "大同市",
                "label": "大同",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "城区",
                        "value": "城区"
                    },
                    {
                        "label": "南郊",
                        "value": "南郊区"
                    },
                    {
                        "label": "阳高",
                        "value": "阳高县"
                    },
                    {
                        "label": "大同",
                        "value": "大同县"
                    },
                    {
                        "label": "天镇",
                        "value": "天镇县"
                    },
                    {
                        "label": "灵丘",
                        "value": "灵丘县"
                    },
                    {
                        "label": "浑源",
                        "value": "浑源县"
                    },
                    {
                        "label": "广灵",
                        "value": "广灵县"
                    },
                    {
                        "label": "矿区",
                        "value": "矿区"
                    },
                    {
                        "label": "左云",
                        "value": "左云县"
                    },
                    {
                        "label": "新荣",
                        "value": "新荣区"
                    },
                    {
                        "label": "大同",
                        "value": "大同市"
                    }
                ]
            },
            {
                "value": "忻州市",
                "label": "忻州",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "忻府",
                        "value": "忻府区"
                    },
                    {
                        "label": "原平",
                        "value": "原平市"
                    },
                    {
                        "label": "繁峙",
                        "value": "繁峙县"
                    },
                    {
                        "label": "五台",
                        "value": "五台县"
                    },
                    {
                        "label": "定襄",
                        "value": "定襄县"
                    },
                    {
                        "label": "代县",
                        "value": "代县"
                    },
                    {
                        "label": "静乐",
                        "value": "静乐县"
                    },
                    {
                        "label": "宁武",
                        "value": "宁武县"
                    },
                    {
                        "label": "保德",
                        "value": "保德县"
                    },
                    {
                        "label": "河曲",
                        "value": "河曲县"
                    },
                    {
                        "label": "五寨",
                        "value": "五寨县"
                    },
                    {
                        "label": "神池",
                        "value": "神池县"
                    },
                    {
                        "label": "岢岚",
                        "value": "岢岚县"
                    },
                    {
                        "label": "偏关",
                        "value": "偏关县"
                    },
                    {
                        "label": "忻州",
                        "value": "忻州市"
                    }
                ]
            },
            {
                "value": "晋城市",
                "label": "晋城",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "城区",
                        "value": "城区"
                    },
                    {
                        "label": "泽州",
                        "value": "泽州县"
                    },
                    {
                        "label": "高平",
                        "value": "高平市"
                    },
                    {
                        "label": "阳城",
                        "value": "阳城县"
                    },
                    {
                        "label": "沁水",
                        "value": "沁水县"
                    },
                    {
                        "label": "陵川",
                        "value": "陵川县"
                    },
                    {
                        "label": "晋城",
                        "value": "晋城市"
                    }
                ]
            },
            {
                "value": "阳泉市",
                "label": "阳泉",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "城区",
                        "value": "城区"
                    },
                    {
                        "label": "郊区",
                        "value": "郊区"
                    },
                    {
                        "label": "盂县",
                        "value": "盂县"
                    },
                    {
                        "label": "平定",
                        "value": "平定县"
                    },
                    {
                        "label": "矿区",
                        "value": "矿区"
                    },
                    {
                        "label": "阳泉",
                        "value": "阳泉市"
                    }
                ]
            },
            {
                "value": "朔州市",
                "label": "朔州",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "朔城",
                        "value": "朔城区"
                    },
                    {
                        "label": "应县",
                        "value": "应县"
                    },
                    {
                        "label": "怀仁",
                        "value": "怀仁县"
                    },
                    {
                        "label": "山阴",
                        "value": "山阴县"
                    },
                    {
                        "label": "平鲁",
                        "value": "平鲁区"
                    },
                    {
                        "label": "右玉",
                        "value": "右玉县"
                    },
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "朔州",
                        "value": "朔州市"
                    }
                ]
            },
            {
                "value": "山西省",
                "label": "山西",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "山西",
                        "value": "山西省"
                    }
                ]
            }
        ]
    },
    {
        "value": "云南省",
        "label": "云南",
        "children": [
    {
        "label": "不限",
        "value": "不限"
    },
            {
                "value": "昆明市",
                "label": "昆明",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "官渡",
                        "value": "官渡区"
                    },
                    {
                        "label": "五华",
                        "value": "五华区"
                    },
                    {
                        "label": "盘龙",
                        "value": "盘龙区"
                    },
                    {
                        "label": "西山",
                        "value": "西山区"
                    },
                    {
                        "label": "呈贡",
                        "value": "呈贡区"
                    },
                    {
                        "label": "安宁",
                        "value": "安宁市"
                    },
                    {
                        "label": "寻甸",
                        "value": "寻甸回族彝族自治县"
                    },
                    {
                        "label": "嵩明",
                        "value": "嵩明县"
                    },
                    {
                        "label": "宜良",
                        "value": "宜良县"
                    },
                    {
                        "label": "东川",
                        "value": "东川区"
                    },
                    {
                        "label": "禄劝",
                        "value": "禄劝彝族苗族自治县"
                    },
                    {
                        "label": "石林",
                        "value": "石林彝族自治县"
                    },
                    {
                        "label": "富民",
                        "value": "富民县"
                    },
                    {
                        "label": "晋宁",
                        "value": "晋宁区"
                    },
                    {
                        "label": "晋宁",
                        "value": "晋宁县"
                    },
                    {
                        "label": "昆明",
                        "value": "昆明市"
                    }
                ]
            },
            {
                "value": "曲靖市",
                "label": "曲靖",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "麒麟",
                        "value": "麒麟区"
                    },
                    {
                        "label": "宣威",
                        "value": "宣威市"
                    },
                    {
                        "label": "富源",
                        "value": "富源县"
                    },
                    {
                        "label": "会泽",
                        "value": "会泽县"
                    },
                    {
                        "label": "陆良",
                        "value": "陆良县"
                    },
                    {
                        "label": "罗平",
                        "value": "罗平县"
                    },
                    {
                        "label": "师宗",
                        "value": "师宗县"
                    },
                    {
                        "label": "沾益",
                        "value": "沾益区"
                    },
                    {
                        "label": "马龙",
                        "value": "马龙县"
                    },
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "沾益",
                        "value": "沾益县"
                    },
                    {
                        "label": "曲靖",
                        "value": "曲靖市"
                    }
                ]
            },
            {
                "value": "红河哈尼族彝族自治州",
                "label": "红河",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "蒙自",
                        "value": "蒙自市"
                    },
                    {
                        "label": "弥勒",
                        "value": "弥勒市"
                    },
                    {
                        "label": "个旧",
                        "value": "个旧市"
                    },
                    {
                        "label": "建水",
                        "value": "建水县"
                    },
                    {
                        "label": "泸西",
                        "value": "泸西县"
                    },
                    {
                        "label": "开远",
                        "value": "开远市"
                    },
                    {
                        "label": "石屏",
                        "value": "石屏县"
                    },
                    {
                        "label": "元阳",
                        "value": "元阳县"
                    },
                    {
                        "label": "红河",
                        "value": "红河县"
                    },
                    {
                        "label": "河口",
                        "value": "河口瑶族自治县"
                    },
                    {
                        "label": "绿春",
                        "value": "绿春县"
                    },
                    {
                        "label": "金平",
                        "value": "金平苗族瑶族傣族自治县"
                    },
                    {
                        "label": "屏边",
                        "value": "屏边苗族自治县"
                    }
                ]
            },
            {
                "value": "大理白族自治州",
                "label": "大理",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "大理",
                        "value": "大理市"
                    },
                    {
                        "label": "祥云",
                        "value": "祥云县"
                    },
                    {
                        "label": "宾川",
                        "value": "宾川县"
                    },
                    {
                        "label": "云龙",
                        "value": "云龙县"
                    },
                    {
                        "label": "巍山",
                        "value": "巍山彝族回族自治县"
                    },
                    {
                        "label": "永平",
                        "value": "永平县"
                    },
                    {
                        "label": "剑川",
                        "value": "剑川县"
                    },
                    {
                        "label": "弥渡",
                        "value": "弥渡县"
                    },
                    {
                        "label": "洱源",
                        "value": "洱源县"
                    },
                    {
                        "label": "鹤庆",
                        "value": "鹤庆县"
                    },
                    {
                        "label": "南涧",
                        "value": "南涧彝族自治县"
                    },
                    {
                        "label": "漾濞",
                        "value": "漾濞彝族自治县"
                    },
                    {
                        "label": "大理",
                        "value": "大理白族自治州"
                    }
                ]
            },
            {
                "value": "楚雄彝族自治州",
                "label": "楚雄",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "楚雄",
                        "value": "楚雄市"
                    },
                    {
                        "label": "禄丰",
                        "value": "禄丰县"
                    },
                    {
                        "label": "武定",
                        "value": "武定县"
                    },
                    {
                        "label": "元谋",
                        "value": "元谋县"
                    },
                    {
                        "label": "姚安",
                        "value": "姚安县"
                    },
                    {
                        "label": "大姚",
                        "value": "大姚县"
                    },
                    {
                        "label": "南华",
                        "value": "南华县"
                    },
                    {
                        "label": "双柏",
                        "value": "双柏县"
                    },
                    {
                        "label": "永仁",
                        "value": "永仁县"
                    },
                    {
                        "label": "牟定",
                        "value": "牟定县"
                    },
                    {
                        "label": "楚雄",
                        "value": "楚雄彝族自治州"
                    }
                ]
            },
            {
                "value": "昭通市",
                "label": "昭通",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "昭阳",
                        "value": "昭阳区"
                    },
                    {
                        "label": "镇雄",
                        "value": "镇雄县"
                    },
                    {
                        "label": "彝良",
                        "value": "彝良县"
                    },
                    {
                        "label": "巧家",
                        "value": "巧家县"
                    },
                    {
                        "label": "威信",
                        "value": "威信县"
                    },
                    {
                        "label": "盐津",
                        "value": "盐津县"
                    },
                    {
                        "label": "鲁甸",
                        "value": "鲁甸县"
                    },
                    {
                        "label": "永善",
                        "value": "永善县"
                    },
                    {
                        "label": "绥江",
                        "value": "绥江县"
                    },
                    {
                        "label": "大关",
                        "value": "大关县"
                    },
                    {
                        "label": "水富",
                        "value": "水富县"
                    },
                    {
                        "label": "昭通",
                        "value": "昭通市"
                    }
                ]
            },
            {
                "value": "玉溪市",
                "label": "玉溪",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "红塔",
                        "value": "红塔区"
                    },
                    {
                        "label": "通海",
                        "value": "通海县"
                    },
                    {
                        "label": "新平",
                        "value": "新平彝族傣族自治县"
                    },
                    {
                        "label": "江川",
                        "value": "江川区"
                    },
                    {
                        "label": "元江",
                        "value": "元江哈尼族彝族傣族自治县"
                    },
                    {
                        "label": "澄江",
                        "value": "澄江县"
                    },
                    {
                        "label": "华宁",
                        "value": "华宁县"
                    },
                    {
                        "label": "易门",
                        "value": "易门县"
                    },
                    {
                        "label": "峨山",
                        "value": "峨山彝族自治县"
                    },
                    {
                        "label": "玉溪",
                        "value": "玉溪市"
                    }
                ]
            },
            {
                "value": "文山壮族苗族自治州",
                "label": "文山",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "文山",
                        "value": "文山市"
                    },
                    {
                        "label": "广南",
                        "value": "广南县"
                    },
                    {
                        "label": "砚山",
                        "value": "砚山县"
                    },
                    {
                        "label": "丘北",
                        "value": "丘北县"
                    },
                    {
                        "label": "富宁",
                        "value": "富宁县"
                    },
                    {
                        "label": "马关",
                        "value": "马关县"
                    },
                    {
                        "label": "麻栗坡",
                        "value": "麻栗坡县"
                    },
                    {
                        "label": "西畴",
                        "value": "西畴县"
                    }
                ]
            },
            {
                "value": "普洱市",
                "label": "普洱",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "思茅",
                        "value": "思茅区"
                    },
                    {
                        "label": "景谷",
                        "value": "景谷傣族彝族自治县"
                    },
                    {
                        "label": "景东",
                        "value": "景东彝族自治县"
                    },
                    {
                        "label": "澜沧",
                        "value": "澜沧拉祜族自治县"
                    },
                    {
                        "label": "镇沅",
                        "value": "镇沅彝族哈尼族拉祜族自治县"
                    },
                    {
                        "label": "宁洱",
                        "value": "宁洱哈尼族彝族自治县"
                    },
                    {
                        "label": "墨江",
                        "value": "墨江哈尼族自治县"
                    },
                    {
                        "label": "江城",
                        "value": "江城哈尼族彝族自治县"
                    },
                    {
                        "label": "孟连",
                        "value": "孟连傣族拉祜族佤族自治县"
                    },
                    {
                        "label": "西盟",
                        "value": "西盟佤族自治县"
                    },
                    {
                        "label": "普洱",
                        "value": "普洱市"
                    }
                ]
            },
            {
                "value": "保山市",
                "label": "保山",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "隆阳",
                        "value": "隆阳区"
                    },
                    {
                        "label": "腾冲",
                        "value": "腾冲市"
                    },
                    {
                        "label": "昌宁",
                        "value": "昌宁县"
                    },
                    {
                        "label": "龙陵",
                        "value": "龙陵县"
                    },
                    {
                        "label": "施甸",
                        "value": "施甸县"
                    },
                    {
                        "label": "保山",
                        "value": "保山市"
                    }
                ]
            },
            {
                "value": "临沧市",
                "label": "临沧",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "临翔",
                        "value": "临翔区"
                    },
                    {
                        "label": "云县",
                        "value": "云县"
                    },
                    {
                        "label": "凤庆",
                        "value": "凤庆县"
                    },
                    {
                        "label": "永德",
                        "value": "永德县"
                    },
                    {
                        "label": "耿马",
                        "value": "耿马傣族佤族自治县"
                    },
                    {
                        "label": "沧源",
                        "value": "沧源佤族自治县"
                    },
                    {
                        "label": "双江",
                        "value": "双江拉祜族佤族布朗族傣族自治县"
                    },
                    {
                        "label": "镇康",
                        "value": "镇康县"
                    }
                ]
            },
            {
                "value": "丽江市",
                "label": "丽江",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "古城",
                        "value": "古城区"
                    },
                    {
                        "label": "玉龙",
                        "value": "玉龙纳西族自治县"
                    },
                    {
                        "label": "永胜",
                        "value": "永胜县"
                    },
                    {
                        "label": "华坪",
                        "value": "华坪县"
                    },
                    {
                        "label": "宁蒗",
                        "value": "宁蒗彝族自治县"
                    }
                ]
            },
            {
                "value": "西双版纳傣族自治州",
                "label": "西双版纳",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "景洪",
                        "value": "景洪市"
                    },
                    {
                        "label": "勐海",
                        "value": "勐海县"
                    },
                    {
                        "label": "勐腊",
                        "value": "勐腊县"
                    },
                    {
                        "label": "西双版纳",
                        "value": "西双版纳傣族自治州"
                    }
                ]
            },
            {
                "value": "德宏傣族景颇族自治州",
                "label": "德宏",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "芒市",
                        "value": "芒市"
                    },
                    {
                        "label": "瑞丽",
                        "value": "瑞丽市"
                    },
                    {
                        "label": "盈江",
                        "value": "盈江县"
                    },
                    {
                        "label": "陇川",
                        "value": "陇川县"
                    },
                    {
                        "label": "梁河",
                        "value": "梁河县"
                    }
                ]
            },
            {
                "value": "迪庆藏族自治州",
                "label": "迪庆",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "香格里拉",
                        "value": "香格里拉市"
                    },
                    {
                        "label": "维西",
                        "value": "维西傈僳族自治县"
                    },
                    {
                        "label": "德钦",
                        "value": "德钦县"
                    }
                ]
            },
            {
                "value": "怒江傈僳族自治州",
                "label": "怒江",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "泸水",
                        "value": "泸水市"
                    },
                    {
                        "label": "兰坪",
                        "value": "兰坪白族普米族自治县"
                    },
                    {
                        "label": "贡山",
                        "value": "贡山独龙族怒族自治县"
                    },
                    {
                        "label": "福贡",
                        "value": "福贡县"
                    },
                    {
                        "label": "泸水",
                        "value": "泸水县"
                    }
                ]
            },
            {
                "value": "云南省",
                "label": "云南",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "云南",
                        "value": "云南省"
                    }
                ]
            }
        ]
    },
    {
        "value": "黑龙江省",
        "label": "黑龙江",
        "children": [
    {
        "label": "不限",
        "value": "不限"
    },
            {
                "value": "哈尔滨市",
                "label": "哈尔滨",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "南岗",
                        "value": "南岗区"
                    },
                    {
                        "label": "道里",
                        "value": "道里区"
                    },
                    {
                        "label": "香坊",
                        "value": "香坊区"
                    },
                    {
                        "label": "道外",
                        "value": "道外区"
                    },
                    {
                        "label": "五常",
                        "value": "五常市"
                    },
                    {
                        "label": "松北",
                        "value": "松北区"
                    },
                    {
                        "label": "呼兰",
                        "value": "呼兰区"
                    },
                    {
                        "label": "阿城",
                        "value": "阿城区"
                    },
                    {
                        "label": "双城",
                        "value": "双城区"
                    },
                    {
                        "label": "尚志",
                        "value": "尚志市"
                    },
                    {
                        "label": "依兰",
                        "value": "依兰县"
                    },
                    {
                        "label": "宾县",
                        "value": "宾县"
                    },
                    {
                        "label": "巴彦",
                        "value": "巴彦县"
                    },
                    {
                        "label": "平房",
                        "value": "平房区"
                    },
                    {
                        "label": "通河",
                        "value": "通河县"
                    },
                    {
                        "label": "延寿",
                        "value": "延寿县"
                    },
                    {
                        "label": "方正",
                        "value": "方正县"
                    },
                    {
                        "label": "木兰",
                        "value": "木兰县"
                    },
                    {
                        "label": "哈尔滨",
                        "value": "哈尔滨市"
                    }
                ]
            },
            {
                "value": "绥化市",
                "label": "绥化",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "北林",
                        "value": "北林区"
                    },
                    {
                        "label": "海伦",
                        "value": "海伦市"
                    },
                    {
                        "label": "肇东",
                        "value": "肇东市"
                    },
                    {
                        "label": "安达",
                        "value": "安达市"
                    },
                    {
                        "label": "兰西",
                        "value": "兰西县"
                    },
                    {
                        "label": "青冈",
                        "value": "青冈县"
                    },
                    {
                        "label": "庆安",
                        "value": "庆安县"
                    },
                    {
                        "label": "望奎",
                        "value": "望奎县"
                    },
                    {
                        "label": "明水",
                        "value": "明水县"
                    },
                    {
                        "label": "绥棱",
                        "value": "绥棱县"
                    },
                    {
                        "label": "绥化",
                        "value": "绥化市"
                    }
                ]
            },
            {
                "value": "齐齐哈尔市",
                "label": "齐齐哈尔",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "龙沙",
                        "value": "龙沙区"
                    },
                    {
                        "label": "讷河",
                        "value": "讷河市"
                    },
                    {
                        "label": "建华",
                        "value": "建华区"
                    },
                    {
                        "label": "泰来",
                        "value": "泰来县"
                    },
                    {
                        "label": "龙江",
                        "value": "龙江县"
                    },
                    {
                        "label": "铁锋",
                        "value": "铁锋区"
                    },
                    {
                        "label": "甘南",
                        "value": "甘南县"
                    },
                    {
                        "label": "克山",
                        "value": "克山县"
                    },
                    {
                        "label": "富裕",
                        "value": "富裕县"
                    },
                    {
                        "label": "拜泉",
                        "value": "拜泉县"
                    },
                    {
                        "label": "依安",
                        "value": "依安县"
                    },
                    {
                        "label": "克东",
                        "value": "克东县"
                    },
                    {
                        "label": "富拉尔基",
                        "value": "富拉尔基区"
                    },
                    {
                        "label": "梅里斯达斡尔族区",
                        "value": "梅里斯达斡尔族区"
                    },
                    {
                        "label": "昂昂溪",
                        "value": "昂昂溪区"
                    },
                    {
                        "label": "碾子山",
                        "value": "碾子山区"
                    }
                ]
            },
            {
                "value": "大庆市",
                "label": "大庆",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "龙凤",
                        "value": "龙凤区"
                    },
                    {
                        "label": "让胡路",
                        "value": "让胡路区"
                    },
                    {
                        "label": "萨尔图",
                        "value": "萨尔图区"
                    },
                    {
                        "label": "杜尔伯特",
                        "value": "杜尔伯特蒙古族自治县"
                    },
                    {
                        "label": "肇源",
                        "value": "肇源县"
                    },
                    {
                        "label": "肇州",
                        "value": "肇州县"
                    },
                    {
                        "label": "林甸",
                        "value": "林甸县"
                    },
                    {
                        "label": "大同",
                        "value": "大同区"
                    },
                    {
                        "label": "红岗",
                        "value": "红岗区"
                    },
                    {
                        "label": "大庆",
                        "value": "大庆市"
                    }
                ]
            },
            {
                "value": "佳木斯市",
                "label": "佳木斯",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "富锦",
                        "value": "富锦市"
                    },
                    {
                        "label": "郊区",
                        "value": "郊区"
                    },
                    {
                        "label": "桦南",
                        "value": "桦南县"
                    },
                    {
                        "label": "向阳",
                        "value": "向阳区"
                    },
                    {
                        "label": "前进",
                        "value": "前进区"
                    },
                    {
                        "label": "同江",
                        "value": "同江市"
                    },
                    {
                        "label": "桦川",
                        "value": "桦川县"
                    },
                    {
                        "label": "汤原",
                        "value": "汤原县"
                    },
                    {
                        "label": "东风",
                        "value": "东风区"
                    },
                    {
                        "label": "抚远",
                        "value": "抚远市"
                    },
                    {
                        "label": "抚远",
                        "value": "抚远县"
                    },
                    {
                        "label": "佳木斯",
                        "value": "佳木斯市"
                    }
                ]
            },
            {
                "value": "牡丹江市",
                "label": "牡丹江",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "西安",
                        "value": "西安区"
                    },
                    {
                        "label": "东安",
                        "value": "东安区"
                    },
                    {
                        "label": "宁安",
                        "value": "宁安市"
                    },
                    {
                        "label": "绥芬河",
                        "value": "绥芬河市"
                    },
                    {
                        "label": "海林",
                        "value": "海林市"
                    },
                    {
                        "label": "爱民",
                        "value": "爱民区"
                    },
                    {
                        "label": "林口",
                        "value": "林口县"
                    },
                    {
                        "label": "东宁",
                        "value": "东宁市"
                    },
                    {
                        "label": "穆棱",
                        "value": "穆棱市"
                    },
                    {
                        "label": "阳明",
                        "value": "阳明区"
                    },
                    {
                        "label": "牡丹江",
                        "value": "牡丹江市"
                    }
                ]
            },
            {
                "value": "黑河市",
                "label": "黑河",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "爱辉",
                        "value": "爱辉区"
                    },
                    {
                        "label": "嫩江",
                        "value": "嫩江县"
                    },
                    {
                        "label": "五大连池",
                        "value": "五大连池市"
                    },
                    {
                        "label": "北安",
                        "value": "北安市"
                    },
                    {
                        "label": "逊克",
                        "value": "逊克县"
                    },
                    {
                        "label": "孙吴",
                        "value": "孙吴县"
                    },
                    {
                        "label": "黑河",
                        "value": "黑河市"
                    }
                ]
            },
            {
                "value": "鸡西市",
                "label": "鸡西",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "鸡冠",
                        "value": "鸡冠区"
                    },
                    {
                        "label": "密山",
                        "value": "密山市"
                    },
                    {
                        "label": "虎林",
                        "value": "虎林市"
                    },
                    {
                        "label": "鸡东",
                        "value": "鸡东县"
                    },
                    {
                        "label": "恒山",
                        "value": "恒山区"
                    },
                    {
                        "label": "城子河",
                        "value": "城子河区"
                    },
                    {
                        "label": "滴道",
                        "value": "滴道区"
                    },
                    {
                        "label": "梨树",
                        "value": "梨树区"
                    },
                    {
                        "label": "麻山",
                        "value": "麻山区"
                    },
                    {
                        "label": "鸡西",
                        "value": "鸡西市"
                    }
                ]
            },
            {
                "value": "双鸭山市",
                "label": "双鸭山",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "宝清",
                        "value": "宝清县"
                    },
                    {
                        "label": "尖山",
                        "value": "尖山区"
                    },
                    {
                        "label": "集贤",
                        "value": "集贤县"
                    },
                    {
                        "label": "饶河",
                        "value": "饶河县"
                    },
                    {
                        "label": "友谊",
                        "value": "友谊县"
                    },
                    {
                        "label": "宝山",
                        "value": "宝山区"
                    },
                    {
                        "label": "岭东",
                        "value": "岭东区"
                    },
                    {
                        "label": "四方台",
                        "value": "四方台区"
                    }
                ]
            },
            {
                "value": "鹤岗市",
                "label": "鹤岗",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "萝北",
                        "value": "萝北县"
                    },
                    {
                        "label": "工农",
                        "value": "工农区"
                    },
                    {
                        "label": "绥滨",
                        "value": "绥滨县"
                    },
                    {
                        "label": "东山",
                        "value": "东山区"
                    },
                    {
                        "label": "南山",
                        "value": "南山区"
                    },
                    {
                        "label": "兴安",
                        "value": "兴安区"
                    },
                    {
                        "label": "向阳",
                        "value": "向阳区"
                    },
                    {
                        "label": "兴山",
                        "value": "兴山区"
                    },
                    {
                        "label": "鹤岗",
                        "value": "鹤岗市"
                    }
                ]
            },
            {
                "value": "伊春市",
                "label": "伊春",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "伊春",
                        "value": "伊春区"
                    },
                    {
                        "label": "铁力",
                        "value": "铁力市"
                    },
                    {
                        "label": "嘉荫",
                        "value": "嘉荫县"
                    },
                    {
                        "label": "南岔",
                        "value": "南岔区"
                    },
                    {
                        "label": "乌马河",
                        "value": "乌马河区"
                    },
                    {
                        "label": "翠峦",
                        "value": "翠峦区"
                    },
                    {
                        "label": "友好",
                        "value": "友好区"
                    },
                    {
                        "label": "西林",
                        "value": "西林区"
                    },
                    {
                        "label": "新青",
                        "value": "新青区"
                    },
                    {
                        "label": "带岭",
                        "value": "带岭区"
                    },
                    {
                        "label": "金山屯",
                        "value": "金山屯区"
                    },
                    {
                        "label": "五营",
                        "value": "五营区"
                    },
                    {
                        "label": "汤旺河",
                        "value": "汤旺河区"
                    },
                    {
                        "label": "美溪",
                        "value": "美溪区"
                    },
                    {
                        "label": "乌伊岭",
                        "value": "乌伊岭区"
                    },
                    {
                        "label": "上甘岭",
                        "value": "上甘岭区"
                    },
                    {
                        "label": "红星",
                        "value": "红星区"
                    },
                    {
                        "label": "伊春",
                        "value": "伊春市"
                    }
                ]
            },
            {
                "value": "七台河市",
                "label": "七台河",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "桃山",
                        "value": "桃山区"
                    },
                    {
                        "label": "勃利",
                        "value": "勃利县"
                    },
                    {
                        "label": "新兴",
                        "value": "新兴区"
                    },
                    {
                        "label": "茄子河",
                        "value": "茄子河区"
                    },
                    {
                        "label": "七台河",
                        "value": "七台河市"
                    }
                ]
            },
            {
                "value": "大兴安岭地区",
                "label": "大兴安岭地区",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "加格达奇",
                        "value": "加格达奇区"
                    },
                    {
                        "label": "呼玛",
                        "value": "呼玛县"
                    },
                    {
                        "label": "漠河",
                        "value": "漠河县"
                    },
                    {
                        "label": "塔河",
                        "value": "塔河县"
                    },
                    {
                        "label": "大兴安岭地区",
                        "value": "大兴安岭地区"
                    }
                ]
            },
            {
                "value": "黑龙江省",
                "label": "黑龙江",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "黑龙江",
                        "value": "黑龙江省"
                    }
                ]
            }
        ]
    },
    {
        "value": "吉林省",
        "label": "吉林",
        "children": [
    {
        "label": "不限",
        "value": "不限"
    },
            {
                "value": "长春市",
                "label": "长春",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "朝阳",
                        "value": "朝阳区"
                    },
                    {
                        "label": "南关",
                        "value": "南关区"
                    },
                    {
                        "label": "宽城",
                        "value": "宽城区"
                    },
                    {
                        "label": "绿园",
                        "value": "绿园区"
                    },
                    {
                        "label": "二道",
                        "value": "二道区"
                    },
                    {
                        "label": "九台",
                        "value": "九台区"
                    },
                    {
                        "label": "农安",
                        "value": "农安县"
                    },
                    {
                        "label": "德惠",
                        "value": "德惠市"
                    },
                    {
                        "label": "榆树",
                        "value": "榆树市"
                    },
                    {
                        "label": "双阳",
                        "value": "双阳区"
                    },
                    {
                        "label": "长春",
                        "value": "长春市"
                    }
                ]
            },
            {
                "value": "吉林市",
                "label": "吉林",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "昌邑",
                        "value": "昌邑区"
                    },
                    {
                        "label": "船营",
                        "value": "船营区"
                    },
                    {
                        "label": "丰满",
                        "value": "丰满区"
                    },
                    {
                        "label": "龙潭",
                        "value": "龙潭区"
                    },
                    {
                        "label": "舒兰",
                        "value": "舒兰市"
                    },
                    {
                        "label": "永吉",
                        "value": "永吉县"
                    },
                    {
                        "label": "桦甸",
                        "value": "桦甸市"
                    },
                    {
                        "label": "磐石",
                        "value": "磐石市"
                    },
                    {
                        "label": "蛟河",
                        "value": "蛟河市"
                    },
                    {
                        "label": "吉林",
                        "value": "吉林市"
                    }
                ]
            },
            {
                "value": "四平市",
                "label": "四平",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "公主岭",
                        "value": "公主岭市"
                    },
                    {
                        "label": "梨树",
                        "value": "梨树县"
                    },
                    {
                        "label": "铁东",
                        "value": "铁东区"
                    },
                    {
                        "label": "双辽",
                        "value": "双辽市"
                    },
                    {
                        "label": "铁西",
                        "value": "铁西区"
                    },
                    {
                        "label": "伊通",
                        "value": "伊通满族自治县"
                    },
                    {
                        "label": "四平",
                        "value": "四平市"
                    }
                ]
            },
            {
                "value": "延边朝鲜族自治州",
                "label": "延边",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "延吉",
                        "value": "延吉市"
                    },
                    {
                        "label": "敦化",
                        "value": "敦化市"
                    },
                    {
                        "label": "珲春",
                        "value": "珲春市"
                    },
                    {
                        "label": "汪清",
                        "value": "汪清县"
                    },
                    {
                        "label": "安图",
                        "value": "安图县"
                    },
                    {
                        "label": "和龙",
                        "value": "和龙市"
                    },
                    {
                        "label": "龙井",
                        "value": "龙井市"
                    },
                    {
                        "label": "图们",
                        "value": "图们市"
                    },
                    {
                        "label": "延边",
                        "value": "延边朝鲜族自治州"
                    }
                ]
            },
            {
                "value": "松原市",
                "label": "松原",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "宁江",
                        "value": "宁江区"
                    },
                    {
                        "label": "前郭尔罗斯",
                        "value": "前郭尔罗斯蒙古族自治县"
                    },
                    {
                        "label": "长岭",
                        "value": "长岭县"
                    },
                    {
                        "label": "扶余",
                        "value": "扶余市"
                    },
                    {
                        "label": "乾安",
                        "value": "乾安县"
                    },
                    {
                        "label": "松原",
                        "value": "松原市"
                    }
                ]
            },
            {
                "value": "通化市",
                "label": "通化",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "东昌",
                        "value": "东昌区"
                    },
                    {
                        "label": "梅河口",
                        "value": "梅河口市"
                    },
                    {
                        "label": "通化",
                        "value": "通化县"
                    },
                    {
                        "label": "柳河",
                        "value": "柳河县"
                    },
                    {
                        "label": "辉南",
                        "value": "辉南县"
                    },
                    {
                        "label": "集安",
                        "value": "集安市"
                    },
                    {
                        "label": "二道江",
                        "value": "二道江区"
                    },
                    {
                        "label": "通化",
                        "value": "通化市"
                    }
                ]
            },
            {
                "value": "白城市",
                "label": "白城",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "洮北",
                        "value": "洮北区"
                    },
                    {
                        "label": "洮南",
                        "value": "洮南市"
                    },
                    {
                        "label": "大安",
                        "value": "大安市"
                    },
                    {
                        "label": "通榆",
                        "value": "通榆县"
                    },
                    {
                        "label": "镇赉",
                        "value": "镇赉县"
                    },
                    {
                        "label": "白城",
                        "value": "白城市"
                    }
                ]
            },
            {
                "value": "白山市",
                "label": "白山",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "浑江",
                        "value": "浑江区"
                    },
                    {
                        "label": "抚松",
                        "value": "抚松县"
                    },
                    {
                        "label": "靖宇",
                        "value": "靖宇县"
                    },
                    {
                        "label": "临江",
                        "value": "临江市"
                    },
                    {
                        "label": "长白",
                        "value": "长白朝鲜族自治县"
                    },
                    {
                        "label": "江源",
                        "value": "江源区"
                    },
                    {
                        "label": "白山",
                        "value": "白山市"
                    }
                ]
            },
            {
                "value": "辽源市",
                "label": "辽源",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "龙山",
                        "value": "龙山区"
                    },
                    {
                        "label": "东丰",
                        "value": "东丰县"
                    },
                    {
                        "label": "东辽",
                        "value": "东辽县"
                    },
                    {
                        "label": "西安",
                        "value": "西安区"
                    },
                    {
                        "label": "辽源",
                        "value": "辽源市"
                    }
                ]
            },
            {
                "value": "吉林省",
                "label": "吉林",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "吉林",
                        "value": "吉林省"
                    }
                ]
            }
        ]
    },
    {
        "value": "海南省",
        "label": "海南",
        "children": [
    {
        "label": "不限",
        "value": "不限"
    },
            {
                "value": "海口市",
                "label": "海口",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "龙华",
                        "value": "龙华区"
                    },
                    {
                        "label": "美兰",
                        "value": "美兰区"
                    },
                    {
                        "label": "琼山",
                        "value": "琼山区"
                    },
                    {
                        "label": "秀英",
                        "value": "秀英区"
                    },
                    {
                        "label": "海口",
                        "value": "海口市"
                    }
                ]
            },
            {
                "value": "三亚市",
                "label": "三亚",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "吉阳",
                        "value": "吉阳区"
                    },
                    {
                        "label": "天涯",
                        "value": "天涯区"
                    },
                    {
                        "label": "崖州",
                        "value": "崖州区"
                    },
                    {
                        "label": "海棠",
                        "value": "海棠区"
                    },
                    {
                        "label": "三亚",
                        "value": "三亚市"
                    }
                ]
            },
            {
                "value": "儋州市",
                "label": "儋州",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "儋州",
                        "value": "儋州市"
                    }
                ]
            },
            {
                "value": "三沙市",
                "label": "三沙",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "三沙",
                        "value": "三沙市"
                    }
                ]
            },
            {
                "value": "省直辖县级行政区划",
                "label": "省直辖县级行政区划",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "澄迈",
                        "value": "澄迈县"
                    },
                    {
                        "label": "乐东",
                        "value": "乐东黎族自治县"
                    },
                    {
                        "label": "琼海",
                        "value": "琼海市"
                    },
                    {
                        "label": "万宁",
                        "value": "万宁市"
                    },
                    {
                        "label": "文昌",
                        "value": "文昌市"
                    },
                    {
                        "label": "陵水",
                        "value": "陵水黎族自治县"
                    },
                    {
                        "label": "东方",
                        "value": "东方市"
                    },
                    {
                        "label": "屯昌",
                        "value": "屯昌县"
                    },
                    {
                        "label": "定安",
                        "value": "定安县"
                    },
                    {
                        "label": "临高",
                        "value": "临高县"
                    },
                    {
                        "label": "保亭",
                        "value": "保亭黎族苗族自治县"
                    },
                    {
                        "label": "昌江",
                        "value": "昌江黎族自治县"
                    },
                    {
                        "label": "琼中",
                        "value": "琼中黎族苗族自治县"
                    },
                    {
                        "label": "五指山",
                        "value": "五指山市"
                    },
                    {
                        "label": "白沙",
                        "value": "白沙黎族自治县"
                    },
                    {
                        "label": "儋州",
                        "value": "儋州市"
                    }
                ]
            },
            {
                "value": "海南省",
                "label": "海南",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "海南",
                        "value": "海南省"
                    }
                ]
            }
        ]
    },
    {
        "value": "甘肃省",
        "label": "甘肃",
        "children": [
    {
        "label": "不限",
        "value": "不限"
    },
            {
                "value": "兰州市",
                "label": "兰州",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "城关",
                        "value": "城关区"
                    },
                    {
                        "label": "七里河",
                        "value": "七里河区"
                    },
                    {
                        "label": "永登",
                        "value": "永登县"
                    },
                    {
                        "label": "榆中",
                        "value": "榆中县"
                    },
                    {
                        "label": "安宁",
                        "value": "安宁区"
                    },
                    {
                        "label": "西固",
                        "value": "西固区"
                    },
                    {
                        "label": "皋兰",
                        "value": "皋兰县"
                    },
                    {
                        "label": "红古",
                        "value": "红古区"
                    },
                    {
                        "label": "兰州",
                        "value": "兰州市"
                    }
                ]
            },
            {
                "value": "庆阳市",
                "label": "庆阳",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "西峰",
                        "value": "西峰区"
                    },
                    {
                        "label": "环县",
                        "value": "环县"
                    },
                    {
                        "label": "庆城",
                        "value": "庆城县"
                    },
                    {
                        "label": "宁县",
                        "value": "宁县"
                    },
                    {
                        "label": "镇原",
                        "value": "镇原县"
                    },
                    {
                        "label": "华池",
                        "value": "华池县"
                    },
                    {
                        "label": "正宁",
                        "value": "正宁县"
                    },
                    {
                        "label": "合水",
                        "value": "合水县"
                    },
                    {
                        "label": "庆阳",
                        "value": "庆阳市"
                    }
                ]
            },
            {
                "value": "陇南市",
                "label": "陇南",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "武都",
                        "value": "武都区"
                    },
                    {
                        "label": "礼县",
                        "value": "礼县"
                    },
                    {
                        "label": "西和",
                        "value": "西和县"
                    },
                    {
                        "label": "宕昌",
                        "value": "宕昌县"
                    },
                    {
                        "label": "成县",
                        "value": "成县"
                    },
                    {
                        "label": "文县",
                        "value": "文县"
                    },
                    {
                        "label": "康县",
                        "value": "康县"
                    },
                    {
                        "label": "徽县",
                        "value": "徽县"
                    },
                    {
                        "label": "两当",
                        "value": "两当县"
                    },
                    {
                        "label": "陇南",
                        "value": "陇南市"
                    }
                ]
            },
            {
                "value": "张掖市",
                "label": "张掖",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "甘州",
                        "value": "甘州区"
                    },
                    {
                        "label": "山丹",
                        "value": "山丹县"
                    },
                    {
                        "label": "民乐",
                        "value": "民乐县"
                    },
                    {
                        "label": "临泽",
                        "value": "临泽县"
                    },
                    {
                        "label": "高台",
                        "value": "高台县"
                    },
                    {
                        "label": "肃南",
                        "value": "肃南裕固族自治县"
                    },
                    {
                        "label": "张掖",
                        "value": "张掖市"
                    }
                ]
            },
            {
                "value": "白银市",
                "label": "白银",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "白银",
                        "value": "白银区"
                    },
                    {
                        "label": "景泰",
                        "value": "景泰县"
                    },
                    {
                        "label": "靖远",
                        "value": "靖远县"
                    },
                    {
                        "label": "会宁",
                        "value": "会宁县"
                    },
                    {
                        "label": "平川",
                        "value": "平川区"
                    }
                ]
            },
            {
                "value": "天水市",
                "label": "天水",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "秦州",
                        "value": "秦州区"
                    },
                    {
                        "label": "麦积",
                        "value": "麦积区"
                    },
                    {
                        "label": "甘谷",
                        "value": "甘谷县"
                    },
                    {
                        "label": "秦安",
                        "value": "秦安县"
                    },
                    {
                        "label": "武山",
                        "value": "武山县"
                    },
                    {
                        "label": "清水",
                        "value": "清水县"
                    },
                    {
                        "label": "张家川",
                        "value": "张家川回族自治县"
                    },
                    {
                        "label": "天水",
                        "value": "天水市"
                    }
                ]
            },
            {
                "value": "定西市",
                "label": "定西",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "安定",
                        "value": "安定区"
                    },
                    {
                        "label": "陇西",
                        "value": "陇西县"
                    },
                    {
                        "label": "临洮",
                        "value": "临洮县"
                    },
                    {
                        "label": "岷县",
                        "value": "岷县"
                    },
                    {
                        "label": "通渭",
                        "value": "通渭县"
                    },
                    {
                        "label": "渭源",
                        "value": "渭源县"
                    },
                    {
                        "label": "漳县",
                        "value": "漳县"
                    },
                    {
                        "label": "定西",
                        "value": "定西市"
                    }
                ]
            },
            {
                "value": "武威市",
                "label": "武威",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "凉州",
                        "value": "凉州区"
                    },
                    {
                        "label": "民勤",
                        "value": "民勤县"
                    },
                    {
                        "label": "古浪",
                        "value": "古浪县"
                    },
                    {
                        "label": "天祝",
                        "value": "天祝藏族自治县"
                    }
                ]
            },
            {
                "value": "酒泉市",
                "label": "酒泉",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "肃州",
                        "value": "肃州区"
                    },
                    {
                        "label": "敦煌",
                        "value": "敦煌市"
                    },
                    {
                        "label": "玉门",
                        "value": "玉门市"
                    },
                    {
                        "label": "瓜州",
                        "value": "瓜州县"
                    },
                    {
                        "label": "金塔",
                        "value": "金塔县"
                    },
                    {
                        "label": "肃北",
                        "value": "肃北蒙古族自治县"
                    },
                    {
                        "label": "阿克塞",
                        "value": "阿克塞哈萨克族自治县"
                    },
                    {
                        "label": "酒泉",
                        "value": "酒泉市"
                    }
                ]
            },
            {
                "value": "平凉市",
                "label": "平凉",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "崆峒",
                        "value": "崆峒区"
                    },
                    {
                        "label": "静宁",
                        "value": "静宁县"
                    },
                    {
                        "label": "庄浪",
                        "value": "庄浪县"
                    },
                    {
                        "label": "泾川",
                        "value": "泾川县"
                    },
                    {
                        "label": "灵台",
                        "value": "灵台县"
                    },
                    {
                        "label": "华亭",
                        "value": "华亭县"
                    },
                    {
                        "label": "崇信",
                        "value": "崇信县"
                    },
                    {
                        "label": "平凉",
                        "value": "平凉市"
                    }
                ]
            },
            {
                "value": "临夏回族自治州",
                "label": "临夏",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "临夏",
                        "value": "临夏市"
                    },
                    {
                        "label": "永靖",
                        "value": "永靖县"
                    },
                    {
                        "label": "临夏",
                        "value": "临夏县"
                    },
                    {
                        "label": "康乐",
                        "value": "康乐县"
                    },
                    {
                        "label": "积石山",
                        "value": "积石山保安族东乡族撒拉族自治县"
                    },
                    {
                        "label": "广河",
                        "value": "广河县"
                    },
                    {
                        "label": "东乡族自治县",
                        "value": "东乡族自治县"
                    },
                    {
                        "label": "和政",
                        "value": "和政县"
                    }
                ]
            },
            {
                "value": "甘南藏族自治州",
                "label": "甘南",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "舟曲",
                        "value": "舟曲县"
                    },
                    {
                        "label": "合作",
                        "value": "合作市"
                    },
                    {
                        "label": "临潭",
                        "value": "临潭县"
                    },
                    {
                        "label": "卓尼",
                        "value": "卓尼县"
                    },
                    {
                        "label": "玛曲",
                        "value": "玛曲县"
                    },
                    {
                        "label": "迭部",
                        "value": "迭部县"
                    },
                    {
                        "label": "夏河",
                        "value": "夏河县"
                    },
                    {
                        "label": "碌曲",
                        "value": "碌曲县"
                    },
                    {
                        "label": "甘南",
                        "value": "甘南藏族自治州"
                    }
                ]
            },
            {
                "value": "金昌市",
                "label": "金昌",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "金川",
                        "value": "金川区"
                    },
                    {
                        "label": "永昌",
                        "value": "永昌县"
                    },
                    {
                        "label": "金昌",
                        "value": "金昌市"
                    }
                ]
            },
            {
                "value": "嘉峪关市",
                "label": "嘉峪关",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "嘉峪关",
                        "value": "嘉峪关市"
                    }
                ]
            },
            {
                "value": "甘肃省",
                "label": "甘肃",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "甘肃",
                        "value": "甘肃省"
                    }
                ]
            }
        ]
    },
    {
        "value": "青海省",
        "label": "青海",
        "children": [
    {
        "label": "不限",
        "value": "不限"
    },
            {
                "value": "西宁市",
                "label": "西宁",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "城西",
                        "value": "城西区"
                    },
                    {
                        "label": "城北",
                        "value": "城北区"
                    },
                    {
                        "label": "城东",
                        "value": "城东区"
                    },
                    {
                        "label": "城中",
                        "value": "城中区"
                    },
                    {
                        "label": "湟中",
                        "value": "湟中县"
                    },
                    {
                        "label": "大通",
                        "value": "大通回族土族自治县"
                    },
                    {
                        "label": "湟源",
                        "value": "湟源县"
                    },
                    {
                        "label": "西宁",
                        "value": "西宁市"
                    }
                ]
            },
            {
                "value": "海东市",
                "label": "海东",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "互助",
                        "value": "互助土族自治县"
                    },
                    {
                        "label": "乐都",
                        "value": "乐都区"
                    },
                    {
                        "label": "平安",
                        "value": "平安区"
                    },
                    {
                        "label": "民和",
                        "value": "民和回族土族自治县"
                    },
                    {
                        "label": "循化",
                        "value": "循化撒拉族自治县"
                    },
                    {
                        "label": "化隆",
                        "value": "化隆回族自治县"
                    },
                    {
                        "label": "海东",
                        "value": "海东市"
                    },
                    {
                        "label": "平安",
                        "value": "平安县"
                    }
                ]
            },
            {
                "value": "海西蒙古族藏族自治州",
                "label": "海西",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "格尔木",
                        "value": "格尔木市"
                    },
                    {
                        "label": "德令哈",
                        "value": "德令哈市"
                    },
                    {
                        "label": "都兰",
                        "value": "都兰县"
                    },
                    {
                        "label": "乌兰",
                        "value": "乌兰县"
                    },
                    {
                        "label": "天峻",
                        "value": "天峻县"
                    },
                    {
                        "label": "海西",
                        "value": "海西蒙古族藏族自治州"
                    }
                ]
            },
            {
                "value": "海南藏族自治州",
                "label": "海南",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "共和",
                        "value": "共和县"
                    },
                    {
                        "label": "贵德",
                        "value": "贵德县"
                    },
                    {
                        "label": "贵南",
                        "value": "贵南县"
                    },
                    {
                        "label": "同德",
                        "value": "同德县"
                    },
                    {
                        "label": "兴海",
                        "value": "兴海县"
                    },
                    {
                        "label": "海南",
                        "value": "海南藏族自治州"
                    }
                ]
            },
            {
                "value": "海北藏族自治州",
                "label": "海北",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "门源",
                        "value": "门源回族自治县"
                    },
                    {
                        "label": "海晏",
                        "value": "海晏县"
                    },
                    {
                        "label": "祁连",
                        "value": "祁连县"
                    },
                    {
                        "label": "刚察",
                        "value": "刚察县"
                    },
                    {
                        "label": "海北",
                        "value": "海北藏族自治州"
                    }
                ]
            },
            {
                "value": "玉树藏族自治州",
                "label": "玉树",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "玉树",
                        "value": "玉树市"
                    },
                    {
                        "label": "囊谦",
                        "value": "囊谦县"
                    },
                    {
                        "label": "曲麻莱",
                        "value": "曲麻莱县"
                    },
                    {
                        "label": "杂多",
                        "value": "杂多县"
                    },
                    {
                        "label": "称多",
                        "value": "称多县"
                    },
                    {
                        "label": "治多",
                        "value": "治多县"
                    }
                ]
            },
            {
                "value": "黄南藏族自治州",
                "label": "黄南",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "同仁",
                        "value": "同仁县"
                    },
                    {
                        "label": "尖扎",
                        "value": "尖扎县"
                    },
                    {
                        "label": "河南",
                        "value": "河南蒙古族自治县"
                    },
                    {
                        "label": "泽库",
                        "value": "泽库县"
                    }
                ]
            },
            {
                "value": "果洛藏族自治州",
                "label": "果洛",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "玛沁",
                        "value": "玛沁县"
                    },
                    {
                        "label": "甘德",
                        "value": "甘德县"
                    },
                    {
                        "label": "达日",
                        "value": "达日县"
                    },
                    {
                        "label": "班玛",
                        "value": "班玛县"
                    },
                    {
                        "label": "久治",
                        "value": "久治县"
                    },
                    {
                        "label": "玛多",
                        "value": "玛多县"
                    }
                ]
            },
            {
                "value": "青海省",
                "label": "青海",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "青海",
                        "value": "青海省"
                    }
                ]
            }
        ]
    },
    {
        "value": "内蒙古自治区",
        "label": "内蒙古",
        "children": [
    {
        "label": "不限",
        "value": "不限"
    },
            {
                "value": "呼和浩特市",
                "label": "呼和浩特",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "赛罕",
                        "value": "赛罕区"
                    },
                    {
                        "label": "新城",
                        "value": "新城区"
                    },
                    {
                        "label": "回民",
                        "value": "回民区"
                    },
                    {
                        "label": "玉泉",
                        "value": "玉泉区"
                    },
                    {
                        "label": "土默特左旗",
                        "value": "土默特左旗"
                    },
                    {
                        "label": "和林格尔",
                        "value": "和林格尔县"
                    },
                    {
                        "label": "武川",
                        "value": "武川县"
                    },
                    {
                        "label": "托克托",
                        "value": "托克托县"
                    },
                    {
                        "label": "清水河",
                        "value": "清水河县"
                    },
                    {
                        "label": "呼和浩特",
                        "value": "呼和浩特市"
                    }
                ]
            },
            {
                "value": "赤峰市",
                "label": "赤峰",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "松山",
                        "value": "松山区"
                    },
                    {
                        "label": "红山",
                        "value": "红山区"
                    },
                    {
                        "label": "宁城",
                        "value": "宁城县"
                    },
                    {
                        "label": "敖汉旗",
                        "value": "敖汉旗"
                    },
                    {
                        "label": "翁牛特旗",
                        "value": "翁牛特旗"
                    },
                    {
                        "label": "阿鲁科尔沁旗",
                        "value": "阿鲁科尔沁旗"
                    },
                    {
                        "label": "喀喇沁旗",
                        "value": "喀喇沁旗"
                    },
                    {
                        "label": "巴林右旗",
                        "value": "巴林右旗"
                    },
                    {
                        "label": "巴林左旗",
                        "value": "巴林左旗"
                    },
                    {
                        "label": "元宝山",
                        "value": "元宝山区"
                    },
                    {
                        "label": "林西",
                        "value": "林西县"
                    },
                    {
                        "label": "克什克腾旗",
                        "value": "克什克腾旗"
                    },
                    {
                        "label": "赤峰",
                        "value": "赤峰市"
                    }
                ]
            },
            {
                "value": "包头市",
                "label": "包头",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "昆都仑",
                        "value": "昆都仑区"
                    },
                    {
                        "label": "青山",
                        "value": "青山区"
                    },
                    {
                        "label": "东河",
                        "value": "东河区"
                    },
                    {
                        "label": "九原",
                        "value": "九原区"
                    },
                    {
                        "label": "土默特右旗",
                        "value": "土默特右旗"
                    },
                    {
                        "label": "固阳",
                        "value": "固阳县"
                    },
                    {
                        "label": "达尔罕茂明安联合旗",
                        "value": "达尔罕茂明安联合旗"
                    },
                    {
                        "label": "石拐",
                        "value": "石拐区"
                    },
                    {
                        "label": "白云鄂博矿区",
                        "value": "白云鄂博矿区"
                    },
                    {
                        "label": "包头",
                        "value": "包头市"
                    }
                ]
            },
            {
                "value": "鄂尔多斯市",
                "label": "鄂尔多斯",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "东胜",
                        "value": "东胜区"
                    },
                    {
                        "label": "准格尔旗",
                        "value": "准格尔旗"
                    },
                    {
                        "label": "伊金霍洛旗",
                        "value": "伊金霍洛旗"
                    },
                    {
                        "label": "达拉特旗",
                        "value": "达拉特旗"
                    },
                    {
                        "label": "乌审旗",
                        "value": "乌审旗"
                    },
                    {
                        "label": "鄂托克旗",
                        "value": "鄂托克旗"
                    },
                    {
                        "label": "杭锦旗",
                        "value": "杭锦旗"
                    },
                    {
                        "label": "鄂托克前旗",
                        "value": "鄂托克前旗"
                    },
                    {
                        "label": "康巴什",
                        "value": "康巴什区"
                    },
                    {
                        "label": "鄂尔多斯",
                        "value": "鄂尔多斯市"
                    }
                ]
            },
            {
                "value": "通辽市",
                "label": "通辽",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "科尔沁",
                        "value": "科尔沁区"
                    },
                    {
                        "label": "奈曼旗",
                        "value": "奈曼旗"
                    },
                    {
                        "label": "科尔沁左翼中旗",
                        "value": "科尔沁左翼中旗"
                    },
                    {
                        "label": "科尔沁左翼后旗",
                        "value": "科尔沁左翼后旗"
                    },
                    {
                        "label": "开鲁",
                        "value": "开鲁县"
                    },
                    {
                        "label": "扎鲁特旗",
                        "value": "扎鲁特旗"
                    },
                    {
                        "label": "霍林郭勒",
                        "value": "霍林郭勒市"
                    },
                    {
                        "label": "库伦旗",
                        "value": "库伦旗"
                    },
                    {
                        "label": "通辽",
                        "value": "通辽市"
                    }
                ]
            },
            {
                "value": "呼伦贝尔市",
                "label": "呼伦贝尔",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "海拉尔",
                        "value": "海拉尔区"
                    },
                    {
                        "label": "满洲里",
                        "value": "满洲里市"
                    },
                    {
                        "label": "莫力达瓦",
                        "value": "莫力达瓦达斡尔族自治旗"
                    },
                    {
                        "label": "扎兰屯",
                        "value": "扎兰屯市"
                    },
                    {
                        "label": "阿荣旗",
                        "value": "阿荣旗"
                    },
                    {
                        "label": "牙克石",
                        "value": "牙克石市"
                    },
                    {
                        "label": "鄂伦春",
                        "value": "鄂伦春自治旗"
                    },
                    {
                        "label": "鄂温克",
                        "value": "鄂温克族自治旗"
                    },
                    {
                        "label": "额尔古纳",
                        "value": "额尔古纳市"
                    },
                    {
                        "label": "陈巴尔虎旗",
                        "value": "陈巴尔虎旗"
                    },
                    {
                        "label": "新巴尔虎右旗",
                        "value": "新巴尔虎右旗"
                    },
                    {
                        "label": "新巴尔虎左旗",
                        "value": "新巴尔虎左旗"
                    },
                    {
                        "label": "根河",
                        "value": "根河市"
                    },
                    {
                        "label": "扎赉诺尔",
                        "value": "扎赉诺尔区"
                    },
                    {
                        "label": "呼伦贝尔",
                        "value": "呼伦贝尔市"
                    }
                ]
            },
            {
                "value": "乌兰察布市",
                "label": "乌兰察布",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "集宁",
                        "value": "集宁区"
                    },
                    {
                        "label": "四子王旗",
                        "value": "四子王旗"
                    },
                    {
                        "label": "兴和",
                        "value": "兴和县"
                    },
                    {
                        "label": "察哈尔右翼前旗",
                        "value": "察哈尔右翼前旗"
                    },
                    {
                        "label": "丰镇",
                        "value": "丰镇市"
                    },
                    {
                        "label": "察哈尔右翼后旗",
                        "value": "察哈尔右翼后旗"
                    },
                    {
                        "label": "商都",
                        "value": "商都县"
                    },
                    {
                        "label": "凉城",
                        "value": "凉城县"
                    },
                    {
                        "label": "察哈尔右翼中旗",
                        "value": "察哈尔右翼中旗"
                    },
                    {
                        "label": "化德",
                        "value": "化德县"
                    },
                    {
                        "label": "卓资",
                        "value": "卓资县"
                    },
                    {
                        "label": "乌兰察布",
                        "value": "乌兰察布市"
                    }
                ]
            },
            {
                "value": "锡林郭勒盟",
                "label": "锡林郭勒盟",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "锡林浩特",
                        "value": "锡林浩特市"
                    },
                    {
                        "label": "二连浩特",
                        "value": "二连浩特市"
                    },
                    {
                        "label": "多伦",
                        "value": "多伦县"
                    },
                    {
                        "label": "西乌珠穆沁旗",
                        "value": "西乌珠穆沁旗"
                    },
                    {
                        "label": "东乌珠穆沁旗",
                        "value": "东乌珠穆沁旗"
                    },
                    {
                        "label": "正蓝旗",
                        "value": "正蓝旗"
                    },
                    {
                        "label": "太仆寺旗",
                        "value": "太仆寺旗"
                    },
                    {
                        "label": "苏尼特右旗",
                        "value": "苏尼特右旗"
                    },
                    {
                        "label": "正镶白旗",
                        "value": "正镶白旗"
                    },
                    {
                        "label": "镶黄旗",
                        "value": "镶黄旗"
                    },
                    {
                        "label": "阿巴嘎旗",
                        "value": "阿巴嘎旗"
                    },
                    {
                        "label": "苏尼特左旗",
                        "value": "苏尼特左旗"
                    },
                    {
                        "label": "锡林郭勒盟",
                        "value": "锡林郭勒盟"
                    }
                ]
            },
            {
                "value": "巴彦淖尔市",
                "label": "巴彦淖尔",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "临河",
                        "value": "临河区"
                    },
                    {
                        "label": "乌拉特前旗",
                        "value": "乌拉特前旗"
                    },
                    {
                        "label": "五原",
                        "value": "五原县"
                    },
                    {
                        "label": "杭锦后旗",
                        "value": "杭锦后旗"
                    },
                    {
                        "label": "乌拉特中旗",
                        "value": "乌拉特中旗"
                    },
                    {
                        "label": "磴口",
                        "value": "磴口县"
                    },
                    {
                        "label": "乌拉特后旗",
                        "value": "乌拉特后旗"
                    },
                    {
                        "label": "巴彦淖尔",
                        "value": "巴彦淖尔市"
                    }
                ]
            },
            {
                "value": "兴安盟",
                "label": "兴安盟",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "乌兰浩特",
                        "value": "乌兰浩特市"
                    },
                    {
                        "label": "科尔沁右翼前旗",
                        "value": "科尔沁右翼前旗"
                    },
                    {
                        "label": "扎赉特旗",
                        "value": "扎赉特旗"
                    },
                    {
                        "label": "科尔沁右翼中旗",
                        "value": "科尔沁右翼中旗"
                    },
                    {
                        "label": "突泉",
                        "value": "突泉县"
                    },
                    {
                        "label": "阿尔山",
                        "value": "阿尔山市"
                    }
                ]
            },
            {
                "value": "乌海市",
                "label": "乌海",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "海勃湾",
                        "value": "海勃湾区"
                    },
                    {
                        "label": "海南",
                        "value": "海南区"
                    },
                    {
                        "label": "乌达",
                        "value": "乌达区"
                    }
                ]
            },
            {
                "value": "阿拉善盟",
                "label": "阿拉善盟",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "阿拉善左旗",
                        "value": "阿拉善左旗"
                    },
                    {
                        "label": "额济纳旗",
                        "value": "额济纳旗"
                    },
                    {
                        "label": "阿拉善右旗",
                        "value": "阿拉善右旗"
                    },
                    {
                        "label": "阿拉善盟",
                        "value": "阿拉善盟"
                    }
                ]
            },
            {
                "value": "内蒙古自治区",
                "label": "内蒙古",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "内蒙古",
                        "value": "内蒙古自治区"
                    }
                ]
            }
        ]
    },
    {
        "value": "广西壮族自治区",
        "label": "广西",
        "children": [
    {
        "label": "不限",
        "value": "不限"
    },
            {
                "value": "南宁市",
                "label": "南宁",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "青秀",
                        "value": "青秀区"
                    },
                    {
                        "label": "西乡塘",
                        "value": "西乡塘区"
                    },
                    {
                        "label": "江南",
                        "value": "江南区"
                    },
                    {
                        "label": "兴宁",
                        "value": "兴宁区"
                    },
                    {
                        "label": "良庆",
                        "value": "良庆区"
                    },
                    {
                        "label": "武鸣",
                        "value": "武鸣区"
                    },
                    {
                        "label": "宾阳",
                        "value": "宾阳县"
                    },
                    {
                        "label": "横县",
                        "value": "横县"
                    },
                    {
                        "label": "上林",
                        "value": "上林县"
                    },
                    {
                        "label": "邕宁",
                        "value": "邕宁区"
                    },
                    {
                        "label": "马山",
                        "value": "马山县"
                    },
                    {
                        "label": "隆安",
                        "value": "隆安县"
                    },
                    {
                        "label": "南宁",
                        "value": "南宁市"
                    }
                ]
            },
            {
                "value": "桂林市",
                "label": "桂林",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "七星",
                        "value": "七星区"
                    },
                    {
                        "label": "象山",
                        "value": "象山区"
                    },
                    {
                        "label": "临桂",
                        "value": "临桂区"
                    },
                    {
                        "label": "叠彩",
                        "value": "叠彩区"
                    },
                    {
                        "label": "秀峰",
                        "value": "秀峰区"
                    },
                    {
                        "label": "灵川",
                        "value": "灵川县"
                    },
                    {
                        "label": "兴安",
                        "value": "兴安县"
                    },
                    {
                        "label": "全州",
                        "value": "全州县"
                    },
                    {
                        "label": "荔浦",
                        "value": "荔浦县"
                    },
                    {
                        "label": "恭城",
                        "value": "恭城瑶族自治县"
                    },
                    {
                        "label": "永福",
                        "value": "永福县"
                    },
                    {
                        "label": "阳朔",
                        "value": "阳朔县"
                    },
                    {
                        "label": "平乐",
                        "value": "平乐县"
                    },
                    {
                        "label": "灌阳",
                        "value": "灌阳县"
                    },
                    {
                        "label": "龙胜",
                        "value": "龙胜各族自治县"
                    },
                    {
                        "label": "资源",
                        "value": "资源县"
                    },
                    {
                        "label": "雁山",
                        "value": "雁山区"
                    },
                    {
                        "label": "桂林",
                        "value": "桂林市"
                    }
                ]
            },
            {
                "value": "柳州市",
                "label": "柳州",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "柳南",
                        "value": "柳南区"
                    },
                    {
                        "label": "鱼峰",
                        "value": "鱼峰区"
                    },
                    {
                        "label": "城中",
                        "value": "城中区"
                    },
                    {
                        "label": "柳北",
                        "value": "柳北区"
                    },
                    {
                        "label": "柳江",
                        "value": "柳江区"
                    },
                    {
                        "label": "融水",
                        "value": "融水苗族自治县"
                    },
                    {
                        "label": "鹿寨",
                        "value": "鹿寨县"
                    },
                    {
                        "label": "柳城",
                        "value": "柳城县"
                    },
                    {
                        "label": "三江",
                        "value": "三江侗族自治县"
                    },
                    {
                        "label": "融安",
                        "value": "融安县"
                    },
                    {
                        "label": "柳江",
                        "value": "柳江县"
                    },
                    {
                        "label": "柳州",
                        "value": "柳州市"
                    }
                ]
            },
            {
                "value": "玉林市",
                "label": "玉林",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "玉州",
                        "value": "玉州区"
                    },
                    {
                        "label": "北流",
                        "value": "北流市"
                    },
                    {
                        "label": "博白",
                        "value": "博白县"
                    },
                    {
                        "label": "容县",
                        "value": "容县"
                    },
                    {
                        "label": "陆川",
                        "value": "陆川县"
                    },
                    {
                        "label": "兴业",
                        "value": "兴业县"
                    },
                    {
                        "label": "福绵",
                        "value": "福绵区"
                    },
                    {
                        "label": "玉林",
                        "value": "玉林市"
                    }
                ]
            },
            {
                "value": "百色市",
                "label": "百色",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "右江",
                        "value": "右江区"
                    },
                    {
                        "label": "平果",
                        "value": "平果县"
                    },
                    {
                        "label": "靖西",
                        "value": "靖西市"
                    },
                    {
                        "label": "田东",
                        "value": "田东县"
                    },
                    {
                        "label": "田阳",
                        "value": "田阳县"
                    },
                    {
                        "label": "德保",
                        "value": "德保县"
                    },
                    {
                        "label": "隆林",
                        "value": "隆林各族自治县"
                    },
                    {
                        "label": "田林",
                        "value": "田林县"
                    },
                    {
                        "label": "那坡",
                        "value": "那坡县"
                    },
                    {
                        "label": "西林",
                        "value": "西林县"
                    },
                    {
                        "label": "凌云",
                        "value": "凌云县"
                    },
                    {
                        "label": "乐业",
                        "value": "乐业县"
                    },
                    {
                        "label": "百色",
                        "value": "百色市"
                    }
                ]
            },
            {
                "value": "贵港市",
                "label": "贵港",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "港北",
                        "value": "港北区"
                    },
                    {
                        "label": "桂平",
                        "value": "桂平市"
                    },
                    {
                        "label": "平南",
                        "value": "平南县"
                    },
                    {
                        "label": "覃塘",
                        "value": "覃塘区"
                    },
                    {
                        "label": "港南",
                        "value": "港南区"
                    },
                    {
                        "label": "贵港",
                        "value": "贵港市"
                    }
                ]
            },
            {
                "value": "北海市",
                "label": "北海",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "海城",
                        "value": "海城区"
                    },
                    {
                        "label": "合浦",
                        "value": "合浦县"
                    },
                    {
                        "label": "银海",
                        "value": "银海区"
                    },
                    {
                        "label": "铁山港",
                        "value": "铁山港区"
                    },
                    {
                        "label": "北海",
                        "value": "北海市"
                    }
                ]
            },
            {
                "value": "梧州市",
                "label": "梧州",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "长洲",
                        "value": "长洲区"
                    },
                    {
                        "label": "万秀",
                        "value": "万秀区"
                    },
                    {
                        "label": "藤县",
                        "value": "藤县"
                    },
                    {
                        "label": "岑溪",
                        "value": "岑溪市"
                    },
                    {
                        "label": "龙圩",
                        "value": "龙圩区"
                    },
                    {
                        "label": "苍梧",
                        "value": "苍梧县"
                    },
                    {
                        "label": "蒙山",
                        "value": "蒙山县"
                    },
                    {
                        "label": "梧州",
                        "value": "梧州市"
                    }
                ]
            },
            {
                "value": "河池市",
                "label": "河池",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "金城江",
                        "value": "金城江区"
                    },
                    {
                        "label": "都安",
                        "value": "都安瑶族自治县"
                    },
                    {
                        "label": "巴马",
                        "value": "巴马瑶族自治县"
                    },
                    {
                        "label": "宜州",
                        "value": "宜州区"
                    },
                    {
                        "label": "南丹",
                        "value": "南丹县"
                    },
                    {
                        "label": "环江",
                        "value": "环江毛南族自治县"
                    },
                    {
                        "label": "大化",
                        "value": "大化瑶族自治县"
                    },
                    {
                        "label": "凤山",
                        "value": "凤山县"
                    },
                    {
                        "label": "宜州",
                        "value": "宜州市"
                    },
                    {
                        "label": "罗城",
                        "value": "罗城仫佬族自治县"
                    },
                    {
                        "label": "东兰",
                        "value": "东兰县"
                    },
                    {
                        "label": "天峨",
                        "value": "天峨县"
                    },
                    {
                        "label": "河池",
                        "value": "河池市"
                    }
                ]
            },
            {
                "value": "钦州市",
                "label": "钦州",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "钦南",
                        "value": "钦南区"
                    },
                    {
                        "label": "钦北",
                        "value": "钦北区"
                    },
                    {
                        "label": "灵山",
                        "value": "灵山县"
                    },
                    {
                        "label": "浦北",
                        "value": "浦北县"
                    },
                    {
                        "label": "钦州",
                        "value": "钦州市"
                    }
                ]
            },
            {
                "value": "来宾市",
                "label": "来宾",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "兴宾",
                        "value": "兴宾区"
                    },
                    {
                        "label": "武宣",
                        "value": "武宣县"
                    },
                    {
                        "label": "象州",
                        "value": "象州县"
                    },
                    {
                        "label": "忻城",
                        "value": "忻城县"
                    },
                    {
                        "label": "金秀",
                        "value": "金秀瑶族自治县"
                    },
                    {
                        "label": "合山",
                        "value": "合山市"
                    },
                    {
                        "label": "来宾",
                        "value": "来宾市"
                    }
                ]
            },
            {
                "value": "崇左市",
                "label": "崇左",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "江州",
                        "value": "江州区"
                    },
                    {
                        "label": "凭祥",
                        "value": "凭祥市"
                    },
                    {
                        "label": "扶绥",
                        "value": "扶绥县"
                    },
                    {
                        "label": "龙州",
                        "value": "龙州县"
                    },
                    {
                        "label": "大新",
                        "value": "大新县"
                    },
                    {
                        "label": "宁明",
                        "value": "宁明县"
                    },
                    {
                        "label": "天等",
                        "value": "天等县"
                    },
                    {
                        "label": "崇左",
                        "value": "崇左市"
                    }
                ]
            },
            {
                "value": "防城港市",
                "label": "防城港",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "港口",
                        "value": "港口区"
                    },
                    {
                        "label": "东兴",
                        "value": "东兴市"
                    },
                    {
                        "label": "防城",
                        "value": "防城区"
                    },
                    {
                        "label": "上思",
                        "value": "上思县"
                    }
                ]
            },
            {
                "value": "贺州市",
                "label": "贺州",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "八步",
                        "value": "八步区"
                    },
                    {
                        "label": "富川",
                        "value": "富川瑶族自治县"
                    },
                    {
                        "label": "平桂",
                        "value": "平桂区"
                    },
                    {
                        "label": "昭平",
                        "value": "昭平县"
                    },
                    {
                        "label": "钟山",
                        "value": "钟山县"
                    },
                    {
                        "label": "贺州",
                        "value": "贺州市"
                    }
                ]
            },
            {
                "value": "广西壮族自治区",
                "label": "广西",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "广西",
                        "value": "广西壮族自治区"
                    }
                ]
            }
        ]
    },
    {
        "value": "新疆维吾尔自治区",
        "label": "新疆",
        "children": [
    {
        "label": "不限",
        "value": "不限"
    },
            {
                "value": "乌鲁木齐市",
                "label": "乌鲁木齐",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "新市",
                        "value": "新市区"
                    },
                    {
                        "label": "沙依巴克",
                        "value": "沙依巴克区"
                    },
                    {
                        "label": "天山",
                        "value": "天山区"
                    },
                    {
                        "label": "水磨沟",
                        "value": "水磨沟区"
                    },
                    {
                        "label": "米东",
                        "value": "米东区"
                    },
                    {
                        "label": "头屯河",
                        "value": "头屯河区"
                    },
                    {
                        "label": "乌鲁木齐",
                        "value": "乌鲁木齐县"
                    },
                    {
                        "label": "达坂城",
                        "value": "达坂城区"
                    },
                    {
                        "label": "乌鲁木齐",
                        "value": "乌鲁木齐市"
                    }
                ]
            },
            {
                "value": "伊犁哈萨克自治州",
                "label": "伊犁",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "霍尔果斯",
                        "value": "霍尔果斯市"
                    },
                    {
                        "label": "伊宁",
                        "value": "伊宁市"
                    },
                    {
                        "label": "奎屯",
                        "value": "奎屯市"
                    },
                    {
                        "label": "霍城",
                        "value": "霍城县"
                    },
                    {
                        "label": "新源",
                        "value": "新源县"
                    },
                    {
                        "label": "察布查尔",
                        "value": "察布查尔锡伯自治县"
                    },
                    {
                        "label": "伊宁",
                        "value": "伊宁县"
                    },
                    {
                        "label": "巩留",
                        "value": "巩留县"
                    },
                    {
                        "label": "尼勒克",
                        "value": "尼勒克县"
                    },
                    {
                        "label": "昭苏",
                        "value": "昭苏县"
                    },
                    {
                        "label": "特克斯",
                        "value": "特克斯县"
                    },
                    {
                        "label": "伊犁",
                        "value": "伊犁哈萨克自治州"
                    }
                ]
            },
            {
                "value": "喀什地区",
                "label": "喀什",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "喀什",
                        "value": "喀什市"
                    },
                    {
                        "label": "莎车",
                        "value": "莎车县"
                    },
                    {
                        "label": "叶城",
                        "value": "叶城县"
                    },
                    {
                        "label": "疏勒",
                        "value": "疏勒县"
                    },
                    {
                        "label": "巴楚",
                        "value": "巴楚县"
                    },
                    {
                        "label": "伽师",
                        "value": "伽师县"
                    },
                    {
                        "label": "麦盖提",
                        "value": "麦盖提县"
                    },
                    {
                        "label": "英吉沙",
                        "value": "英吉沙县"
                    },
                    {
                        "label": "疏附",
                        "value": "疏附县"
                    },
                    {
                        "label": "岳普湖",
                        "value": "岳普湖县"
                    },
                    {
                        "label": "泽普",
                        "value": "泽普县"
                    },
                    {
                        "label": "塔什库尔干",
                        "value": "塔什库尔干塔吉克自治县"
                    },
                    {
                        "label": "喀什",
                        "value": "喀什地区"
                    }
                ]
            },
            {
                "value": "巴音郭楞蒙古自治州",
                "label": "巴音郭楞",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "库尔勒",
                        "value": "库尔勒市"
                    },
                    {
                        "label": "和静",
                        "value": "和静县"
                    },
                    {
                        "label": "轮台",
                        "value": "轮台县"
                    },
                    {
                        "label": "尉犁",
                        "value": "尉犁县"
                    },
                    {
                        "label": "焉耆",
                        "value": "焉耆回族自治县"
                    },
                    {
                        "label": "和硕",
                        "value": "和硕县"
                    },
                    {
                        "label": "若羌",
                        "value": "若羌县"
                    },
                    {
                        "label": "且末",
                        "value": "且末县"
                    },
                    {
                        "label": "博湖",
                        "value": "博湖县"
                    },
                    {
                        "label": "巴音郭楞",
                        "value": "巴音郭楞蒙古自治州"
                    }
                ]
            },
            {
                "value": "昌吉回族自治州",
                "label": "昌吉",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "昌吉",
                        "value": "昌吉市"
                    },
                    {
                        "label": "奇台",
                        "value": "奇台县"
                    },
                    {
                        "label": "呼图壁",
                        "value": "呼图壁县"
                    },
                    {
                        "label": "吉木萨尔",
                        "value": "吉木萨尔县"
                    },
                    {
                        "label": "阜康",
                        "value": "阜康市"
                    },
                    {
                        "label": "玛纳斯",
                        "value": "玛纳斯县"
                    },
                    {
                        "label": "木垒",
                        "value": "木垒哈萨克自治县"
                    },
                    {
                        "label": "昌吉",
                        "value": "昌吉回族自治州"
                    }
                ]
            },
            {
                "value": "阿克苏地区",
                "label": "阿克苏",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "阿克苏",
                        "value": "阿克苏市"
                    },
                    {
                        "label": "库车",
                        "value": "库车县"
                    },
                    {
                        "label": "温宿",
                        "value": "温宿县"
                    },
                    {
                        "label": "沙雅",
                        "value": "沙雅县"
                    },
                    {
                        "label": "拜城",
                        "value": "拜城县"
                    },
                    {
                        "label": "新和",
                        "value": "新和县"
                    },
                    {
                        "label": "阿瓦提",
                        "value": "阿瓦提县"
                    },
                    {
                        "label": "乌什",
                        "value": "乌什县"
                    },
                    {
                        "label": "柯坪",
                        "value": "柯坪县"
                    },
                    {
                        "label": "阿克苏",
                        "value": "阿克苏地区"
                    }
                ]
            },
            {
                "value": "自治区直辖县级行政区划",
                "label": "自治区直辖县级行政区划",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "石河子",
                        "value": "石河子市"
                    },
                    {
                        "label": "阿拉尔",
                        "value": "阿拉尔市"
                    },
                    {
                        "label": "五家渠",
                        "value": "五家渠市"
                    },
                    {
                        "label": "图木舒克",
                        "value": "图木舒克市"
                    },
                    {
                        "label": "北屯",
                        "value": "北屯市"
                    },
                    {
                        "label": "铁门关",
                        "value": "铁门关市"
                    },
                    {
                        "label": "双河",
                        "value": "双河市"
                    },
                    {
                        "label": "可克达拉",
                        "value": "可克达拉市"
                    },
                    {
                        "label": "不限",
                        "value": "不限"
                    }
                ]
            },
            {
                "value": "和田地区",
                "label": "和田",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "和田",
                        "value": "和田市"
                    },
                    {
                        "label": "墨玉",
                        "value": "墨玉县"
                    },
                    {
                        "label": "和田",
                        "value": "和田县"
                    },
                    {
                        "label": "洛浦",
                        "value": "洛浦县"
                    },
                    {
                        "label": "于田",
                        "value": "于田县"
                    },
                    {
                        "label": "皮山",
                        "value": "皮山县"
                    },
                    {
                        "label": "策勒",
                        "value": "策勒县"
                    },
                    {
                        "label": "民丰",
                        "value": "民丰县"
                    }
                ]
            },
            {
                "value": "塔城地区",
                "label": "塔城",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "乌苏",
                        "value": "乌苏市"
                    },
                    {
                        "label": "沙湾",
                        "value": "沙湾县"
                    },
                    {
                        "label": "塔城",
                        "value": "塔城市"
                    },
                    {
                        "label": "额敏",
                        "value": "额敏县"
                    },
                    {
                        "label": "和布克赛尔",
                        "value": "和布克赛尔蒙古自治县"
                    },
                    {
                        "label": "托里",
                        "value": "托里县"
                    },
                    {
                        "label": "裕民",
                        "value": "裕民县"
                    },
                    {
                        "label": "塔城",
                        "value": "塔城地区"
                    }
                ]
            },
            {
                "value": "吐鲁番市",
                "label": "吐鲁番",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "高昌",
                        "value": "高昌区"
                    },
                    {
                        "label": "鄯善",
                        "value": "鄯善县"
                    },
                    {
                        "label": "托克逊",
                        "value": "托克逊县"
                    },
                    {
                        "label": "吐鲁番",
                        "value": "吐鲁番市"
                    }
                ]
            },
            {
                "value": "克拉玛依市",
                "label": "克拉玛依",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "克拉玛依",
                        "value": "克拉玛依区"
                    },
                    {
                        "label": "独山子",
                        "value": "独山子区"
                    },
                    {
                        "label": "白碱滩",
                        "value": "白碱滩区"
                    },
                    {
                        "label": "乌尔禾",
                        "value": "乌尔禾区"
                    },
                    {
                        "label": "克拉玛依",
                        "value": "克拉玛依市"
                    }
                ]
            },
            {
                "value": "哈密市",
                "label": "哈密",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "伊州",
                        "value": "伊州区"
                    },
                    {
                        "label": "伊吾",
                        "value": "伊吾县"
                    },
                    {
                        "label": "巴里坤",
                        "value": "巴里坤哈萨克自治县"
                    },
                    {
                        "label": "哈密",
                        "value": "哈密市"
                    }
                ]
            },
            {
                "value": "博尔塔拉蒙古自治州",
                "label": "博尔塔拉",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "博乐",
                        "value": "博乐市"
                    },
                    {
                        "label": "精河",
                        "value": "精河县"
                    },
                    {
                        "label": "阿拉山口",
                        "value": "阿拉山口市"
                    },
                    {
                        "label": "温泉",
                        "value": "温泉县"
                    },
                    {
                        "label": "博尔塔拉",
                        "value": "博尔塔拉蒙古自治州"
                    }
                ]
            },
            {
                "value": "阿勒泰地区",
                "label": "阿勒泰",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "阿勒泰",
                        "value": "阿勒泰市"
                    },
                    {
                        "label": "富蕴",
                        "value": "富蕴县"
                    },
                    {
                        "label": "福海",
                        "value": "福海县"
                    },
                    {
                        "label": "布尔津",
                        "value": "布尔津县"
                    },
                    {
                        "label": "青河",
                        "value": "青河县"
                    },
                    {
                        "label": "哈巴河",
                        "value": "哈巴河县"
                    },
                    {
                        "label": "吉木乃",
                        "value": "吉木乃县"
                    }
                ]
            },
            {
                "value": "克孜勒苏柯尔克孜自治州",
                "label": "克孜勒苏",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "阿图什",
                        "value": "阿图什市"
                    },
                    {
                        "label": "阿克陶",
                        "value": "阿克陶县"
                    },
                    {
                        "label": "乌恰",
                        "value": "乌恰县"
                    },
                    {
                        "label": "阿合奇",
                        "value": "阿合奇县"
                    },
                    {
                        "label": "克孜勒苏",
                        "value": "克孜勒苏柯尔克孜自治州"
                    }
                ]
            },
            {
                "value": "哈密地区",
                "label": "哈密",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "哈密",
                        "value": "哈密市"
                    },
                    {
                        "label": "巴里坤",
                        "value": "巴里坤哈萨克自治县"
                    },
                    {
                        "label": "伊吾",
                        "value": "伊吾县"
                    }
                ]
            },
            {
                "value": "新疆维吾尔自治区",
                "label": "新疆",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "新疆",
                        "value": "新疆维吾尔自治区"
                    }
                ]
            }
        ]
    },
    {
        "value": "宁夏回族自治区",
        "label": "宁夏",
        "children": [
    {
        "label": "不限",
        "value": "不限"
    },
            {
                "value": "银川市",
                "label": "银川",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "兴庆",
                        "value": "兴庆区"
                    },
                    {
                        "label": "金凤",
                        "value": "金凤区"
                    },
                    {
                        "label": "西夏",
                        "value": "西夏区"
                    },
                    {
                        "label": "贺兰",
                        "value": "贺兰县"
                    },
                    {
                        "label": "灵武",
                        "value": "灵武市"
                    },
                    {
                        "label": "永宁",
                        "value": "永宁县"
                    },
                    {
                        "label": "银川",
                        "value": "银川市"
                    }
                ]
            },
            {
                "value": "吴忠市",
                "label": "吴忠",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "利通",
                        "value": "利通区"
                    },
                    {
                        "label": "青铜峡",
                        "value": "青铜峡市"
                    },
                    {
                        "label": "盐池",
                        "value": "盐池县"
                    },
                    {
                        "label": "同心",
                        "value": "同心县"
                    },
                    {
                        "label": "红寺堡",
                        "value": "红寺堡区"
                    },
                    {
                        "label": "吴忠",
                        "value": "吴忠市"
                    }
                ]
            },
            {
                "value": "固原市",
                "label": "固原",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "原州",
                        "value": "原州区"
                    },
                    {
                        "label": "西吉",
                        "value": "西吉县"
                    },
                    {
                        "label": "彭阳",
                        "value": "彭阳县"
                    },
                    {
                        "label": "隆德",
                        "value": "隆德县"
                    },
                    {
                        "label": "泾源",
                        "value": "泾源县"
                    },
                    {
                        "label": "固原",
                        "value": "固原市"
                    }
                ]
            },
            {
                "value": "中卫市",
                "label": "中卫",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "沙坡头",
                        "value": "沙坡头区"
                    },
                    {
                        "label": "中宁",
                        "value": "中宁县"
                    },
                    {
                        "label": "海原",
                        "value": "海原县"
                    },
                    {
                        "label": "中卫",
                        "value": "中卫市"
                    }
                ]
            },
            {
                "value": "石嘴山市",
                "label": "石嘴山",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "平罗",
                        "value": "平罗县"
                    },
                    {
                        "label": "大武口",
                        "value": "大武口区"
                    },
                    {
                        "label": "惠农",
                        "value": "惠农区"
                    },
                    {
                        "label": "石嘴山",
                        "value": "石嘴山市"
                    }
                ]
            },
            {
                "value": "宁夏回族自治区",
                "label": "宁夏",
                "children": [
    {
        "label": "不限",
        "value": "不限"
    },
                    {
                        "label": "宁夏回族自治区",
                        "value": "宁夏"
                    }
                ]
            }
        ]
    },
    {
        "value": "西藏自治区",
        "label": "西藏",
        "children": [
            {
                "label": "不限",
                "value": "不限"
            },
            {
                "value": "拉萨市",
                "label": "拉萨",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "城关",
                        "value": "城关区"
                    },
                    {
                        "label": "堆龙德庆",
                        "value": "堆龙德庆区"
                    },
                    {
                        "label": "达孜",
                        "value": "达孜县"
                    },
                    {
                        "label": "曲水",
                        "value": "曲水县"
                    },
                    {
                        "label": "达孜",
                        "value": "达孜区"
                    },
                    {
                        "label": "林周",
                        "value": "林周县"
                    },
                    {
                        "label": "墨竹工卡",
                        "value": "墨竹工卡县"
                    },
                    {
                        "label": "尼木",
                        "value": "尼木县"
                    },
                    {
                        "label": "当雄",
                        "value": "当雄县"
                    },
                    {
                        "label": "拉萨",
                        "value": "拉萨市"
                    },
                    {
                        "label": "堆龙德庆",
                        "value": "堆龙德庆县"
                    }
                ]
            },
            {
                "value": "日喀则市",
                "label": "日喀则",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "桑珠孜",
                        "value": "桑珠孜区"
                    },
                    {
                        "label": "白朗",
                        "value": "白朗县"
                    },
                    {
                        "label": "拉孜",
                        "value": "拉孜县"
                    },
                    {
                        "label": "萨迦",
                        "value": "萨迦县"
                    },
                    {
                        "label": "江孜",
                        "value": "江孜县"
                    },
                    {
                        "label": "昂仁",
                        "value": "昂仁县"
                    },
                    {
                        "label": "南木林",
                        "value": "南木林县"
                    },
                    {
                        "label": "谢通门",
                        "value": "谢通门县"
                    },
                    {
                        "label": "定日",
                        "value": "定日县"
                    },
                    {
                        "label": "仁布",
                        "value": "仁布县"
                    },
                    {
                        "label": "康马",
                        "value": "康马县"
                    },
                    {
                        "label": "定结",
                        "value": "定结县"
                    },
                    {
                        "label": "吉隆",
                        "value": "吉隆县"
                    },
                    {
                        "label": "聂拉木",
                        "value": "聂拉木县"
                    },
                    {
                        "label": "亚东",
                        "value": "亚东县"
                    },
                    {
                        "label": "仲巴",
                        "value": "仲巴县"
                    },
                    {
                        "label": "萨嘎",
                        "value": "萨嘎县"
                    },
                    {
                        "label": "岗巴",
                        "value": "岗巴县"
                    },
                    {
                        "label": "日喀则",
                        "value": "日喀则市"
                    }
                ]
            },
            {
                "value": "昌都市",
                "label": "昌都",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "卡若",
                        "value": "卡若区"
                    },
                    {
                        "label": "芒康",
                        "value": "芒康县"
                    },
                    {
                        "label": "类乌齐",
                        "value": "类乌齐县"
                    },
                    {
                        "label": "丁青",
                        "value": "丁青县"
                    },
                    {
                        "label": "江达",
                        "value": "江达县"
                    },
                    {
                        "label": "贡觉",
                        "value": "贡觉县"
                    },
                    {
                        "label": "左贡",
                        "value": "左贡县"
                    },
                    {
                        "label": "察雅",
                        "value": "察雅县"
                    },
                    {
                        "label": "八宿",
                        "value": "八宿县"
                    },
                    {
                        "label": "洛隆",
                        "value": "洛隆县"
                    },
                    {
                        "label": "边坝",
                        "value": "边坝县"
                    },
                    {
                        "label": "昌都",
                        "value": "昌都市"
                    }
                ]
            },
            {
                "value": "林芝市",
                "label": "林芝",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "巴宜",
                        "value": "巴宜区"
                    },
                    {
                        "label": "米林",
                        "value": "米林县"
                    },
                    {
                        "label": "波密",
                        "value": "波密县"
                    },
                    {
                        "label": "察隅",
                        "value": "察隅县"
                    },
                    {
                        "label": "工布江达",
                        "value": "工布江达县"
                    },
                    {
                        "label": "墨脱",
                        "value": "墨脱县"
                    },
                    {
                        "label": "朗县",
                        "value": "朗县"
                    }
                ]
            },
            {
                "value": "山南市",
                "label": "山南",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "乃东",
                        "value": "乃东区"
                    },
                    {
                        "label": "贡嘎",
                        "value": "贡嘎县"
                    },
                    {
                        "label": "扎囊",
                        "value": "扎囊县"
                    },
                    {
                        "label": "加查",
                        "value": "加查县"
                    },
                    {
                        "label": "隆子",
                        "value": "隆子县"
                    },
                    {
                        "label": "浪卡子",
                        "value": "浪卡子县"
                    },
                    {
                        "label": "桑日",
                        "value": "桑日县"
                    },
                    {
                        "label": "措美",
                        "value": "措美县"
                    },
                    {
                        "label": "洛扎",
                        "value": "洛扎县"
                    },
                    {
                        "label": "琼结",
                        "value": "琼结县"
                    },
                    {
                        "label": "错那",
                        "value": "错那县"
                    },
                    {
                        "label": "曲松",
                        "value": "曲松县"
                    },
                    {
                        "label": "山南",
                        "value": "山南市"
                    }
                ]
            },
            {
                "value": "那曲市",
                "label": "那曲",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "那曲",
                        "value": "那曲市"
                    }
                ]
            },
            {
                "value": "那曲地区",
                "label": "那曲",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "那曲",
                        "value": "那曲县"
                    },
                    {
                        "label": "嘉黎",
                        "value": "嘉黎县"
                    },
                    {
                        "label": "聂荣",
                        "value": "聂荣县"
                    },
                    {
                        "label": "巴青",
                        "value": "巴青县"
                    },
                    {
                        "label": "索县",
                        "value": "索县"
                    },
                    {
                        "label": "比如",
                        "value": "比如县"
                    },
                    {
                        "label": "安多",
                        "value": "安多县"
                    },
                    {
                        "label": "班戈",
                        "value": "班戈县"
                    },
                    {
                        "label": "尼玛",
                        "value": "尼玛县"
                    },
                    {
                        "label": "双湖",
                        "value": "双湖县"
                    },
                    {
                        "label": "申扎",
                        "value": "申扎县"
                    },
                    {
                        "label": "那曲",
                        "value": "那曲地区"
                    }
                ]
            },
            {
                "value": "阿里地区",
                "label": "阿里",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "噶尔",
                        "value": "噶尔县"
                    },
                    {
                        "label": "普兰",
                        "value": "普兰县"
                    },
                    {
                        "label": "改则",
                        "value": "改则县"
                    },
                    {
                        "label": "措勤",
                        "value": "措勤县"
                    },
                    {
                        "label": "日土",
                        "value": "日土县"
                    },
                    {
                        "label": "札达",
                        "value": "札达县"
                    },
                    {
                        "label": "革吉",
                        "value": "革吉县"
                    },
                    {
                        "label": "阿里",
                        "value": "阿里地区"
                    }
                ]
            },
            {
                "value": "山南地区",
                "label": "山南",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "乃东",
                        "value": "乃东县"
                    },
                    {
                        "label": "贡嘎",
                        "value": "贡嘎县"
                    },
                    {
                        "label": "措美",
                        "value": "措美县"
                    }
                ]
            },
            {
                "value": "林芝地区",
                "label": "林芝",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "林芝",
                        "value": "林芝县"
                    }
                ]
            },
            {
                "value": "日喀则地区",
                "label": "日喀则",
                "children": [
                {
                    "label": "不限",
                    "value": "不限"
                }
                ]
            }, 
            {
                "value": "西藏自治区",
                "label": "西藏",
                "children": [
                    {
                        "label": "不限",
                        "value": "不限"
                    },
                    {
                        "label": "西藏",
                        "value": "西藏自治区"
                    }
                ]
            },
        ]
    }, 
    {
        "value": "港澳台",
        "label": "港澳台",
        "children": [
            {
                "label": "不限",
                "value": "不限"
            },
            {
                "value": "香港",
                "label": "香港"
            }, 
            {
                "value": "澳门",
                "label": "澳门"
            }, 
            {
                "value": "台湾",
                "label": "台湾"
            }
        ]
    }
];
exports.data = province;
